module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module container_lg",
    attrs: {
      "id": "module_2"
    }
  }, [_c('div', {
    staticClass: "scene"
  }, [_c('svg', {
    staticStyle: {
      "background": "#FACE86"
    },
    attrs: {
      "id": "town",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 6560 572"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "ad_clip"
    }
  }, [_c('rect', {
    attrs: {
      "width": "122",
      "height": "161",
      "x": "4112",
      "y": "266"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "path-1",
      "d": "M4170 229c22-23.18 33-40.85 33-53 0-18.23-14.77-33-33-33s-33 14.77-33 33c0 12.15 11 29.82 33 53z"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter-2",
      "width": "148.5%",
      "height": "137.2%",
      "x": "-24.2%",
      "y": "-16.3%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feOffset', {
    attrs: {
      "dy": "2",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
      "in": "shadowBlurOuter1"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "id": "path-3",
      "d": "M4425 229c22-23.18 33-40.85 33-53 0-18.23-14.77-33-33-33s-33 14.77-33 33c0 12.15 11 29.82 33 53z"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter-4",
      "width": "148.5%",
      "height": "137.2%",
      "x": "-24.2%",
      "y": "-16.3%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feOffset', {
    attrs: {
      "dy": "2",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
      "in": "shadowBlurOuter1"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "id": "path-5",
      "d": "M3807 229c22-23.18 33-40.85 33-53 0-18.23-14.77-33-33-33s-33 14.77-33 33c0 12.15 11 29.82 33 53z"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter-6",
      "width": "148.5%",
      "height": "137.2%",
      "x": "-24.2%",
      "y": "-16.3%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feOffset', {
    attrs: {
      "dy": "2",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
      "in": "shadowBlurOuter1"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "id": "path-7",
      "d": "M3403 299c22-23.18 33-40.85 33-53 0-18.23-14.77-33-33-33s-33 14.77-33 33c0 12.15 11 29.82 33 53z"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter-8",
      "width": "148.5%",
      "height": "137.2%",
      "x": "-24.2%",
      "y": "-16.3%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feOffset', {
    attrs: {
      "dy": "2",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
      "in": "shadowBlurOuter1"
    }
  })], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "id": "hill_4",
      "fill": "#FBD79E",
      "d": "M5147.88 286c-253.34 0-472.8 149.3-943.88 162.94V470h1782c-389.85-122.67-669.22-184-838.12-184z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hill_3",
      "fill": "#F1C47A",
      "d": "M3686 470h961v-21.62c-204.56-23.7-602.1-97.95-961-137.38v159z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hill_2",
      "fill": "#FBD79E",
      "d": "M1733.15 213c-363.78 0-471.08 188.12-942.15 201.77V470h1782c-317.38-171.33-597.33-257-839.85-257z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hill_1",
      "fill": "#F1C47A",
      "d": "M3274.83 286.4C2867.27 293 2253.2 449.68 1913.66 449.42 1569.94 449.15 867.78 166.98 491 154v316h2784c0-116.23-.06-177.43-.17-183.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fence_2",
      "fill": "#E2B56C",
      "d": "M1291 282.2l8.6-11.4c.68-.9 1.93-1.06 2.8-.4.17.12.3.25.4.4l8.5 11.4v44.54h5.06V282.2l8.1-11.36c.63-.9 1.88-1.1 2.78-.47.15.1.3.24.4.4l9 11.42v44.54h5.07V282.2l8.5-11.4c.67-.88 1.93-1.06 2.8-.4.16.1.3.25.4.4l8.6 11.4V450h-20.3v-41.4h-5.06V450h-20.28v-41.4h-5.07V450H1291V282.2zm45.6 71.4v27.96h5.07V353.6h-5.07zm-25.36 0v27.96h5.07V353.6h-5.06z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fence_1",
      "fill": "#E2B56C",
      "d": "M491 282.2l8.9-11.43c.67-.87 1.92-1.03 2.8-.35.14.12.27.25.4.4l8.24 11.38v44.54h5.08V282.2l8.14-11.36c.64-.9 1.9-1.1 2.8-.47.14.1.28.25.4.4l9 11.43v44.54h5.1V282.2l8.47-11.4c.65-.88 1.9-1.06 2.8-.4.14.1.28.24.4.4l8.66 11.4v44.54h5.07V282.2l8.38-11.4c.65-.87 1.9-1.07 2.8-.4.15.1.28.23.4.38l8.76 11.42v44.54h5.1V282.2l8.38-11.4c.65-.87 1.9-1.07 2.8-.4.14.1.28.23.4.38l8.75 11.42v44.54h5.1V282.2l8.44-11.4c.65-.88 1.9-1.06 2.8-.4.15.1.28.24.4.4l8.7 11.4v44.54h5.07V282.2l8.45-11.4c.65-.88 1.9-1.06 2.8-.4.14.1.28.24.4.4l8.68 11.4v44.54h5.1V282.2l8.9-11.43c.67-.87 1.93-1.03 2.8-.35.15.12.28.26.4.4l8.23 11.38v44.54h5.1V282.2l8.68-11.4c.67-.9 1.92-1.06 2.8-.4.15.12.28.26.4.4l8.45 11.4v44.54h5.08V282.2l8.65-11.4c.67-.9 1.93-1.06 2.8-.4.16.12.3.25.4.4l8.5 11.4v44.54h5.1V282.2l8.1-11.36c.65-.9 1.9-1.1 2.8-.47.15.1.3.24.4.4l9.03 11.43v44.54h5.08V282.2l8.53-11.4c.65-.88 1.9-1.06 2.8-.4.14.1.27.24.4.4l8.6 11.4V450h-20.34v-41.4h-5.08V450h-20.34v-41.4h-5.1V450h-20.33v-41.4h-5.07V450H694.4v-41.4h-5.1V450h-20.33v-41.4h-5.1V450h-20.33v-41.4h-5.08V450h-20.34v-41.4h-5.1V450H592.7v-41.4h-5.1V450h-20.68v-41.4h-5.1V450H541.5v-41.4h-4.74V450h-20.34v-41.4h-5.08V450H491V282.2zm274.53 71.4v27.96h5.08V353.6h-5.07zm-25.43 0v27.96h5.1V353.6h-5.1zm-25.42 0v27.96h5.1V353.6h-5.1zm-25.42 0v27.96h5.08V353.6h-5.08zm-25.43 0v27.96h5.1V353.6h-5.1zm-25.42 0v27.96h5.1V353.6h-5.1zm-25.4 0v27.96h5.07V353.6H613zm-25.44 0v27.96h5.1V353.6h-5.1zm-25.42 0v27.96h5.08V353.6h-5.08zm-25.42 0v27.96h5.08V353.6h-5.08zm-25.43 0v27.96h5.08V353.6h-5.1z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "sidewalk",
      "width": "6563",
      "height": "20",
      "x": "-2",
      "y": "449",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_197",
      "width": "1757",
      "height": "256",
      "x": "4907",
      "y": "193",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_196",
      "width": "240",
      "height": "127",
      "x": "5539",
      "y": "242",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_195",
      "width": "101",
      "height": "101",
      "x": "5666",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_194",
      "width": "101",
      "height": "101",
      "x": "5551",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_193",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5744.36 254.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_192",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5756.37 254.63L5689 340",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_191",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5639.36 299.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_190",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5652.37 268.63L5585 354",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_189",
      "width": "240",
      "height": "127",
      "x": "5805",
      "y": "242",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_188",
      "width": "101",
      "height": "101",
      "x": "5931",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_187",
      "width": "101",
      "height": "101",
      "x": "5817",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_186",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6010.36 254.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_185",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6022.37 254.63L5955 340",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_184",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5904.36 299.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_183",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5917.37 268.63L5850 354",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_182",
      "width": "240",
      "height": "127",
      "x": "6108",
      "y": "242",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_181",
      "width": "101",
      "height": "101",
      "x": "6234",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_180",
      "width": "101",
      "height": "101",
      "x": "6120",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_179",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6313.36 254.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_178",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6325.37 254.63L6258 340",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_177",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6207.36 299.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_176",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6221.37 268.63L6154 354",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_175",
      "width": "240",
      "height": "127",
      "x": "6373",
      "y": "242",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_174",
      "width": "101",
      "height": "101",
      "x": "6500",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_173",
      "width": "101",
      "height": "101",
      "x": "6386",
      "y": "254",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_172",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6579.36 254.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_171",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6591.37 254.63L6524 340",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_170",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6473.36 299.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_169",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6486.37 268.63L6419 354",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_168",
      "width": "38",
      "height": "19",
      "x": "5476",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_167",
      "width": "38",
      "height": "19",
      "x": "5514",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_166",
      "width": "38",
      "height": "19",
      "x": "5476",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_165",
      "width": "38",
      "height": "19",
      "x": "5514",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_164",
      "width": "38",
      "height": "19",
      "x": "5501",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_163",
      "width": "38",
      "height": "19",
      "x": "5551",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_162",
      "width": "38",
      "height": "19",
      "x": "5551",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_161",
      "width": "38",
      "height": "19",
      "x": "5539",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_160",
      "width": "38",
      "height": "19",
      "x": "5590",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_159",
      "width": "38",
      "height": "19",
      "x": "5590",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_158",
      "width": "38",
      "height": "19",
      "x": "5577",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_157",
      "width": "38",
      "height": "19",
      "x": "5627",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_156",
      "width": "38",
      "height": "19",
      "x": "5627",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_155",
      "width": "38",
      "height": "19",
      "x": "5615",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_154",
      "width": "25",
      "height": "19",
      "x": "5476",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_153",
      "width": "38",
      "height": "19",
      "x": "5666",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_152",
      "width": "38",
      "height": "19",
      "x": "5703",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_151",
      "width": "38",
      "height": "19",
      "x": "5666",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_150",
      "width": "38",
      "height": "19",
      "x": "5703",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_149",
      "width": "38",
      "height": "19",
      "x": "5691",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_148",
      "width": "38",
      "height": "19",
      "x": "5741",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_147",
      "width": "38",
      "height": "19",
      "x": "5741",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_146",
      "width": "38",
      "height": "19",
      "x": "5729",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_145",
      "width": "38",
      "height": "19",
      "x": "5779",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_144",
      "width": "38",
      "height": "19",
      "x": "5779",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_143",
      "width": "38",
      "height": "19",
      "x": "5766",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_142",
      "width": "38",
      "height": "19",
      "x": "5817",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_141",
      "width": "38",
      "height": "19",
      "x": "5817",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_140",
      "width": "38",
      "height": "19",
      "x": "5805",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_139",
      "width": "38",
      "height": "19",
      "x": "5653",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_138",
      "width": "38",
      "height": "19",
      "x": "5855",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_137",
      "width": "38",
      "height": "19",
      "x": "5855",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_136",
      "width": "38",
      "height": "19",
      "x": "5842",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_135",
      "width": "38",
      "height": "19",
      "x": "5893",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_134",
      "width": "38",
      "height": "19",
      "x": "5931",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_133",
      "width": "38",
      "height": "19",
      "x": "5893",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_132",
      "width": "38",
      "height": "19",
      "x": "5931",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_131",
      "width": "38",
      "height": "19",
      "x": "5918",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_130",
      "width": "38",
      "height": "19",
      "x": "5969",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_129",
      "width": "38",
      "height": "19",
      "x": "5969",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_128",
      "width": "38",
      "height": "19",
      "x": "5956",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_127",
      "width": "38",
      "height": "19",
      "x": "6007",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_126",
      "width": "38",
      "height": "19",
      "x": "6007",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_125",
      "width": "38",
      "height": "19",
      "x": "5994",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_124",
      "width": "38",
      "height": "19",
      "x": "6044",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_123",
      "width": "38",
      "height": "19",
      "x": "6044",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_122",
      "width": "38",
      "height": "19",
      "x": "6032",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_121",
      "width": "38",
      "height": "19",
      "x": "5880",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_120",
      "width": "38",
      "height": "19",
      "x": "6083",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_119",
      "width": "38",
      "height": "19",
      "x": "6083",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_118",
      "width": "38",
      "height": "19",
      "x": "6070",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_117",
      "width": "38",
      "height": "19",
      "x": "6120",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_116",
      "width": "38",
      "height": "19",
      "x": "6159",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_115",
      "width": "38",
      "height": "19",
      "x": "6120",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_114",
      "width": "38",
      "height": "19",
      "x": "6159",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_113",
      "width": "38",
      "height": "19",
      "x": "6146",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_112",
      "width": "38",
      "height": "19",
      "x": "6196",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_111",
      "width": "38",
      "height": "19",
      "x": "6196",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_110",
      "width": "38",
      "height": "19",
      "x": "6184",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_109",
      "width": "38",
      "height": "19",
      "x": "6234",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_108",
      "width": "38",
      "height": "19",
      "x": "6234",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_107",
      "width": "38",
      "height": "19",
      "x": "6222",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_106",
      "width": "38",
      "height": "19",
      "x": "6272",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_105",
      "width": "38",
      "height": "19",
      "x": "6272",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_104",
      "width": "38",
      "height": "19",
      "x": "6259",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_103",
      "width": "38",
      "height": "19",
      "x": "6108",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_102",
      "width": "38",
      "height": "19",
      "x": "6311",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_101",
      "width": "38",
      "height": "19",
      "x": "6311",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_100",
      "width": "38",
      "height": "19",
      "x": "6299",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_99",
      "width": "38",
      "height": "19",
      "x": "6350",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_98",
      "width": "38",
      "height": "19",
      "x": "6387",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_97",
      "width": "38",
      "height": "19",
      "x": "6350",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_96",
      "width": "38",
      "height": "19",
      "x": "6387",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_95",
      "width": "38",
      "height": "19",
      "x": "6375",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_94",
      "width": "38",
      "height": "19",
      "x": "6425",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_93",
      "width": "38",
      "height": "19",
      "x": "6425",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_92",
      "width": "38",
      "height": "19",
      "x": "6412",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_91",
      "width": "38",
      "height": "19",
      "x": "6463",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_90",
      "width": "38",
      "height": "19",
      "x": "6463",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_89",
      "width": "38",
      "height": "19",
      "x": "6450",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_88",
      "width": "38",
      "height": "19",
      "x": "6501",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_87",
      "width": "38",
      "height": "19",
      "x": "6501",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_86",
      "width": "38",
      "height": "19",
      "x": "6489",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_85",
      "width": "22",
      "height": "19",
      "x": "6539",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_84",
      "width": "22",
      "height": "19",
      "x": "6539",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_83",
      "width": "36",
      "height": "19",
      "x": "6526",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_82",
      "width": "38",
      "height": "19",
      "x": "6336",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_81",
      "width": "38",
      "height": "19",
      "x": "4907",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_80",
      "width": "38",
      "height": "19",
      "x": "4907",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_79",
      "width": "25",
      "height": "19",
      "x": "4907",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_78",
      "width": "38",
      "height": "19",
      "x": "4945",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_77",
      "width": "38",
      "height": "19",
      "x": "4945",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_76",
      "width": "38",
      "height": "19",
      "x": "4932",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_75",
      "width": "38",
      "height": "19",
      "x": "5034",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_74",
      "width": "38",
      "height": "19",
      "x": "5034",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_73",
      "width": "25",
      "height": "19",
      "x": "5034",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_72",
      "width": "25",
      "height": "19",
      "x": "5071",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_71",
      "width": "25",
      "height": "19",
      "x": "5071",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_70",
      "width": "38",
      "height": "19",
      "x": "5059",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_69",
      "width": "25",
      "height": "19",
      "x": "5349",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_68",
      "width": "38",
      "height": "19",
      "x": "5349",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_67",
      "width": "38",
      "height": "19",
      "x": "5349",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_66",
      "width": "38",
      "height": "19",
      "x": "5375",
      "y": "411",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_65",
      "width": "25",
      "height": "19",
      "x": "5387",
      "y": "392",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_64",
      "width": "25",
      "height": "19",
      "x": "5387",
      "y": "430",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_63",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5350 242 5350 449 5097 449 5097 242"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_62",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5351 242 5351 449 5224 449 5224 242"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_61",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5224 242 5224 449 5097 449 5097 242"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_60",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5351 411 5351 449 5224 449 5224 411"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_59",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5224 411 5224 449 5097 449 5097 411"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_58",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5196 254 5196 393 5109 393 5109 254"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_57",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5188 255l-78 96",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_56",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5164 255l-54 68",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_55",
      "fill": "#FFF",
      "d": "M5213.33 306.05c2.03.02 3.67 1.7 3.67 3.8v80.7c0 1.36-1.07 2.45-2.38 2.45-1.32 0-2.4-1.1-2.4-2.44v-79.44h-8.7c-1.4 0-2.52-1.15-2.52-2.57 0-1.4 1.1-2.55 2.5-2.55l9.83.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_54",
      "fill": "#FFF",
      "d": "M5231.67 306.05c-2.03.02-3.67 1.7-3.67 3.8v80.7c0 1.36 1.07 2.45 2.38 2.45 1.32 0 2.4-1.1 2.4-2.44v-79.44h8.7c1.4 0 2.52-1.15 2.52-2.57 0-1.4-1.1-2.55-2.5-2.55l-9.83.05z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_53",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5337 254 5337 393 5250 393 5250 254"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_52",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5336 296l-78 96",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_51",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5336 325l-54 68",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_50",
      "width": "1656",
      "height": "211",
      "x": "4907",
      "y": "-30",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_49",
      "width": "1757",
      "height": "12",
      "x": "4907",
      "y": "181",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_47",
      "width": "63",
      "height": "207",
      "x": "4970",
      "y": "242",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_46",
      "width": "63",
      "height": "31",
      "x": "4970",
      "y": "211",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "transform": "matrix(1 0 0 -1 0 453)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_45",
      "width": "556",
      "height": "51",
      "x": "4945",
      "y": "160",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_44",
      "width": "556",
      "height": "12",
      "x": "4945",
      "y": "147",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "school_43",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "5008 -42.75 5223 -106 5438 -42.75 5438 147 5008 147"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_41",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5224 27c69.28 0 113.62 27.32 133 81.97V147h-266v-38.03C5110.38 54.32 5154.72 27 5224 27z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_40",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5223.5 33c64.13 0 106.3 25.33 126.5 76v38h-253v-38c20.2-50.67 62.37-76 126.5-76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_39",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5222 34v112",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_38",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5280 43l-52 64",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_37",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5342 110l-28 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_36",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5263 38l-28 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_35",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5159 70l-30 38",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_34",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5097 109h252",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_33",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5160 46v98",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_32",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5286 46v98",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_31",
      "width": "63",
      "height": "207",
      "x": "5412",
      "y": "242",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_30",
      "width": "63",
      "height": "31",
      "x": "5412",
      "y": "211",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "transform": "matrix(1 0 0 -1 0 453)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_29",
      "width": "240",
      "height": "127",
      "x": "5539",
      "y": "17",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_28",
      "width": "101",
      "height": "101",
      "x": "5666",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_27",
      "width": "101",
      "height": "101",
      "x": "5551",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_26",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5744.36 29.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_25",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5756.37 29.63L5689 115",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_24",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5639.36 74.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_23",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5652.37 43.63L5585 129",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_22",
      "width": "240",
      "height": "127",
      "x": "5805",
      "y": "17",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_21",
      "width": "101",
      "height": "101",
      "x": "5931",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_20",
      "width": "101",
      "height": "101",
      "x": "5817",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_19",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6010.36 29.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_18",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6022.37 29.63L5955 115",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_17",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5904.36 74.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_16",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M5917.37 43.63L5850 129",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_15",
      "width": "240",
      "height": "127",
      "x": "6108",
      "y": "17",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_14",
      "width": "101",
      "height": "101",
      "x": "6234",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_13",
      "width": "101",
      "height": "101",
      "x": "6120",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_12",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6313.36 29.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_11",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6325.37 29.63L6258 115",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_10",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6207.36 74.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_9",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6221.37 43.63L6154 129",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_8",
      "width": "240",
      "height": "127",
      "x": "6373",
      "y": "17",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_7",
      "width": "101",
      "height": "101",
      "x": "6500",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "school_6",
      "width": "101",
      "height": "101",
      "x": "6386",
      "y": "29",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_5",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6579.36 29.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6591.37 29.63L6524 115",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6473.36 74.63l-44.72 55.74",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M6486.37 43.63L6419 129",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_1",
      "fill": "#FFF",
      "d": "M5125.64 194.7h-5.85c-.1-.12-.13-.28-.13-.48 0-.22.07-.42.2-.6l2.04-.24v-7.94h-10.96v7.88h1.76c.32 0 .48.14.48.42 0 .14-.05.38-.15.72l-.06.24h-5.85c-.08-.12-.12-.28-.12-.48 0-.22.07-.42.2-.6l2.04-.24v-16.7h-1.76c-.32 0-.48-.14-.48-.42 0-.14.05-.38.15-.72l.06-.24h5.86c.08.12.12.28.12.48 0 .22-.07.42-.2.6l-2.04.24v7.43h10.97v-7.37h-1.75c-.32 0-.48-.14-.48-.42 0-.14.05-.38.15-.72l.06-.24h5.85c.08.12.12.28.12.48 0 .22-.07.42-.2.6l-2.04.24v16.7h1.76c.33 0 .5.14.5.42 0 .14-.06.38-.16.72l-.06.24zm13.36 0h-6.45c-.1-.12-.13-.28-.13-.48 0-.22.07-.42.22-.6l2.33-.24v-16.7h-2.06c-.3 0-.48-.14-.48-.42 0-.14.05-.38.16-.72l.06-.24h6.45c.07.12.1.28.1.48 0 .22-.06.42-.2.6l-2.33.24v16.7h2.06c.32 0 .48.14.48.42 0 .14-.04.38-.14.72l-.06.24zm20.9-1.87v-6.22h-3.26c-.33 0-.5-.13-.5-.4 0-.15.06-.4.16-.73l.06-.24h7.22c.08.12.12.28.12.48 0 .23-.07.43-.22.6l-1.87.25v6.4c-.05.15-.14.3-.24.46-.1.17-.2.32-.33.46-.75.34-1.65.6-2.7.82-1.07.2-2.1.32-3.12.32-1.93 0-3.6-.4-5.02-1.22-1.4-.8-2.5-1.96-3.27-3.46-.76-1.5-1.14-3.26-1.14-5.3 0-2.03.4-3.8 1.16-5.3.78-1.5 1.87-2.66 3.28-3.5 1.4-.8 3.06-1.22 4.98-1.22.83 0 1.72.1 2.67.3.95.2 1.83.48 2.63.84.13.14.24.3.34.45.1.15.18.3.24.45l.06 3.7c-.12.07-.28.1-.48.1-.23 0-.43-.06-.6-.2l-.83-3.45c-.7-.3-1.37-.5-2-.6-.64-.13-1.3-.2-2.02-.2-1.55 0-2.9.36-4.06 1.07-1.15.7-2.03 1.7-2.65 3-.62 1.28-.92 2.8-.92 4.58 0 1.74.3 3.25.95 4.54.64 1.27 1.54 2.26 2.7 2.95 1.18.7 2.57 1.04 4.16 1.04.73 0 1.53-.1 2.4-.24.9-.15 1.6-.32 2.15-.53zm28.52 1.87h-5.84c-.1-.12-.13-.28-.13-.48 0-.22.08-.42.22-.6l2.03-.24v-7.94h-10.97v7.88h1.75c.33 0 .5.14.5.42 0 .14-.06.38-.16.72l-.06.24h-5.85c-.07-.12-.1-.28-.1-.48 0-.22.06-.42.2-.6l2.03-.24v-16.7h-1.76c-.32 0-.48-.14-.48-.42 0-.14.04-.38.14-.72l.06-.24h5.85c.08.12.12.28.12.48 0 .22-.07.42-.2.6l-2.04.24v7.43h10.97v-7.37h-1.76c-.32 0-.5-.14-.5-.42 0-.14.07-.38.17-.72l.07-.24h5.85c.08.12.12.28.12.48 0 .22-.07.42-.22.6l-2.03.24v16.7h1.75c.32 0 .5.14.5.42 0 .14-.06.38-.17.72l-.06.24zm18.5-1.8l-.07-3.76c.12-.08.28-.12.48-.12.23 0 .43.07.6.2l.83 3.58c.56.25 1.2.44 1.9.58.7.14 1.42.2 2.2.2 1.67 0 2.97-.34 3.9-1.03.95-.7 1.42-1.66 1.42-2.9 0-.97-.34-1.75-1.03-2.36-.7-.63-1.9-1.22-3.63-1.8-1.6-.53-2.87-1.06-3.8-1.6-.95-.56-1.62-1.18-2.04-1.85-.4-.67-.62-1.45-.62-2.33 0-1.48.55-2.64 1.64-3.47 1.1-.83 2.6-1.25 4.54-1.25 1.72 0 3.33.36 4.82 1.08.12.14.23.3.33.45.1.16.18.3.24.45l.06 3.6c-.12.1-.3.13-.5.13s-.4-.06-.6-.2l-.8-3.4c-1.14-.48-2.33-.72-3.56-.72-1.43 0-2.53.3-3.3.86-.77.57-1.15 1.4-1.15 2.48 0 .64.13 1.2.43 1.66.3.46.8.9 1.54 1.3s1.77.8 3.08 1.25c2.2.76 3.77 1.58 4.7 2.44.92.86 1.4 1.95 1.4 3.28 0 1.66-.64 2.97-1.9 3.92-1.24.95-2.98 1.43-5.2 1.43-1.03 0-2.02-.1-2.97-.32-.95-.2-1.75-.5-2.4-.88-.12-.14-.23-.3-.33-.45-.1-.16-.18-.3-.24-.46zm33.4-12.04l-.84-3.66c-1.3-.53-2.6-.8-3.84-.8-1.46 0-2.73.37-3.82 1.08-1.1.7-1.94 1.7-2.53 3-.6 1.28-.9 2.78-.9 4.5 0 1.75.3 3.25.92 4.52.6 1.26 1.5 2.24 2.63 2.93 1.15.7 2.5 1.04 4.05 1.04 1.8 0 3.53-.42 5.18-1.27.28.34.48.74.58 1.2-.75.5-1.67.87-2.76 1.16-1.1.3-2.18.44-3.27.44-1.84 0-3.44-.4-4.8-1.23-1.37-.83-2.43-2-3.2-3.5-.75-1.5-1.12-3.26-1.12-5.3 0-2 .37-3.74 1.1-5.23.75-1.5 1.8-2.66 3.13-3.5 1.35-.82 2.9-1.24 4.7-1.24.8 0 1.7.1 2.64.3.94.2 1.8.48 2.62.84l.32.45c.1.15.18.3.24.45l.06 3.9c-.12.1-.28.13-.48.13-.22 0-.42-.07-.6-.22zm26.7 13.84h-5.84c-.08-.12-.12-.28-.12-.48 0-.22.07-.42.2-.6l2.04-.24v-7.94h-10.97v7.88h1.76c.3 0 .48.14.48.42 0 .14-.05.38-.16.72l-.06.24h-5.84c-.1-.12-.13-.28-.13-.48 0-.22.06-.42.2-.6l2.04-.24v-16.7h-1.76c-.32 0-.5-.14-.5-.42 0-.14.06-.38.17-.72l.06-.24h5.85c.1.12.13.28.13.48 0 .22-.07.42-.22.6l-2.03.24v7.43h10.97v-7.37h-1.75c-.33 0-.5-.14-.5-.42 0-.14.06-.38.16-.72l.07-.24h5.85c.08.12.12.28.12.48 0 .22-.07.42-.2.6l-2.04.24v16.7h1.76c.32 0 .48.14.48.42 0 .14-.05.38-.15.72l-.07.24zm16.07-1.1c1.45 0 2.7-.37 3.8-1.08 1.07-.7 1.9-1.72 2.5-3 .6-1.3.9-2.8.9-4.54 0-1.72-.3-3.22-.9-4.5-.6-1.3-1.43-2.3-2.5-3-1.1-.7-2.35-1.07-3.8-1.07-1.46 0-2.73.37-3.8 1.08-1.1.7-1.93 1.7-2.53 3-.6 1.28-.9 2.78-.9 4.5 0 1.75.3 3.26.9 4.55.6 1.28 1.44 2.28 2.52 3 1.07.7 2.34 1.06 3.8 1.06zm0 1.4c-1.8 0-3.38-.42-4.74-1.25-1.35-.83-2.4-2-3.15-3.5-.74-1.48-1.1-3.24-1.1-5.27 0-2 .36-3.75 1.1-5.24.76-1.5 1.8-2.66 3.16-3.5 1.36-.82 2.93-1.24 4.73-1.24 1.8 0 3.36.42 4.72 1.25 1.35.83 2.4 2 3.15 3.5.75 1.48 1.12 3.23 1.12 5.23 0 2.03-.38 3.8-1.13 5.28-.75 1.5-1.8 2.66-3.15 3.5-1.36.82-2.93 1.24-4.73 1.24zm24.8-1.4c1.46 0 2.73-.37 3.8-1.08 1.1-.7 1.93-1.72 2.53-3 .6-1.3.9-2.8.9-4.54 0-1.72-.3-3.22-.9-4.5-.6-1.3-1.44-2.3-2.52-3-1.07-.7-2.34-1.07-3.8-1.07-1.45 0-2.7.37-3.8 1.08-1.07.7-1.9 1.7-2.5 3-.6 1.28-.9 2.78-.9 4.5 0 1.75.3 3.26.9 4.55.6 1.28 1.43 2.28 2.5 3 1.1.7 2.35 1.06 3.8 1.06zm0 1.4c-1.8 0-3.36-.42-4.72-1.25-1.35-.83-2.4-2-3.15-3.5-.75-1.48-1.12-3.24-1.12-5.27 0-2 .38-3.75 1.13-5.24.75-1.5 1.8-2.66 3.15-3.5 1.36-.82 2.93-1.24 4.73-1.24 1.8 0 3.38.42 4.74 1.25 1.35.83 2.4 2 3.15 3.5.74 1.48 1.1 3.23 1.1 5.23 0 2.03-.36 3.8-1.1 5.28-.76 1.5-1.8 2.66-3.16 3.5-1.36.82-2.93 1.24-4.73 1.24zm29.3-.3h-13.32c-.08-.12-.12-.28-.12-.48 0-.22.07-.42.2-.6l2.04-.24v-16.7h-1.76c-.32 0-.48-.14-.48-.42 0-.14.05-.38.15-.72l.07-.24h6.15c.08.12.12.28.12.48 0 .22-.07.42-.2.6l-2.34.24v16.7h8.45l.76-3.43c.2-.15.4-.22.62-.22.2 0 .36.04.48.12l-.06 4.12c-.2.3-.45.56-.73.78z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub_13",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4844.04 368.62c.33.1.65.24.96.38 4.36-2.06 5.34-1.83 10 0 4-2 6-2 10 0 4-2 6-2 10 0 4-2 6-2 10 0 3.68-1.84 8.16-.35 10 3.33 1.05 2.1 1.05 4.57 0 6.67 2 4 2 6 0 10 2 3.97 2 6 0 10 2 4 2 6 0 10 2 4 2 6 0 10 2 4 2 6 0 10 2 4 2 6 0 10 .53 1.06.85 2.22.96 3.48.28 3.3-2.16 6.2-5.46 6.5l-.52.02h-49.96c-3.3 0-6-2.7-6-6 0-.17 0-.35.02-.52.1-1.26.43-2.42.96-3.48-2-4-2-6 0-10-2-4-2-6 0-10-2-4-2-6 0-10-2-4-2-6 0-10-2-4-2-6 0-10-2-4-2-6 0-10-1.84-3.68-.35-8.14 3.33-9.98 1.77-.9 3.83-1.03 5.7-.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub_12",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4859.88 386.66c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.16 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub_11",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4884.88 407.66c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.16 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub_10",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4868.8 410.92c4.17-.48 7.5 4.02 6.38 7.7-3.35.76-7.5-3.54-6.38-7.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub_9",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4845.34 428.96c3.42-2.44 8.5-.12 9.32 3.64-2.57 2.3-8.27.53-9.32-3.64z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub_8",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4849.68 441.25c.25-4.2 5.25-6.68 8.7-4.95.15 3.44-4.8 6.77-8.7 4.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub_7",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4846.37 381.98c4.13.76 6 6.03 3.85 9.23-3.43-.24-6.13-5.57-3.85-9.22z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub_6",
      "cx": "4852",
      "cy": "381",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 9704 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub_5",
      "cx": "4855",
      "cy": "384",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 9710 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub_4",
      "cx": "4879",
      "cy": "406",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 9758 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub_3",
      "cx": "4873",
      "cy": "406",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 9746 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub_2",
      "cx": "4876",
      "cy": "410",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 9752 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub_1",
      "cx": "4859",
      "cy": "432",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 9718 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_88",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4217.9 111.8c0 61.47-39.05 127.65-114.23 136.12-14.58 1.64-23.5-4.5-39.6-9.26-41.26-12.2-143.6-49.1-152.44-132.16-4.1 104.1 116.5 135.34 160.83 170.27 16.74 13.2 33.96 19.4 38.27 9.23 4.47-10.57 52.12-32.7 72.73-52.2 19.2-18.2 48.74-75.04 34.44-122z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_87",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4120.96 97.04c-26.7 49.03-32.02 80.27-48.06 80.27s-39.9-36.42-63.32-69.1c13.4 43.54 36.44 65.9 55.58 130.62.64 2.18 1.3 4.42 1.92 6.7 2.63 9.42 4.26 19.8 5.05 30.7 5.08 69.62-23.66 161.66-43.94 172.34h90.02c16.25-32.53 2.74-119.47-20.54-233.95-5.3-26.13 14.87-72.5 23.28-117.56z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_86",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3881 110.8c12.94-3.4 25.37 9.27 23.46 21.4-10.26 3.92-25.17-7.77-23.47-21.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_85",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3882.26 162.7c7.53-11.07 25.22-9.66 31.74.75-5.17 9.68-24.1 10.65-31.74-.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_84",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3945.96 118.16c7.64 11 0 27-12.07 29.37-7.2-8.3-1.3-26.3 12.06-29.37z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_83",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3914.3 69.43c10.67 8.1 8.34 25.7-2.4 31.66-9.4-5.67-9.37-24.62 2.4-31.67z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_82",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4037.3 77.67c6.46 11.74-2.83 26.86-15.06 27.94-6.28-9 1.45-26.3 15.07-27.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_81",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4063.1 53.54c11.57 6.75 11.4 24.5 1.47 31.72-10.02-4.48-12.3-23.3-1.47-31.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_80",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4029.74 32.77c13.18 2.4 19.1 19.12 12.23 29.3-10.95-.78-19.53-17.67-12.23-29.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_79",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4094.4 27.57c8.57 10.3 2.34 26.9-9.46 30.3-7.88-7.63-3.6-26.08 9.46-30.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_78",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3959.96 76.1c7.05 11.4-1.43 26.97-13.6 28.7-6.73-8.67.08-26.35 13.6-28.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_77",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3938.64 47.44c10.52 8.3 7.88 25.83-2.96 31.6-9.3-5.82-8.94-24.77 2.96-31.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_76",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4058.7 108.36c2.97 13.06-10.13 25.04-22.2 22.7-3.54-10.38 8.66-24.88 22.2-22.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_75",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4159.1 98.78c-3.3 12.98-20.4 17.7-30.1 10.15 1.55-10.86 19-18.24 30.1-10.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_74",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4151.17 136.56c-6.34 11.8-24.08 12.25-31.65 2.58 4.13-10.17 22.85-13.1 31.65-2.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_73",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4142.2 166.23c-6.35 11.8-24.08 12.25-31.65 2.58 4.12-10.16 22.85-13.1 31.64-2.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_72",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4144.3 57.2c6.03 11.96-3.78 26.74-16.04 27.4-5.97-9.22 2.36-26.24 16.04-27.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_71",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4094.74 66.64c13.38-.65 22.9 14.32 18.5 25.8-10.83 1.7-23-12.84-18.5-25.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_70",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4082.96 93.08c13.38.53 21.56 16.27 16.2 27.32-10.96.75-21.8-14.8-16.2-27.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_69",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4064.73 131.9c13.38-.63 22.9 14.34 18.5 25.8-10.84 1.7-23-12.82-18.5-25.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_68",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3989.3 67.5c13.3 1.7 20.06 18.08 13.75 28.62-10.98-.2-20.43-16.63-13.75-28.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_67",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3969.8 114.76c7.34-11.2 25.05-10.1 31.75.2-5 9.76-23.9 11.06-31.75-.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_66",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3983.55 147c6.13-11.9 23.86-12.67 31.6-3.13-3.95 10.24-22.62 13.5-31.6 3.13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_65",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3934.1 233.7c1.44-13.3 17.72-20.37 28.36-14.24 0 10.98-16.27 20.7-28.37 14.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_64",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3966.8 259.53c-2.5-13.16 11-24.67 22.98-21.92 3.2 10.5-9.5 24.57-22.97 21.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_63",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3903.26 198.7c7.53-11.07 25.22-9.66 31.74.75-5.17 9.68-24.1 10.65-31.74-.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_62",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3971.8 148.97c7.64 11 0 27-12.06 29.36-7.2-8.3-1.3-26.3 12.07-29.36z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_61",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4003.03 167.96c7.63 11-.02 27-12.07 29.36-7.2-8.3-1.3-26.3 12.07-29.36z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_60",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4183.2 114.68c12.76-4.08 25.83 7.92 24.56 20.14-10.03 4.44-25.54-6.45-24.56-20.14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_59",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4187.53 72.63c13.07-2.95 25.04 10.14 22.7 22.2-10.38 3.56-24.88-8.65-22.7-22.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_58",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4178.52 38c8.93 10 3.28 26.82-8.4 30.62-8.14-7.35-4.5-25.95 8.4-30.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_57",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4254.1 117.66c1.8 13.27-12.28 24.06-24.1 20.7-2.63-10.67 10.8-24.05 24.1-20.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_56",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4218.48 39.2c11.9 6.14 12.67 23.87 3.13 31.6-10.23-3.94-13.5-22.6-3.12-31.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_55",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4254.5 175.83c-3.53 12.92-20.7 17.35-30.27 9.63 1.74-10.84 19.32-17.92 30.26-9.63z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_54",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4244.94 80.56c4.96 12.44-6.1 26.32-18.37 25.9-5.14-9.7 4.64-25.93 18.37-25.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_53",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4175.17 144.08c13.27-1.8 24.06 12.28 20.68 24.1-10.65 2.63-24.03-10.8-20.68-24.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_52",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4155.03 178.16c13.28-1.8 24.07 12.27 20.7 24.08-10.66 2.64-24.04-10.78-20.7-24.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_51",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4212.5 259.23c-12.36 5.18-26.43-5.63-26.22-17.9 9.6-5.32 26 4.18 26.2 17.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_50",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4234.16 227.84c-11.5 6.85-26.95-1.9-28.46-14.1 8.78-6.58 26.34.54 28.46 14.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree3_49",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4133.18 199.5c12.92 3.53 17.35 20.7 9.63 30.27-10.83-1.74-17.9-19.32-9.62-30.26z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_48",
      "cx": "4027.5",
      "cy": "202.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8055 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_47",
      "cx": "3984.5",
      "cy": "165.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7969 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_46",
      "cx": "3950.5",
      "cy": "152.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7901 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_45",
      "cx": "3965.5",
      "cy": "131.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7931 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_44",
      "cx": "3932.5",
      "cy": "102.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7865 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_43",
      "cx": "3890.5",
      "cy": "89.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7781 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_42",
      "cx": "3882.5",
      "cy": "145.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7765 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_41",
      "cx": "3915.5",
      "cy": "180.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7831 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_40",
      "cx": "4001.5",
      "cy": "251.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8003 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_39",
      "cx": "3945.5",
      "cy": "250.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7891 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_38",
      "cx": "3924.5",
      "cy": "221.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7849 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_37",
      "cx": "4033.5",
      "cy": "265.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8067 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_36",
      "cx": "4024.5",
      "cy": "174.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8049 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_35",
      "cx": "4053.5",
      "cy": "145.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8107 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_34",
      "cx": "4074.5",
      "cy": "120.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8149 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_33",
      "cx": "4016.5",
      "cy": "65.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8033 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_32",
      "cx": "3975.5",
      "cy": "91.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7951 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_31",
      "cx": "3965.5",
      "cy": "61.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7931 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_30",
      "cx": "3995.5",
      "cy": "51.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7991 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_29",
      "cx": "4057.5",
      "cy": "35.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8115 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_28",
      "cx": "4003.5",
      "cy": "128.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8007 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_27",
      "cx": "4053.5",
      "cy": "91.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8107 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_26",
      "cx": "4080.5",
      "cy": "76.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8161 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_25",
      "cx": "4116.5",
      "cy": "53.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8233 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_24",
      "cx": "4159.5",
      "cy": "81.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8319 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_23",
      "cx": "4144.5",
      "cy": "41.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8289 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_22",
      "cx": "4150.5",
      "cy": "120.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8301 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_21",
      "cx": "4111.5",
      "cy": "196.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8223 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_20",
      "cx": "4118.5",
      "cy": "151.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8237 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_19",
      "cx": "4171.5",
      "cy": "169.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8343 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_18",
      "cx": "4159.5",
      "cy": "150.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8319 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_17",
      "cx": "4141.5",
      "cy": "185.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8283 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_16",
      "cx": "4115.5",
      "cy": "231.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8231 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_15",
      "cx": "4180.5",
      "cy": "98.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8361 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_14",
      "cx": "4169.5",
      "cy": "128.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8339 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_13",
      "cx": "4198.5",
      "cy": "58.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8397 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_12",
      "cx": "4239.5",
      "cy": "57.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8479 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_11",
      "cx": "4204.5",
      "cy": "26.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8409 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_10",
      "cx": "4248.5",
      "cy": "106.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8497 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_9",
      "cx": "4229.5",
      "cy": "163.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8459 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_8",
      "cx": "4245.5",
      "cy": "149.63",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8491 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_7",
      "cx": "4227.5",
      "cy": "202.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8455 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_6",
      "cx": "4235.5",
      "cy": "243.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8471 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_5",
      "cx": "4209.5",
      "cy": "237.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8419 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_4",
      "cx": "4175.5",
      "cy": "258.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8351 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_3",
      "cx": "4156.5",
      "cy": "213.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8313 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_2",
      "cx": "4153.5",
      "cy": "265.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8307 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree3_1",
      "cx": "4184.5",
      "cy": "185.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 8369 0)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_39",
      "width": "132",
      "height": "173",
      "x": "4107",
      "y": "260",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_38",
      "width": "211",
      "height": "173",
      "x": "4249",
      "y": "260",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_37",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4397 261l-69 86",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_36",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4460 294l-58 73",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_35",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4304 261l-55 69",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_34",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4384 391l-33 41",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_33",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4378 261l-136 172",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_32",
      "width": "10",
      "height": "206",
      "x": "4097",
      "y": "243",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_31",
      "width": "10",
      "height": "206",
      "x": "4239",
      "y": "243",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_30",
      "width": "10",
      "height": "206",
      "x": "4460",
      "y": "243",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_29",
      "width": "4",
      "height": "250",
      "x": "4514",
      "y": "199",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "bus_stop_28",
      "cx": "4516.5",
      "cy": "235.5",
      "r": "16.5",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "bus_stop_27",
      "cx": "4516.5",
      "cy": "235.5",
      "r": "12.5",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_26",
      "width": "33",
      "height": "99",
      "x": "4500",
      "y": "261",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "rx": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_24",
      "width": "10",
      "height": "206",
      "x": "4318",
      "y": "243",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_25",
      "width": "33",
      "height": "12",
      "x": "4500",
      "y": "199",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_23",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4173 243h297c-4.46-29.33-29.2-44-74.25-44H4173v44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_22",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4173 243h190c-4.47-29.33-29.25-44-74.35-44H4173v44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_21",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4097 243h152c-5.57-30-30.9-45-76-45s-70.43 15-76 45z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "bus_stop_20",
      "width": "122",
      "height": "163",
      "x": "4112",
      "y": "265",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#ad_clip)"
    }
  }, [_c('g', {
    attrs: {
      "id": "ad_man"
    }
  }, [_c('rect', {
    attrs: {
      "id": "ad_men_bg",
      "width": "120",
      "height": "161",
      "x": "4113",
      "y": "266",
      "fill": "#494949"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_woman",
      "fill": "#000",
      "d": "M4186.72 296.96c-.42 3 .15 6.28 1.68 7-3.7 7.72-2.62 13.72-2.46 17.5-.52.93-1.78 1.16-2.86 1.6 1.63-.05 2.2-.23 2.87-.44-.02.7-.12 1.32-.36 1.8-1.6 3.35-4.7 8.32-5.67 9.98-.95 1.66 2.6 2.8 4.65 3.94 2.03 1.14-.52 3.72-1.5 4.1-.97.35.73 3.47 2.7 4.23-.7.6-1.8.42-2.02 1.92-.2 1.5.45 2.96 2.3 3.27 1.82.3-.9 6.3.74 8.36 1.64 2.05 12.5-.83 18.5-3.26 5.97-2.42 7.94 6 8.5 8.33.57 2.3 2.22 7.25-1.25 9-3.47 1.77-32.94 6.2-37.76 8.18-3.22 1.3-6.67 19.97-10.37 44.52H4233V287.2c-11.33-5.86-43.9-7.22-46.28 9.76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_24",
      "fill": "#696969",
      "d": "M4121.6 354.9c-5.78 6.8-.5 45.37 3.6 72.1h32c2.9-22.86 10-65.9 3.7-72.1-6.3-6.17-33.5-6.78-39.3 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_23",
      "fill": "#252525",
      "d": "M4122.14 355.1c.17 0-2.86 2.05-1.9 13.06.24 2.82 2.3 22.43 6.16 58.84h31.94c3.56-36.04 5.48-55.65 5.76-58.84.9-10.12-2.37-13.05-2.17-13.05 1.57 0 52.43 23.8 56.08 26.4 2.8 4.48 7.46 19.65 14 45.5h-119v-61.48c5.1-6.94 8.15-10.4 9.14-10.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_22",
      "fill": "#373737",
      "d": "M4122.16 355.1c.17 0-2.87 2.05-1.9 13.06.23 2.82 2.3 22.43 6.17 58.84h31.87c3.66-36.04 5.63-55.65 5.9-58.84.9-10.12-2.37-13.05-2.17-13.05.34 0 2.9 1.08 6.75 2.8 3.84 5.46 10.02 34.7 10.77 40.52-.9 4.72-3.8 14.25-8.7 28.58H4113v-61.48c5.1-6.94 8.16-10.4 9.16-10.4z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "ad_men_man_21",
      "fill": "#CECECE",
      "points": "4122.07563 345.993711 4161.40336 345.993711 4161.40336 364.432313 4150.04557 377.731663 4141.7395 401.685535 4132.31861 377.731663 4122.07563 364.432313"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_20",
      "fill": "#252525",
      "d": "M4142.1 343.97c17.27 0 33.42-13.66 33.42-30.55 0-16.9-2.53-41.34-33.42-41.34-16.9 0-25.1 7.23-29.1 16.63v38.1c5.64 9.93 16.94 17.17 29.1 17.17z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_19",
      "fill": "#D6D6D6",
      "d": "M4171.52 318.14c5.44-1.9 7.73 1.92 6.84 6.93-.9 5-5.8 7.03-6.84 9-1.05 1.95-.8 4.74-4.4 4.84-3.62.1-1.04-18.84 4.4-20.76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_18",
      "fill": "#DCDCDC",
      "d": "M4113 336.04c.48 1.28 1.23 2.8 3.4 2.87 3.3.1 1.32-17-3.4-20.25v17.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_17",
      "fill": "#E5E5E5",
      "d": "M4136.4 360.17c2.12 0 4.02-1.08 5.33-1.08 1.3 0 3.2 1.07 5.32 1.07s17.55-6.46 22.86-38.03c2.33-13.76-2.7-20.67-11.1-27.93-12.7-10.98-27.46 3.55-21.54 14.7-9.34-.05-13.8-10.42-12.58-14.7-8.48 7.06-13.38 14.15-11.14 27.94 1.15 7.03 2.76 12.8 4.6 17.5 6.75 17.2 16.62 20.53 18.27 20.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_16",
      "fill": "#DCDCDC",
      "d": "M4141.94 359.1c1.3 0 3.16 1.07 5.28 1.07 2.1 0 17.42-6.44 22.7-37.94 2.3-13.74-2.7-20.63-11.03-27.88 4.28 6.37 7.75 13.48 8.97 22.25-6.17-5.8-22.23.5-25.93 3.98-1.58 7.17 0 15.82 0 19.82 0 8.78-1.3 18.7 0 18.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_15",
      "fill": "#252525",
      "d": "M4146.33 315.22c.1 1.4-.04 3.16.9 3.1.92-.05 10.07-3.63 11.74-4.07 1.66-.44 6 .28 8.05 1.3 2.05 1.04-2.27-4.8-6.85-4.22-4.57.58-13.94 2.5-13.84 3.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_14",
      "fill": "#252525",
      "d": "M4136.14 315.22c-.1 1.4.04 3.16-.9 3.1-.92-.05-10.07-3.63-11.74-4.07-1.66-.44-6 .28-8.05 1.3-2.05 1.04 2.27-4.8 6.85-4.22 4.57.58 13.94 2.5 13.84 3.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_13",
      "fill": "#FFF",
      "d": "M4150.23 322.6c1.9-3.17 9.93-3.66 13.32-1.3-.85 1.92-4.58 3.1-6.1 3.28-1.53.2-6.3-.16-7.22-1.97z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_12",
      "fill": "#737373",
      "d": "M4155.14 323.7c1.1.12 2.1-.68 2.22-1.8.1-1.1-.7-2.1-1.8-2.22-1.1-.12-2.1.7-2.2 1.8-.13 1.1.67 2.1 1.78 2.23z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_11",
      "fill": "#252525",
      "d": "M4155.25 322.7c.55.06 1.05-.35 1.1-.9.06-.56-.34-1.06-.9-1.12-.55-.05-1.04.35-1.1.9-.06.56.34 1.06.9 1.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_9",
      "fill": "#FFF",
      "d": "M4134.26 322.6c-1.9-3.17-9.93-3.66-13.32-1.3.85 1.92 4.58 3.1 6.1 3.28 1.53.2 6.3-.16 7.22-1.97z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_8",
      "fill": "#737373",
      "d": "M4128.34 323.7c-1.1.12-2.1-.68-2.22-1.8-.12-1.1.7-2.1 1.8-2.22 1.1-.12 2.1.7 2.2 1.8.13 1.1-.68 2.1-1.78 2.23z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_7",
      "fill": "#252525",
      "d": "M4128.23 322.7c-.55.06-1.05-.35-1.1-.9-.06-.56.34-1.06.9-1.12.54-.05 1.04.35 1.1.9.06.56-.34 1.06-.9 1.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_5",
      "fill": "#F0F0F0",
      "d": "M4141.53 319.67h1.38c.55 0 1 .42 1 .96.3 6.85.53 10.75.7 11.68.3 1.48 3.7 1.43 3.7 3.87 0 .75-2.06.46-3.05 1.28-1 .83-.64 2.48-3.02 2.47-2.4 0-2.4-1.7-3.32-2.46-.9-.76-2.7-.65-2.7-1.3 0-2.35 3.4-2.24 3.64-3.85.15-1.02.38-4.9.7-11.68.02-.53.46-.95 1-.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_4",
      "fill": "#D6D6D6",
      "d": "M4142.12 358.7c.87 0 1.67.34 2.08.45.4.12-1.46-4.06-2.08-4.04-.62.02-2.18 4.05-1.85 4.05.34 0 .98-.44 1.85-.44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_3",
      "fill": "#BCBCBC",
      "d": "M4142.24 349.03c6.46 0 7.52-2.53 8.07-3.04-.5 0-6.27.6-8.06.62-1.78.02-7.58-.63-8.06-.63.58.5 1.6 3.03 8.06 3.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_2",
      "fill": "#CBCBCB",
      "d": "M4142.24 345.1c.68 0 1.83-1.14 2.68-1.13.86 0 4.96 2.15 5.37 2.3.4.17-6.28.72-8.06.74-1.78.02-8.37-.5-8.05-.72.3-.2 4.9-2.3 5.36-2.3.45 0 2 1.13 2.68 1.13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_man_1",
      "fill": "#E5E5E5",
      "d": "M4150 325.7c2.34 1.34 12.5.57 14.14-.88 1.64-1.45-4 15.1-8.26 15.1-4.27 0-8.22-15.55-5.88-14.22z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ad_men_prefume_6",
      "width": "10.08",
      "height": "5.06",
      "x": "4192.66",
      "y": "366.25",
      "fill": "#B07A22",
      "rx": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ad_men_prefume_5",
      "width": "7.06",
      "height": "3.04",
      "x": "4193.67",
      "y": "371.31",
      "fill": "#96671A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_prefume_4",
      "fill": "#F4DEB9",
      "d": "M4187.6 374.35h20.22c1.65 0 3 1.34 3 3v23.36c0 1.67-1.35 3-3 3h-20.22c-1.66 0-3-1.33-3-3v-23.35c0-1.66 1.34-3 3-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_prefume_3",
      "fill": "#D59F46",
      "d": "M4191.4 376.37h11.6c2.76 0 5 2.24 5 5 0 .25-.02.5-.05.74l-1.98 13.3c-.36 2.45-2.47 4.26-4.95 4.26h-7.64c-2.48 0-4.58-1.8-4.95-4.26l-1.97-13.3c-.4-2.73 1.48-5.27 4.2-5.67.25-.04.5-.06.74-.06z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_prefume_2",
      "fill": "#F4DEB9",
      "d": "M4186.13 374.35h23.15c.55 0 1 .44 1 1 0 .16-.04.32-.12.47l-3.75 7.06c-.52.98-1.53 1.6-2.64 1.6h-12.1c-1.1 0-2.13-.62-2.65-1.6l-3.75-7.06c-.26-.5-.08-1.1.4-1.36.16-.07.32-.1.48-.1z",
      "opacity": ".3"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "ad_men_prefume_1",
      "cx": "4197.71",
      "cy": "391.56",
      "fill": "#96671A",
      "rx": "4.03",
      "ry": "4.05"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_men_text",
      "fill": "#FFF",
      "d": "M4174.5 416.54v-7.42h4.24v.4h-3.77v3.18h3.35v.4h-3.35v3.44h-.46zm5.22-3.7c0-.53.1-1.02.3-1.48.2-.46.5-.86.84-1.2.34-.35.75-.63 1.22-.83.47-.2.98-.3 1.52-.3s1.04.1 1.52.3c.47.2.9.48 1.24.82.36.35.64.75.84 1.2.2.47.3.96.3 1.48 0 .53-.1 1.02-.3 1.48-.2.47-.48.87-.84 1.2-.35.35-.77.62-1.24.82-.48.2-.98.3-1.52.3s-1.05-.1-1.52-.3c-.47-.2-.88-.47-1.22-.8-.35-.35-.63-.75-.83-1.2-.2-.47-.3-.96-.3-1.5zm.44 0c0 .47.1.9.27 1.3.18.42.43.78.74 1.08.3.3.67.55 1.1.73.4.17.84.26 1.32.26.46 0 .9-.08 1.33-.25.43-.18.8-.42 1.1-.73.33-.3.58-.66.76-1.07.18-.4.27-.85.27-1.32 0-.46-.1-.9-.28-1.3-.2-.42-.44-.78-.75-1.08-.3-.3-.68-.55-1.1-.73-.42-.18-.87-.26-1.34-.26-.47 0-.9.08-1.33.26-.42.18-.8.42-1.1.73-.3.3-.56.67-.74 1.08-.18.4-.27.85-.27 1.3zm9.13 3.7v-7.42h1.68c.27 0 .54.04.8.12.3.07.54.2.77.36.23.16.4.38.55.64.15.26.22.58.22.95 0 .4-.1.8-.3 1.16-.22.36-.56.64-1.02.82.05.08.14.2.25.4l.4.62c.13.23.3.47.44.73l.44.72.36.57.2.32h-.53l-.18-.28-.33-.53c-.13-.2-.27-.42-.4-.66l-.44-.68-.4-.64c-.1-.2-.2-.34-.28-.45l-.3.04-.33.02h-1.18v3.18h-.45zm.44-3.6h1.2c.37 0 .68-.06.94-.18.25-.13.45-.28.6-.46.14-.18.24-.38.3-.58.06-.2.1-.4.1-.56 0-.23-.06-.44-.15-.63-.1-.2-.22-.37-.4-.52-.15-.14-.36-.25-.6-.34-.23-.1-.5-.13-.8-.13h-1.2v3.4zm8.57-4.16l.9 1.27.96 1.35c.33.45.64.9.95 1.3.3.44.6.82.83 1.15.1-.12.2-.3.37-.5l.54-.78.66-.94.72-1 .7-.98.64-.87v7.76h-.46v-6.06-.2-.22l-.8 1.1-.84 1.23c-.3.4-.56.8-.82 1.18l-.7 1.03c-.14-.16-.3-.37-.5-.63l-.6-.84-.64-.93-.63-.9c-.2-.28-.36-.53-.5-.75l-.34-.5v.22c.02.07.02.14.02.2v6.07h-.44v-7.76zm9.66 7.76v-7.42h4.66v.4h-4.2v3.08h3.77v.4h-3.8v3.13h4.37v.4h-4.8zm12.94-7.42v7.75c-.4-.5-.87-1.03-1.38-1.62-.5-.6-1.03-1.2-1.55-1.8-.52-.6-1.02-1.2-1.5-1.8-.5-.57-.93-1.1-1.3-1.6l-.2-.26.02.33v6.4h-.46v-7.76l1.37 1.65c.5.6 1.02 1.18 1.54 1.78.52.6 1.02 1.2 1.5 1.78.5.58.95 1.1 1.34 1.6l.2.28-.02-.34v-6.4h.44z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ad_woman"
    }
  }, [_c('rect', {
    attrs: {
      "id": "ad_women_bg_3",
      "width": "120",
      "height": "160.01",
      "x": "4113",
      "y": "266",
      "fill": "#EAFDFF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_bg_2",
      "fill": "#A0E7D8",
      "d": "M4113 340.54c17.37 9.74 37.37 16.85 60 21.33 22.63 4.47 42.63 4.9 60 1.33v51.87h-120v-74.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_bg_1",
      "fill": "#7DD4C1",
      "d": "M4113 349.48c19.3 7.96 39.3 13.32 60 16.1 20.7 2.77 40.7 2.86 60 .26V427h-120v-77.52z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_13",
      "fill": "#E3D0B0",
      "d": "M4223.18 348.5c5.17 23.44-13.52 69.9-16.93 78.5h-18.87l1.78-59.3c20.2-11.76 31.54-18.17 34.02-19.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_12",
      "fill": "#4A3421",
      "d": "M4172.75 266H4233c-6.64 40.05-13.02 65.4-19.15 76.05-9.37 3.38-46.47.44-66.8-3.97 6.9-9.28 11.05-17.7 15.2-29.12-5.7 10.05-13.6 20.14-20.43 27.82-2.3-.7-5.47-1.76-7-2.72 18.67-19.3 31.3-36.32 37.93-68.06z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_11",
      "fill": "#E3D0B0",
      "d": "M4174.45 266c.3 6.5-1.1 19.4-1.1 22.96-9.05 8.5-34.95 34.6-39.78 34.68-4.84.07-17.02-9.08-20.57-12.76V297.3c7.68 4.82 14.53 8.06 20.57 9.7 14.48-15.02 25.63-33.22 33.87-41h7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_10",
      "fill": "#EFDBBC",
      "d": "M4172.26 266c-5.32 7.93-11.4 16.62-12.86 20.06-1.46 3.43 2.23 14.72 7.54 17.9 3.55 2.13 6.34 7.9 8.38 17.28-14.12 7.12-22.6 13.93-25.42 20.44-8.78 20.22 10.55 64.3 16.1 85.32h23.2c1.47-30.54 1.6-49.05.43-55.53 2.3-4.9 21.66-19.74 31.62-24.96-4.4-8-14.66-17-13.78-20.8 1.04-4.46 22.3-30.27 25.53-33.23V266h-60.74z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_9",
      "fill": "#E3D0B0",
      "d": "M4184.6 277.93c3.66 5.8 2.2 18.04.3 22.42.15 0-16.15 5.17-15.34 6.16.5.63 1.22 1.82 1.6 2.4 1.76-.1 4.75-.93 7.97-1.94-.77 1.2-.98 2.17-1.5 3.16 2.95-.66 7.04-3.6 8.7-6.54 1.53 3.57 4.8 7.47 9.73 7.7-.06-.34-.6-1.5-.85-2.68 3.27 2.78 12.23 4.22 18.37 3.32.32-.05-10 7.26-9.25 16.27.58 6.77 6.76 13.88 5.6 20.2 1.12.55 9.93-1.6 11.1-1.5-.53-2.14-13.24-17.68-13.64-20.5.6-3.48 12.28-17.17 14.7-20.7-1.46-.3-34.42-5.35-34.22-5.35-.44-10.65 5.46-18.92 10.52-22.42-2.77-.02-6.2 3.4-8 3.22-2.76-.27-4.2-3.22-5.8-3.22z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_8",
      "fill": "#E3D0B0",
      "d": "M4227.05 292.03c1.8-3.05 3.25-6.77 5.95-7.15v8.15c-3.14 1.33-5.12 1-5.95-1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_7",
      "fill": "#E564AD",
      "d": "M4209.86 279.4c-11.14-.1-17.67 8.3-23.2 18.14-3.1-12.5-13.5-20.06-19.3-21.94.35-.54 3.94-7.1 5.66-9.6h-1.37c-3.67 4.12-11.56 18.1-12.46 20.33-1.42 3.46-5.36 15.45 9.16 19.9 3.82 1.18 12.77-1.88 18.3-5.34 5.95 5.34 9.42 8.5 22.6 8.82 5.54.13 10.06-1.44 13.57-4.72l10.17-11.9c-1.8.9-3.2 1.13-4.17.68-.9-.42-6.56-7.4-7.87-9.9-1.32-2.48.57-13.3 3.8-17.88h-2.47c-2.6 4.2-3.87 11.2-3.87 15.98-2.37-1.5-5.2-2.54-8.57-2.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_6",
      "fill": "#EB81BC",
      "d": "M4188.78 297.05c3.67 0 6.88 2.3 7.6 5.44.74 3.12-.6 3.75 1.9 7.23-2.78 0-6.97-.86-8.05-3.15-1.07-2.3-1.07-5.1-1.76-5.1-.7 0-3.63-.16-4-.16-.92.3.55 1.93-1.7 3.92-2.24 2-4.28 2.96-6.3 3.17 2.17-3.04 1.3-5.78 1.83-7.6.52-1.8 2.12-4.87 6.16-3.75.32.2 3.7 0 4.32 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_5",
      "fill": "#E564AD",
      "d": "M4186.96 299.72c1.58-2.3 5.9 0 5.33 3.6-1.48-1.86-3.74-3.27-5.34-2.95-.45 0-3 .25-3.26.24-.6 1.87-2.68 1.08-4.25 4.16-.04-2.88 1.6-5.8 4.25-5.04.2.14 2.86 0 3.26 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_4",
      "fill": "#FA92CC",
      "d": "M4188.37 297.55c-.67-.7-3.42-1.1-4.26-.3-.83.82-.9 4.1-.23 4.95.67.85 3.93.67 4.3 0-1.17-.7-1.4-3.82.2-4.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_3",
      "fill": "#E564AD",
      "d": "M4147.7 348.27c7-8.97 34.77-.66 41.3 23.08 5 0 22-19.03 33.1-21.43-.33-.9-.72-2.25-1.52-3.34-25.4 4.34-42.86 0-67.53-10.02-2.23 1.47-5.28 7.87-5.34 11.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_2",
      "fill": "#E3D0B0",
      "d": "M4185 336.64c.73.2 1.2-.77 1.5-1.88.24-.94 1.83-8.35 2-10.77.17-2.43-.93-13.7-1.58-13.6-.65.14.9 8.56.2 14-.54 4.4-2.28 9.62-2.42 10.23-.32 1.36-.44 1.82.3 2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_girl_1",
      "fill": "#C5AC82",
      "d": "M4185.6 335.54c.34.1.53-.27.57-.65.05-.4.6-2.13.28-2.22-.32-.08-1.07 1.38-1.23 2-.16.6.07.78.4.86z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ad_women_text",
      "fill": "#FFF",
      "d": "M4121.84 371.44h-.05l-1.22 6.2h2.47l-1.2-6.2zm-1.04-4.92h2.05l3.84 17.1h-2.47l-.73-3.68h-3.35l-.72 3.68h-2.46l3.83-17.1zm9.55 7.64h1.4c.44 0 .78-.06 1.04-.18.25-.12.44-.3.58-.52.14-.22.23-.5.28-.83.05-.33.07-.7.07-1.14 0-.44-.02-.82-.07-1.15-.05-.33-.15-.6-.3-.84-.16-.22-.37-.4-.64-.5-.28-.12-.64-.17-1.1-.17h-1.27v5.33zm-2.46-7.64h3.95c2.9 0 4.34 1.67 4.34 5.02 0 1-.17 1.84-.48 2.56-.3.7-.86 1.28-1.65 1.7l2.65 7.82h-2.6l-2.3-7.3h-1.47v7.3h-2.46v-17.1zm10.27 0h7.33v2.3h-4.87v5.02h4.24v2.3h-4.24v5.03h4.87v2.45h-7.33v-17.1zm15.7 9.87l-3.38-9.88h2.6l1.98 6.8h.04l1.98-6.8h2.6l-3.37 9.87v7.22h-2.46v-7.23zm6.92-5.85c0-.68.1-1.3.35-1.82.25-.53.56-.96.96-1.3.4-.35.84-.6 1.33-.8.5-.17 1-.25 1.5-.25s.98.08 1.47.26c.5.18.93.44 1.33.78.4.35.7.78.95 1.3.24.54.36 1.15.36 1.83v9.03c0 .7-.12 1.32-.36 1.84s-.56.95-.95 1.3c-.4.34-.84.6-1.33.78-.5.17-.98.26-1.48.26s-1-.1-1.5-.26c-.48-.18-.92-.44-1.3-.78-.4-.35-.72-.78-.97-1.3-.24-.52-.36-1.13-.36-1.84v-9.03zm2.45 9.03c0 .6.17 1.03.5 1.3.33.3.72.43 1.17.43.45 0 .84-.13 1.17-.4.32-.3.48-.73.48-1.32v-9.03c0-.6-.16-1.02-.5-1.3-.32-.28-.7-.42-1.16-.42-.45 0-.84.14-1.17.42-.33.28-.5.7-.5 1.3v9.03zm15.92.2c0 .55-.1 1.07-.3 1.55-.22.48-.5.9-.87 1.27-.36.36-.78.64-1.26.85-.5.2-1 .3-1.55.3s-1.07-.1-1.55-.3c-.48-.2-.9-.5-1.27-.85-.36-.37-.64-.8-.85-1.27-.2-.48-.32-1-.32-1.56v-13.25h2.47v13c0 .62.15 1.07.44 1.36.3.3.66.43 1.1.43.43 0 .8-.13 1.08-.42.3-.3.43-.74.43-1.35v-13h2.47v13.24zm-61.1 5.95h3.6c.8 0 1.46.12 2 .36.57.23 1.02.55 1.38.95.35.4.6.86.76 1.38.16.52.24 1.06.24 1.62v.62c0 .47-.04.86-.1 1.18-.08.32-.2.6-.34.84-.14.23-.32.44-.53.63-.2.18-.45.35-.72.5.58.3 1 .7 1.28 1.23.27.53.4 1.25.4 2.14v.97c0 1.5-.36 2.65-1.1 3.45-.72.8-1.9 1.2-3.5 1.2h-3.35v-17.1zm2.47 14.64h1.06c.5 0 .9-.07 1.17-.2.28-.16.5-.36.64-.6.15-.27.24-.57.27-.92.03-.36.05-.74.05-1.16 0-.44-.02-.82-.07-1.14-.05-.32-.15-.58-.3-.8-.16-.22-.37-.38-.64-.5-.27-.1-.63-.16-1.08-.16h-1.08v5.47zm0-7.63h1.1c.83 0 1.38-.2 1.66-.6.28-.42.42-1.02.42-1.8 0-.77-.16-1.35-.47-1.73-.3-.37-.88-.57-1.7-.57h-1v4.7zm7.8-7h7.34v2.3h-4.87v5h4.26v2.32h-4.25v5h4.88v2.46h-7.33v-17.1zm12.7 4.9h-.05l-1.22 6.2h2.46l-1.2-6.2zm-1.04-4.9h2.05l3.84 17.08h-2.47l-.73-3.67h-3.35l-.72 3.67h-2.46l3.83-17.1zm14.9 13.27c0 .53-.1 1.04-.3 1.52-.2.48-.47.9-.83 1.26-.35.36-.76.65-1.24.86-.47.22-.98.33-1.53.33-.47 0-.94-.07-1.42-.2-.5-.12-.92-.34-1.3-.66-.4-.3-.7-.7-.96-1.22-.25-.5-.37-1.16-.37-1.95v-9.4c0-.57.1-1.1.3-1.57.18-.48.45-.9.8-1.25.36-.34.78-.62 1.27-.82.5-.2 1.04-.3 1.63-.3.56 0 1.1.1 1.57.3.48.2.9.48 1.25.84.36.36.63.8.84 1.3.2.5.3 1.05.3 1.65v.96h-2.45v-.82c0-.47-.14-.9-.4-1.24-.3-.35-.66-.53-1.12-.53-.6 0-1.02.2-1.22.57-.2.37-.3.85-.3 1.43v8.74c0 .5.12.9.33 1.24.22.35.6.52 1.17.52.16 0 .34-.03.52-.1.2-.04.36-.13.5-.26.16-.13.3-.3.38-.53.1-.22.15-.5.15-.84v-.85h2.46V399zm2-13.27h2.47v7.32h3.04v-7.32h2.47v17.1h-2.46v-7.62h-3.03v7.62h-2.46v-17.1zm14.77 0h3.6c.78 0 1.45.12 2 .36.56.23 1.02.55 1.37.95.36.4.6.86.76 1.38.15.52.23 1.06.23 1.62v.62c0 .47-.04.86-.1 1.18-.08.32-.2.6-.33.84-.15.23-.33.44-.53.63-.2.18-.45.35-.73.5.58.3 1 .7 1.28 1.23.27.53.4 1.25.4 2.14v.97c0 1.5-.36 2.65-1.1 3.45-.72.8-1.9 1.2-3.5 1.2h-3.35v-17.1zm2.46 14.64h1.06c.5 0 .88-.07 1.16-.2.28-.16.5-.36.64-.6.15-.27.23-.57.27-.92.03-.36.04-.74.04-1.16 0-.44 0-.82-.06-1.14-.05-.32-.15-.58-.3-.8-.15-.22-.36-.38-.64-.5-.27-.1-.63-.16-1.08-.16h-1.1v5.47zm0-7.63h1.1c.83 0 1.38-.2 1.66-.6.27-.42.4-1.02.4-1.8 0-.77-.14-1.35-.46-1.73-.3-.37-.88-.57-1.7-.57h-1v4.7zm7.67-2.98c0-.7.12-1.3.36-1.82.24-.53.56-.97.96-1.3.4-.36.83-.62 1.32-.8.5-.17 1-.26 1.5-.26.48 0 .98.1 1.47.27.5.17.94.43 1.34.78.4.34.7.78.95 1.3.23.54.35 1.14.35 1.83v9.03c0 .7-.12 1.3-.36 1.83-.25.52-.57.95-.96 1.3-.4.34-.84.6-1.33.77-.48.18-.98.27-1.47.27-.5 0-1-.1-1.5-.27-.48-.17-.92-.43-1.3-.78-.4-.34-.73-.77-.97-1.3-.24-.5-.36-1.13-.36-1.83v-9.04zm2.46 9.03c0 .58.17 1.02.5 1.3.33.28.72.42 1.17.42.45 0 .84-.14 1.17-.42.32-.28.5-.72.5-1.3v-9.04c0-.6-.18-1.03-.5-1.3-.33-.3-.72-.43-1.17-.43-.45 0-.84.14-1.17.42-.33.28-.5.72-.5 1.3v9.04zm7.96-13.07h3.64c1.4 0 2.47.4 3.2 1.16.75.77 1.12 1.85 1.12 3.25v8c0 1.6-.4 2.77-1.17 3.53-.77.76-1.9 1.14-3.35 1.14h-3.43v-17.1zm2.46 14.8h1.13c.7 0 1.2-.18 1.5-.53.28-.34.42-.88.42-1.62v-8.23c0-.68-.14-1.2-.4-1.56-.28-.38-.78-.57-1.5-.57h-1.14v12.5zm9.67-4.93l-3.37-9.87h2.6l1.98 6.8h.05l2-6.8h2.6l-3.4 9.87v7.22h-2.45v-7.22zm-83.8 16.97h1.4c.42 0 .77-.06 1.02-.18.26-.13.46-.3.6-.53.13-.22.22-.5.27-.82.05-.33.07-.7.07-1.14 0-.43 0-.8-.06-1.13-.05-.33-.15-.6-.3-.84s-.37-.4-.64-.52c-.27-.1-.63-.16-1.08-.16h-1.28v5.33zm-2.47-7.63h3.95c2.9 0 4.34 1.67 4.34 5 0 1-.15 1.86-.47 2.57-.3.72-.86 1.3-1.65 1.73l2.65 7.8h-2.6l-2.3-7.3h-1.46v7.3h-2.46v-17.1zm10.27 0h7.33v2.3h-4.87v5.02h4.26v2.3h-4.25v5.02h4.88v2.45h-7.33v-17.1zm12.7 4.92h-.06l-1.22 6.2h2.46l-1.2-6.2zm-1.05-4.92h2.05l3.84 17.1h-2.47l-.73-3.68h-3.35l-.72 3.67h-2.46l3.83-17.1zm7.1 0h3.63c1.4 0 2.47.38 3.2 1.16.75.78 1.12 1.86 1.12 3.25v8c0 1.6-.4 2.78-1.17 3.54-.78.75-1.9 1.13-3.36 1.13h-3.43v-17.1zm2.45 14.8h1.14c.68 0 1.17-.2 1.46-.53.3-.33.43-.87.43-1.6v-8.25c0-.67-.14-1.2-.42-1.56-.27-.37-.77-.56-1.5-.56h-1.13v12.5zm9.67-4.94l-3.37-9.86h2.6l1.98 6.8h.05l1.98-6.8h2.6l-3.37 9.86v7.23h-2.48v-7.23zm6.7-6.36c0-.5.08-.97.28-1.42.2-.44.45-.83.8-1.16.33-.33.72-.6 1.17-.78.45-.2.94-.3 1.45-.3.6 0 1.14.13 1.63.37.5.24.9.58 1.22 1 .16.23.3.44.4.63.1.2.18.4.25.62.06.2.1.46.13.73.02.27.04.6.04.96 0 .4-.02.75-.03 1.03 0 .28-.02.53-.06.74-.02.2-.06.38-.1.54-.05.16-.12.3-.2.43l-1.66 2.83c-.12.2-.2.4-.3.6-.07.2-.1.4-.1.62v1.93h-2.47v-2.23c0-.35.05-.7.17-1 .1-.33.25-.64.43-.94l1.54-2.5c.14-.2.23-.43.27-.67.04-.24.06-.48.06-.72v-1.27c0-.34-.12-.63-.35-.87-.24-.24-.52-.36-.86-.36-.3 0-.57.1-.84.3-.28.22-.4.53-.4.93v1.4h-2.47v-1.43zm2.45 11.14h2.46v2.45h-2.46v-2.45z"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_19",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4249 375h136.62c4.75 0 8.84 3.34 9.8 8l6.58 32h-153v-40z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_18",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4249 423v-8h169.73c2.9 0 5.27 1.8 5.27 4s-2.36 4-5.27 4H4249z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_17",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4500.4 278h32.2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_16",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 286h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_15",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4519 286h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_14",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 295h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_13",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4519 295h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_12",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 303h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_11",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4519 303h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_10",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 311h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_9",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 319h24",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_8",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 336h24",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_7",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4519 311h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 327h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_5",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4519 327h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 344h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4519 344h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4505 352h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bus_stop_1",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M4519 352h10",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "dylan"
    }
  }, [_c('path', {
    attrs: {
      "id": "dylan_left_hand",
      "fill": "#F0CDB8",
      "d": "M3831.7 350.72c.16 1.36 1.2 2.02 2.3 3.52 1.26 1.76 1.5 5.12 3 7.82-.27.7-2.46-.33-3-1.42-.54-1.1-.96-2-1.13-2.26-.18-.27-.54-.22-.62.06-.08.3.7 10.18.54 10.7-.2.5-1.44.64-1.7.16-.28-.48-1.1-8.3-1.23-8.5-.13-.18-.4-.05-.5.07-.1.12 1 8.44.85 8.76-.15.33-1.45.4-1.62.17-.17-.24-1.12-8.55-1.28-8.73-.17-.17-.45-.12-.55.06-.1.18 1.1 8.15.93 8.52-.16.36-1.42.5-1.57.16-.16-.33-1.3-8.36-1.42-8.46-.13-.1-.3-.08-.4.04-.1.12.43 6.14.27 6.5-.17.34-1.1.5-1.3.12-.18-.4-1.1-15.12-1.2-15.93-.37-2.7.96-5.7 4.26-6.04 3.3-.33 5.03 1.78 5.37 4.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_arm_bottom",
      "fill": "#353535",
      "d": "M3824.43 318.04c-3.94.4-6.8 3.94-6.4 7.87l.05.3 3.8 25.76c.2 1.27 1.35 2.16 2.62 2.03l7.36-.78c1.27-.14 2.22-1.25 2.14-2.52l-1.65-26c-.25-3.94-3.66-6.93-7.62-6.7l-.3.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_leftt_arm_top",
      "fill": "#353535",
      "d": "M3821.74 291c-3.92.36-6.82 3.88-6.48 7.87l2.27 26.53c.34 4 3.8 6.94 7.73 6.6 3.92-.36 6.82-3.88 6.48-7.87l-2.27-26.53c-.34-4-3.8-6.94-7.73-6.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_shoe_4",
      "fill": "#353535",
      "d": "M3823.97 434H3811v14h28c-.23-4-2.17-6.34-5.8-7-3.64-.66-6.72-3-9.23-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_shoe_3",
      "fill": "#787B78",
      "d": "M3811 446v2h28c-.1-.92-.18-1.6-.27-2H3811z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_left_shoe_2",
      "fill": "#787B78",
      "points": "3829 440.575943 3827.97303 442 3824 439.088172 3825.26134 438",
      "transform": "matrix(-1 0 0 1 7653 0)"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_left_shoe_1",
      "fill": "#787B78",
      "points": "3826 438.4 3825.01991 440 3821 437.460322 3822.02091 436",
      "transform": "matrix(-1 0 0 1 7647 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_leg_bottom",
      "fill": "#ABAFAB",
      "d": "M3817.5 379c-5.25 0-9.5 4.25-9.5 9.5V434h19v-45.5c0-5.25-4.25-9.5-9.5-9.5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_left_leg_top",
      "width": "19",
      "height": "60",
      "x": "3808",
      "y": "338",
      "fill": "#ABAFAB",
      "transform": "matrix(-1 0 0 1 7635 0)",
      "rx": "9.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_shoe_4",
      "fill": "#3D3D3D",
      "d": "M3802.97 434H3790v14h28c-.23-4-2.17-6.34-5.8-7-3.64-.66-6.72-3-9.23-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_shoe_3",
      "fill": "#7C7F7C",
      "d": "M3790 446v2h28c-.1-.92-.18-1.6-.27-2H3790z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_right_shoe_2",
      "fill": "#7C7F7C",
      "points": "3807 440.575943 3805.97303 442 3802 439.088172 3803.26134 438",
      "transform": "matrix(-1 0 0 1 7609 0)"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_right_shoe_1",
      "fill": "#7C7F7C",
      "points": "3805 438.4 3804.01991 440 3800 437.460322 3801.02091 436",
      "transform": "matrix(-1 0 0 1 7605 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_leg_bottom",
      "fill": "#ABAFAB",
      "d": "M3796.5 379c-5.25 0-9.5 4.25-9.5 9.5V434h19v-45.5c0-5.25-4.25-9.5-9.5-9.5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_right_leg_top",
      "width": "19",
      "height": "60",
      "x": "3787",
      "y": "338",
      "fill": "#ABAFAB",
      "transform": "matrix(-1 0 0 1 7593 0)",
      "rx": "9.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hip",
      "fill": "#ABAFAB",
      "d": "M3827 329h-41v5.5c0 11.32 9.18 20.5 20.5 20.5s20.5-9.18 20.5-20.5V329z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_bag_3",
      "width": "43",
      "height": "60",
      "x": "3777",
      "y": "283",
      "fill": "#5B7046",
      "transform": "matrix(-1 0 0 1 7597 0)",
      "rx": "21.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hoodie_2",
      "fill": "#BCC1BC",
      "d": "M3824.22 287.88c-4.86-6.26-26.87-6.48-32.16-.77-12.6 13.58-4.4 38.76-7.4 44.43-2.98 5.67-1.3 9.36 0 11.46 5.63 9 37.2 11.92 44.1.8 1.5-2.43 2.1-9.85-.93-15.26-3.03-5.4-1.5-37.94-3.6-40.66z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hoodie_1",
      "fill": "#353535",
      "d": "M3822.9 282.98c-.95-8.57-25.32-10.02-26.77 0-1.45 10.02 9.48 12.77 15.75 7.13 7.1 3.18 11.94 1.45 11-7.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_bag_2",
      "fill": "#778F5F",
      "d": "M3793.06 287c-2.48.03-5.7 2.38-4.94 4.9 13.63.07 11.1 18.13 7.54 31.02 0 .9.18 4.03 0 5.08 10.26-9.6 12.85-36.78-2.6-41z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_bag_1",
      "fill": "#778F5F",
      "d": "M3828.35 292.74c-.5-3.35-3.05-5.5-5.35-5.74 2.2 12.1 2.68 26.9 3.83 38 1.63-12.76 3.04-22.1 1.52-32.26z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_hand",
      "fill": "#F0CDB8",
      "d": "M3794.05 351.2c0 1.34.94 2.1 1.85 3.7 1.05 1.88.93 5.23 2.1 8.06-.34.65-2.36-.58-2.77-1.7-.4-1.15-.72-2.08-.86-2.37-.14-.3-.5-.28-.6 0-.12.27-.4 10.16-.62 10.64-.22.5-1.45.5-1.67 0-.2-.5-.18-8.32-.28-8.53-.1-.2-.38-.1-.5 0-.1.12.1 8.48-.1 8.8-.18.3-1.45.24-1.6 0-.13-.27-.18-8.6-.32-8.8-.13-.18-.42-.16-.53 0-.12.18.2 8.2 0 8.54-.2.35-1.43.35-1.55 0-.1-.35-.36-8.42-.48-8.53-.12-.1-.28-.1-.4 0-.1.1-.23 6.14-.43 6.47-.2.33-1.14.4-1.28 0-.14-.4.52-15.1.5-15.9-.06-2.73 1.56-5.57 4.8-5.57 3.25 0 4.7 2.27 4.73 5.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_arm_bottom",
      "fill": "#353535",
      "d": "M3790 318c-3.87 0-7 3.14-7 7v.3l.97 23.9c.1 2.68 2.3 4.8 5 4.8h2.07c2.68 0 4.88-2.12 5-4.8l.96-23.9c.16-3.88-2.85-7.14-6.72-7.3h-.28z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_right_arm_top",
      "width": "14",
      "height": "41",
      "x": "3783",
      "y": "291",
      "fill": "#353535",
      "transform": "matrix(-1 0 0 1 7580 0)",
      "rx": "7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_neck",
      "fill": "#E5BDA6",
      "d": "M3814.5 280.54c-.4 2.6-.6 4.4.5 5.84-.28.54-.7 2.18-2.96 2.54-3.1.5-6.48-1.3-7.04-2.54 1-1.46 1.1-2.94.5-5.84.74-2.1 7.97-2.02 9 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_face",
      "fill": "#F0CDB8",
      "fill-rule": "nonzero",
      "d": "M3792.75 264.05c-1-.6-2.46-1.35-4.1 0-1.4 1.15-.35 5.68 1.55 8.2 1.88 2.48 4.93 3 6.13 2.04 2.8 6.1 5.73 8.7 13.3 8.7 10.67 0 14.37.68 14.37-21 0-15.32-4.12-21-14.37-21-9.2-.05-19.4 4.8-16.88 23.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_mouth_bottom",
      "fill": "#DFB39B",
      "d": "M3814.8 277h-7.66c-.8 0 2.05 1 4.6 1 2.56 0 3.77-1 3.06-1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_mouth_top",
      "fill": "#D3A185",
      "d": "M3815.75 277h-9.58c-1 0 2.56-2 5.76-2 3.2 0 4.7 2 3.82 2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_ear",
      "fill": "#E5BDA6",
      "d": "M3792.92 268.28c-.96-1.97-2.46-3.8-4.3-3.15-1.83.65.52 7.88 5.38 7.87-.56-.34-2.1-1.92-2.15-3.15-.05-1.23.36-1.85 1.07-1.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_nose",
      "fill": "#DFB39B",
      "d": "M3812.9 263.77c0-.98-2.54-1.07-2.54 0 0 1.06-.8 6.62 0 7.6.82 1 3.2.66 3.58 0 .37-.65-1.04-6.62-1.04-7.6z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_right_cheek",
      "cx": "3802",
      "cy": "272",
      "r": "3",
      "fill": "#EDC7B2",
      "transform": "matrix(-1 0 0 1 7604 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_left_cheek",
      "cx": "3819",
      "cy": "272",
      "r": "3",
      "fill": "#EDC7B2",
      "transform": "matrix(-1 0 0 1 7638 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_eye_whites",
      "fill": "#FFF",
      "d": "M3807 264.36c-1.3-3.94-7.13-4.54-8-1.13 0 4.6 7.05 5 8 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_right_pupil",
      "cx": "3802",
      "cy": "264",
      "r": "2",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 7604 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_eye_whites",
      "fill": "#FFF",
      "d": "M3815 264.36c1.3-3.94 7.13-4.54 8-1.13 0 4.6-7.05 5-8 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_left_pupil",
      "cx": "3818",
      "cy": "264",
      "r": "2",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 7636 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_brow",
      "fill": "#33261A",
      "d": "M3814.02 260.05c.27-1.36 8.8-1.38 8.97-.17.16 1.22-1.63.64-3.98.87-2.35.23-5.27.66-5-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_brow",
      "fill": "#33261A",
      "d": "M3806.98 260.05c-.27-1.36-8.8-1.38-8.97-.17-.16 1.22 1.63.64 3.98.87 2.35.23 5.27.66 5-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hair",
      "fill": "#7F9568",
      "d": "M3790.38 263.03c3.74.8 4.7 7.98 5.2 8.5.5.53 1.82.72 1.78 0-.03-.7-1.77-8.5.64-15.53-1 .1-3.67 1.13-8 3.07l.38 3.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hat_2",
      "fill": "#1C1C1C",
      "d": "M3809.76 240c-14.4.62-19.9 1.08-19.76 20 7.6-4.3 28.98-4.58 34-2.4-.14-10.72-5.2-17.97-14.24-17.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hat_1",
      "fill": "#353535",
      "d": "M3828.74 255.8c-6.72-5.7-25.54-4.4-30.82.1-1.72 1.45-.83 2.46 1 1.98 3.64-.97 23-1.46 28.72-.08 2.18.53 3.45 0 1.1-2z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "dylan_house"
    }
  }, [_c('g', {
    attrs: {
      "id": "dylan_shadow"
    }
  }, [_c('path', {
    attrs: {
      "id": "dylan_shadow_left_arm_fore",
      "fill": "#E2B56C",
      "d": "M3338.5 318.96c.44.07.87.1 1.3.1.77-.05 14.45.34 14.83.2.37-.13.3-1.02-.02-1.2-.3-.18-5.9-.2-6-.3-.12-.1-.13-.26-.02-.38.1-.1 7.6-.48 7.94-.6.32-.1.3-1.27-.03-1.46-.33-.18-7.8.25-7.95.14-.16-.1-.2-.37 0-.5.16-.14 7.92-.32 8.15-.45.24-.13.27-1.33-.02-1.5-.3-.17-8.07.15-8.18.04-.1-.1-.2-.36 0-.46.2-.1 7.47-.2 7.94-.4.46-.22.42-1.4-.03-1.6-.44-.2-9.66-.3-9.9-.4-.27-.1-.3-.43-.02-.57.26-.13 1.12-.43 2.17-.84 1.05-.4 2.16-2.34 1.55-2.65-2.62 1.17-5.74 1.1-7.46 2.13-1.18.7-1.85 1.4-2.72 1.7-.9-1.1-2.23-1.8-3.75-1.85l-21.43-.52c-3.65-.08-6.7 2.8-6.77 6.46v.28c.06 3.66 3.07 6.57 6.73 6.5h.28l21.4-1.27c.73-.05 1.42-.25 2.03-.57z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_shadow_left_arm_top",
      "width": "13.24",
      "height": "37.24",
      "x": "3307.44",
      "y": "283.02",
      "fill": "#E2B56C",
      "transform": "matrix(-1 0 0 1 6628.115 0)",
      "rx": "6.62"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_shadow_right_arm_fore",
      "fill": "#E2B56C",
      "d": "M3347.22 341.98c.22 3.14.87 13.67 1 14 .17.35 1 .2 1.15-.14.15-.32-.32-5.93-.23-6.04.1-.1.23-.13.35-.04.1.1 1.1 7.57 1.25 7.9.13.3 1.24.18 1.4-.16.13-.34-.92-7.77-.83-7.93.08-.17.33-.22.48-.05.14.16.98 7.9 1.13 8.12.15.23 1.3.15 1.43-.15.14-.32-.84-8.07-.75-8.18.1-.1.34-.23.45-.04.1.18.84 7.45 1.08 7.9.24.44 1.34.3 1.5-.16.15-.47-.55-9.7-.48-9.95.07-.26.4-.32.55-.06.15.26.52 1.1 1 2.1.47 1.03 2.4 1.98 2.64 1.34-1.32-2.52-1.53-5.65-2.66-7.28-.63-.92-1.24-1.5-1.62-2.14.63-.43 1.02-1.16.97-1.96l-1.53-23.9c-.23-3.62-3.4-6.38-7.1-6.15l-.27.04c-3.68.38-6.34 3.62-5.95 7.23 0 .1.02.18.03.27l3.56 23.7c.12.82.7 1.48 1.46 1.74z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_shadow_right_arm_top",
      "fill": "#E2B56C",
      "d": "M3345.9 284.18c-3.64.32-6.33 3.5-6 7.14l2.1 24.1c.32 3.62 3.52 6.3 7.15 6 3.63-.33 6.3-3.53 6-7.16l-2.1-24.1c-.33-3.62-3.53-6.3-7.16-5.98z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_shadow_body",
      "fill": "#E2B56C",
      "d": "M3346.84 253.73c.06 1.12.1 2.3.1 3.54 0 9.7-.8 14.55-2.72 17 .53.68.86 1.45.95 2.3.18 1.6.13 2.97-.1 4.08.6.42 1.13.9 1.53 1.4 1.94 2.53.54 32.62 3.3 37.62 2.78 5 2.24 11.87.87 14.1-6.3 10.3-35.23 7.6-40.38-.73-1.2-1.94-2.75-5.35 0-10.6 2.73-5.25-4.77-28.53 6.75-41.08.78-.84 1.93-1.55 3.36-2.1-.1-.83-.07-1.73.07-2.7.26-1.83 1.35-3.24 2.92-4.28-.73-1-1.37-2.22-2-3.62-1.1.88-3.93.4-5.65-1.9-1.75-2.32-2.72-6.52-1.43-7.6.56-.45 1.1-.64 1.6-.68l-.18-.04-.32-3.25h-.03c-.02-.15-.02-.3-.02-.45-.03-16.78 5.08-17.2 18.28-17.74 7.47-.3 12 4.94 12.98 13.03 1.57.57 2.94 1.3 4 2.23 2.16 1.93 1 2.44-1.03 1.93-.73-.2-1.7-.35-2.86-.47z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "dad",
    attrs: {
      "id": "dad"
    }
  }, [_c('g', {
    attrs: {
      "id": "dad_left_arm"
    }
  }, [_c('path', {
    attrs: {
      "id": "dad_left_arm_fore",
      "fill": "#E2B56C",
      "d": "M3543.1 66.38c-.27-.44-.5-.9-.7-1.38-.46-1.08-9.97-20-10-20.62-.06-.62 1.26-1.1 1.73-.78.46.3 4.15 8.17 4.37 8.24.22.07.45-.02.54-.24.1-.23-4.28-11-4.33-11.53-.04-.53 1.66-1.28 2.13-.95.47.34 4.74 11.08 5 11.23.26.16.65 0 .73-.32.08-.33-4.73-11.33-4.7-11.75.04-.42 1.76-1.27 2.2-.97.43.3 5.05 11.42 5.27 11.5.22.07.65.04.67-.3.02-.34-4.6-10.62-4.6-11.4 0-.8 1.7-1.53 2.3-1.03.58.5 6.75 13.34 7.06 13.64.3.3.8.1.83-.36.02-.47-.1-1.87-.2-3.62s1.94-4.6 2.8-3.95c.04 4.45 2.18 8.78 1.82 11.88-.3 2.62-1.18 3.65-.47 5.38.13.22.24.45.35.7l11.86 26.64c1.62 3.63 0 7.88-3.64 9.5-3.63 1.62-7.9-.02-9.5-3.65l-11.5-25.84z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dad_left_arm_top",
      "fill": "#E2B56C",
      "d": "M3605.68 79.57l-.08-.4-.08-.3c-1.35-4.83-6.32-7.74-11.22-6.5l-23.26 5.8.57 2.26-11.67 2.92c-3.74.93-6.02 4.72-5.08 8.47.93 3.74 4.72 6.02 8.47 5.08L3575 94l.55 2.23 23.25-5.8c4.86-1.2 7.86-6 6.88-10.86z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dad_body",
      "fill": "#E2B56C",
      "d": "M3621.84 68.14c1.76.8 2.2 1.9 2.16 2.82 0 .1 0 .2-.02.28 16.88 2.05 14.5 24.26 15.36 47.66.66.6 1.56 1.38 1.65 3 .08 1.64-.64 2.53-1.5 3.18-6.65 4.15-44.7 3.62-52.9 0-.74-.1-1.4-1.55-1.58-3.17-.18-1.6 1-3 1.58-3.64 1.25-20.4-1.33-46.9 17.1-47.13-.16-.94.08-1.92 1.28-2.7-.76-.16-1.45-.36-2.03-.62-3.66-1.6-4.94-7-5.1-9.68-1.47-4.12-1.85-9.27-1.85-13.17 0-2.87.2-5.4.62-7.6-.66-9.66 3.8-15.42 18.2-15.35 17.2.1 21.63 5.74 19.8 23 1.6 1.37 1.7 4.13.86 6.86-.93 3-2.62 4.18-5.16 4.1-.05.2-.1.4-.18.6.02 0 .04.03.05.06 0 5.54-3.26 10.2-8.36 11.52z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dad_right_arm_fore",
      "fill": "#E2B56C",
      "d": "M3652.1 121.78c0 .1-.03.18-.05.27-.42 1.9-1.8 2.18-3.66 4.15-2.16 2.3-2.98 7.05-5.6 10.66.32 1.03 3.74-.05 4.7-1.52.97-1.47 1.72-2.67 2.02-3.03.3-.35.83-.2.9.2.1.42-2.44 14.44-2.25 15.2.2.74 2.06 1.17 2.53.53.47-.64 2.77-11.67 3-11.93.2-.26.6-.03.73.16.14.2-2.66 11.9-2.47 12.4.2.5 2.13.82 2.42.5.28-.3 2.85-12.03 3.12-12.25.26-.2.68-.1.8.18.13.28-2.75 11.47-2.55 12.02.2.55 2.07.96 2.34.5.27-.46 3.07-11.73 3.28-11.86.22-.13.46-.06.6.13.14.18-1.48 8.7-1.28 9.23.2.52 1.6.93 1.93.4.33-.52 3.72-21.4 4-22.55.1-.45.17-.9.2-1.37l5.87-27.6c.86-4-1.7-7.94-5.72-8.8-4-.85-7.95 1.7-8.8 5.72l-5.97 28.05-.1.63z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dad_right_arm_top",
      "fill": "#E2B56C",
      "d": "M3623.6 77.66c-2.06 5.06.4 10.82 5.45 12.86L3651 99.4l.9-2.3 10.9 4.4c3.8 1.53 8.13-.3 9.66-4.1 1.53-3.8-.3-8.1-4.1-9.64l-10.9-4.4.93-2.3-21.95-8.86c-5.06-2.04-10.82.4-12.86 5.46z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "dad_speech_bubble"
    }
  }, [_c('path', {
    attrs: {
      "id": "dad_speechbubble_2",
      "fill": "#FBD79E",
      "d": "M3560.44 55.95c-11.84 0-21.44-8.05-21.44-17.97 0-9.93 9.6-17.98 21.44-17.98 11.84 0 21.44 8.05 21.44 17.98 0 4.08-1.62 7.85-4.37 10.87.08 2.7 8.05 9.47 11.5 11.15-7.12-.83-15.28-5.84-16.48-7.17-3.44 1.97-7.6 3.12-12.08 3.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dad_speechbubble_1",
      "fill": "#E2B56C",
      "d": "M3548.2 30.54l.75 2.64 1.65-2.2.85.7-2.1 2 2.82.34-.22 1.1-2.66-.74 1.15 2.53-1.02.36-.8-2.7-1.7 2.22-.88-.73 2.1-1.9-2.77-.3.22-1.1 2.67.75-1.13-2.6 1.06-.36zm5.8 3.58c.1-.43.22-.8.38-1.06.17-.28.35-.5.55-.65.2-.14.4-.23.64-.27.23-.05.44-.05.66 0 .2.04.4.1.6.23.2.1.37.27.5.48.13.22.22.48.26.8.04.32.02.7-.07 1.16-.1.45-.2.8-.38 1.1-.16.27-.34.48-.54.63-.2.14-.4.23-.63.27-.22.03-.44.02-.65-.02-.2-.04-.4-.12-.6-.23-.2-.1-.37-.28-.5-.5-.13-.2-.22-.46-.27-.78-.05-.32-.03-.7.06-1.15zm.97.2c-.1.53-.1.92.04 1.17.14.24.3.38.5.42.1.02.2.02.3 0 .1-.03.2-.1.3-.18.1-.1.18-.24.26-.42.08-.17.15-.4.2-.7.06-.3.1-.53.08-.73 0-.2-.04-.36-.1-.5-.04-.12-.1-.22-.2-.28-.1-.07-.18-.1-.28-.13-.2-.05-.42.02-.62.2-.2.2-.36.56-.47 1.1zm2 5.7c.07-.44.2-.8.36-1.07.16-.28.35-.5.55-.64.2-.14.4-.24.64-.28.22-.04.44-.04.65 0 .2.04.42.12.6.23.2.1.37.28.5.5.13.2.22.46.27.78.05.32.03.7-.06 1.17-.1.44-.2.8-.38 1.08-.16.28-.34.5-.54.64-.2.15-.4.24-.64.27-.22.02-.44.02-.65-.02-.2-.04-.42-.12-.6-.24-.2-.1-.37-.27-.5-.48-.13-.2-.22-.48-.27-.8-.05-.32-.03-.7.06-1.15zm.95.18c-.1.54-.1.93.04 1.18.12.25.28.4.48.43.1.03.2.03.3 0 .1 0 .2-.06.3-.15.1-.1.18-.23.26-.4.1-.2.16-.44.22-.74.05-.28.07-.52.06-.7 0-.2-.03-.37-.1-.5-.04-.13-.1-.23-.2-.3-.08-.06-.17-.1-.28-.12-.1-.02-.2 0-.3 0-.1.04-.2.1-.3.2-.1.1-.2.23-.27.4-.08.2-.15.43-.2.72zm2.25-7.4l.7.56-6.65 8.73-.72-.52 6.67-8.77zm6.13 8.23l-2-.4-.98 2.2-.94-.18.98-2.2-1.35-.26.37-.85 1.36.27.78-1.72-1.28-.25.36-.84 1.3.26.95-2.07.95.17-.94 2.07 2 .4.93-2.08.95.2-.94 2.06 1.33.26-.38.83-1.32-.24-.78 1.7 1.28.26-.4.84-1.25-.25-1 2.2-.93-.18.98-2.2zm-1.62-1.23l2 .4.77-1.73-2-.4-.77 1.73zm10.57-3.8l1.14.2-.94 4.78-.7 2.38-.68-.13.24-2.47.93-4.77zm-2 8.94c.06-.25.17-.43.34-.55.16-.12.36-.16.6-.1.25.04.43.15.55.32.12.17.16.38.1.63-.04.23-.15.4-.32.53-.18.12-.4.15-.64.1-.25-.04-.42-.15-.53-.33-.12-.17-.15-.38-.1-.6z"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "mom"
    }
  }, [_c('g', {
    attrs: {
      "id": "mom_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "mom_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "mom_right_hand",
      "fill": "#E2B56C",
      "d": "M3399.18 80.28c1.3-.77 4.2-2.4 6.78-7.08 1.22-2.24 4.68-4.13 6.8-7.06.87-.04.9 2.8 0 3.93-.88 1.1-1.6 2-1.8 2.32-.22.3.03.67.37.62.34-.05 10.5-5.73 11.13-5.8.63-.05 1.43 1.23 1.05 1.76-.36.52-8.27 5.2-8.42 5.45-.14.23.13.45.3.5.2.06 8.5-5.2 8.93-5.18.44 0 1.2 1.37 1.02 1.67-.17.3-8.55 5.37-8.65 5.63-.1.26.1.54.33.56.24.03 8.14-5.14 8.62-5.14.47 0 1.26 1.3.97 1.62-.3.33-8.27 5.46-8.3 5.65-.06.2.06.36.23.4.18.07 6.34-3.44 6.8-3.43.45 0 1.12.94.8 1.32-.32.4-10.72 6.4-13.33 7.34-2.6.93-7.4 2.64-8.58 3.34l-5.04-8.42z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_right_arm_bottom",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3412.67 87.55l-7.55-13.57c-.2-.34-.58-.45-.92-.26l-33.54 18.5c-4 2.2-5.44 7.16-3.26 11.1l.28.5c2.18 3.9 7.17 5.3 11.16 3.1l33.54-18.5c.3-.17.46-.58.3-.87z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_right_arm_top",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3381.2 103.6l.28-.5c2.17-3.94.7-8.9-3.28-11.13l-26.84-14.95c-3.98-2.22-8.95-.84-11.1 3.1l-.3.5c-2.16 3.92-.7 8.9 3.3 11.1l26.83 14.96c3.97 2.22 8.94.84 11.1-3.1z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_body",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3310.04 137.4h50.27c-2.67-25.18-4.05-39.8-4.15-43.87-.14-6.1-9.7-22.16-22.45-22.1-12.75.08-22.8 8.86-23.66 22.1v43.86z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_neck",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3340.6 63.08c-1.42 4.84-1.05 8.32 1.4 10.64-2.92 3-11.76 2.9-16 .5 1.4-2.43 3.3-5.33.94-11.14.47-7.25 14.6-6.28 13.65 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_left_hand",
      "fill": "#E2B56C",
      "d": "M3320.87 148.04c0 1.5-.1 4.8 2.58 9.37 1.28 2.2 1.13 6.1 2.55 9.4-.4.76-2.85-.67-3.35-2s-.88-2.4-1.05-2.74c-.17-.33-.6-.3-.73 0-.13.32-.47 11.84-.74 12.4-.27.57-1.77.6-2.03 0-.25-.58-.22-9.7-.34-9.94-.13-.24-.46-.12-.6 0-.14.13.1 9.87-.12 10.23-.22.36-1.77.3-1.93 0-.16-.3-.22-10-.4-10.23-.15-.22-.5-.2-.63 0-.14.2.24 9.55 0 9.95-.24.4-1.74.4-1.88 0-.15-.4-.45-9.8-.6-9.95-.14-.13-.34-.12-.48 0-.13.13-.28 7.15-.52 7.53-.24.38-1.37.47-1.54 0-.16-.47 0-12.37.54-15.06.53-2.7 1.52-7.65 1.52-9l9.75.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_left_arm_bottom",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3308.63 156h15.7c.38 0 .67-.3.67-.67V117.2c0-4.54-3.67-8.2-8.2-8.2h-.6c-4.53 0-8.2 3.66-8.2 8.2v38.13c0 .33.3.67.63.67z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_left_arm_top",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3316.2 126h.6c4.53 0 8.2-3.67 8.2-8.2V87.2c0-4.53-3.67-8.2-8.2-8.2h-.6c-4.53 0-8.2 3.67-8.2 8.2v30.6c0 4.53 3.67 8.2 8.2 8.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_face",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3319 48.67c0 10.9 8 20.33 16.8 20.33 11.1 0 15.4-9.5 15.4-18.74 0-14.57-6.3-21.26-16.18-21.26-8.85-.05-16.02 8.7-16.02 19.67z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_hair",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M3348.2 29.38c-2.98-2.9-9.43-9.66-22.17-6.6-10.92 2.62-9.9 11.6-12.27 14.12-3.84 4.07-6.6 2.47-8.7 7.18-1.64 3.64 1.1 6.45.1 10.2-.68 2.46-7.03 11.78 5.86 13.53 13.56 1.85 9.72-10.1 9.9-14.02.15-3.15 4.67-1.26 8.67-6.3 3.54-4.52 1.43-13.1 2.82-15.1 1.97-2.76 9.33-1.55 12.56.64 6.44 4.27 7.82 20.13 1.57 31.53 4.52 6.55 21.4 2.48 13-10.1-2.6-3.87 2.64-5.95-.63-12.3-2.84-5.54-10.72-12.77-10.72-12.77z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "mom_speech_bubble"
    }
  }, [_c('path', {
    attrs: {
      "id": "mom_speechbubble_2",
      "fill": "#FBD79E",
      "d": "M3399.56 64.95c11.84 0 21.44-8.05 21.44-17.97 0-9.93-9.6-17.98-21.44-17.98-11.84 0-21.44 8.05-21.44 17.98 0 4.08 1.62 7.85 4.37 10.87-.08 2.7-8.05 9.47-11.5 11.15 7.12-.83 15.28-5.84 16.48-7.17 3.44 1.97 7.6 3.12 12.08 3.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "mom_speechbubble_1",
      "fill": "#E2B56C",
      "d": "M3391.9 48.8l-2.02.3-.2 2.38-.97.14.22-2.4-1.35.2.07-.92 1.37-.2.18-1.87-1.3.2.07-.93 1.32-.18.2-2.27.97-.13-.22 2.26 2-.28.23-2.26.96-.14-.2 2.27 1.33-.2-.1.92-1.32.18-.17 1.88 1.3-.18-.1.92-1.28.17-.22 2.4-.95.13.2-2.4zm-1.94-.62l2-.3.2-1.86-2.02.28-.18 1.88zm13.2-2.4c.04.36.1.73.12 1.13l.13 1.2c.07.47.16.9.28 1.3l.93-.12.13.9-1.84.26-.28-1.02h-.07l-.16.36c-.08.14-.17.28-.3.43-.13.15-.3.3-.52.4-.2.14-.5.23-.85.28-.3.04-.58.03-.84-.03-.28-.05-.52-.15-.73-.3-.2-.14-.38-.33-.52-.56-.14-.23-.23-.5-.28-.8-.06-.47-.02-.88.14-1.22.17-.35.42-.63.76-.84.33-.22.75-.38 1.24-.47.5-.1 1.03-.14 1.63-.12-.04-.47-.1-.86-.18-1.2-.1-.33-.2-.6-.37-.8-.16-.2-.36-.33-.6-.4-.27-.08-.58-.1-.95-.03-.38.05-.76.2-1.1.45-.37.25-.67.58-.9 1-.25.4-.43.9-.54 1.47-.12.57-.12 1.2-.03 1.88.1.73.3 1.35.57 1.85.27.5.6.92.98 1.22.38.3.8.5 1.27.6.45.12.93.14 1.42.07.2-.03.42-.08.65-.17.22-.08.45-.18.66-.3.2-.13.4-.28.6-.44.17-.16.32-.33.45-.52l.67.65c-.33.46-.76.85-1.28 1.14-.52.3-1.1.5-1.73.58-.54.07-1.1.06-1.65-.05-.57-.1-1.1-.32-1.6-.67-.48-.34-.9-.8-1.27-1.43-.36-.6-.6-1.4-.74-2.33-.14-.92-.13-1.73.04-2.43.16-.7.42-1.3.78-1.8.35-.5.78-.9 1.27-1.2.5-.3 1-.47 1.54-.55.48-.06.9-.06 1.25 0 .33.1.63.23.87.45.23.2.42.5.56.87.14.36.25.8.32 1.3zm-2.28 4.13c.26-.03.48-.1.66-.2.18-.12.33-.25.44-.4.1-.15.2-.3.26-.47l.15-.46-.15-.97c-.45-.03-.85 0-1.2.04-.36.05-.66.14-.9.26-.25.12-.43.3-.55.5-.1.2-.14.45-.1.74.04.3.18.56.4.76.24.2.56.27.98.2zm6.73-10l1.16-.18.67 4.8.1 2.5-.67.08-.58-2.4-.67-4.8zm1.05 9.1c-.04-.26 0-.47.13-.63.12-.17.3-.27.54-.3.25-.03.46 0 .63.13.17.12.27.3.3.56.04.24 0 .44-.14.6-.1.18-.3.28-.55.32-.24.03-.44 0-.6-.14-.17-.13-.27-.3-.3-.55z"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_36",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3274-1h400v450h-400V-1zm221 205v120h144V204h-144zm-185 0v120h144V204h-144zM3495 3v120h144V3h-144zm-185 0v120h144V3h-144z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_35",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3319.5 367h107",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_34",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3357 367v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_33",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3400 367v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_32",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3336 389v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_31",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3379 389v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_30",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3300 389h108",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_29",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3319.5 411h107",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house3_28",
      "width": "420",
      "height": "11",
      "x": "3264",
      "y": "158",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house3_26",
      "width": "155",
      "height": "130",
      "x": "3489",
      "y": "199",
      "fill": "#FFF",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_24",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3573 205l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_23",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3556 205l-60 76",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_22",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3619 287l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_21",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3638 239l-67 84",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house3_20",
      "width": "155",
      "height": "130",
      "x": "3304",
      "y": "199",
      "fill": "#FFF",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_18",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3388 205l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_17",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3371 205l-60 76",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_16",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3434 287l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_15",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3453 239l-67 84",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house3_14",
      "width": "155",
      "height": "130",
      "x": "3489",
      "y": "-2",
      "fill": "#FACE86",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_12",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3573 4l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_11",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3556 4l-60 76",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_10",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3619 86l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_9",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3638 38l-67 84",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house3_8",
      "width": "155",
      "height": "130",
      "x": "3304",
      "y": "-2",
      "fill": "#FACE86",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3388 4l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_5",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3371 4l-60 76",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3434 86l-29 36",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3453 38l-67 84",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house3_2",
      "width": "12",
      "height": "210",
      "x": "3674",
      "y": "239",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house3_1",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3674 239h55v-3c0-20.43-16.57-37-37-37h-18v40z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "bang"
    }
  }, [_c('path', {
    attrs: {
      "id": "bang_2",
      "fill": "#FCE5BE",
      "d": "M3604.27 170.1c-8.94-5.75-17.56-8.05-25.86-6.9-8.3 1.15-15.65 5.42-22.07 12.8-5.18-6.1-11.13-8.9-17.85-8.38-6.73.5-14.33 3.27-22.8 8.26 2.5-6.55 2.56-10.77.13-12.66-2.42-1.9-6.06-.9-10.92 2.94 6.64-7.26 9.74-12.67 9.3-16.23-.43-3.57-5.83-6.77-16.18-9.63 10.6-2.25 17.16-4.48 19.73-6.7 2.56-2.22 1.65-4.9-2.72-8.05 25.85 1.4 40.55.8 44.1-1.87 1.5-1.12.97-5.42-1.6-12.9 7.3 7.83 12.1 11.6 14.4 11.33 2.3-.28-2.04-6.98-13-20.1 14.65 10.77 26.5 16.55 35.54 17.33 9.03.78 19.7.42 32.03-1.1-5.6 5.57-8.22 9.15-7.9 10.74.33 1.6 2.95 3.62 7.86 6.1-3.02.14-5.32.77-6.88 1.88-1.56 1.12 2.26 7.2 11.45 18.28-7.6-.7-13.32-.46-17.12.73-3.8 1.2-7 5.9-9.6 14.14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "bang_1",
      "fill": "#E2B56C",
      "d": "M3544.14 154.62c-1.24.67-2.88 1.13-4.92 1.37-.25.02-.5-.06-.75-.27-.26-.2-.4-.43-.43-.68l-.3-2.52c-.1-.82-.2-2-.3-3.55-.08-1.66-.16-2.86-.24-3.6-.07-.53-.14-1.33-.2-2.4 0-.28.08-.48.22-.6.76-.33 1.64-.56 2.65-.68 1.02-.13 2.05.1 3.07.67 1.2.67 1.86 1.6 2 2.76.18 1.48-.25 2.72-1.3 3.7.9.28 1.6.6 2.1 1s.77.86.83 1.4c.1.7-.2 1.4-.9 2.16-.46.52-.97.93-1.53 1.22zm-4.05-11.16c-.65.08-1.1.15-1.34.22l.17 1.52.24 3.37c.83-.03 1.28-.05 1.34-.07.88-.17 1.56-.53 2.06-1.07.54-.6.75-1.3.65-2.1-.05-.54-.42-1-1.1-1.4-.66-.4-1.33-.55-2-.47zm1.82 6.8l-.94-.02c-.08 0-.2.03-.34.05l-.36.05c-.3.04-.65.05-1 .04.05.72.1 1.38.18 1.95l.22 1.8c1.52-.25 2.73-.6 3.65-1.1.38-.2.74-.5 1.08-.88.32-.34.47-.6.45-.74-.03-.27-.44-.53-1.23-.78-.6-.2-1.15-.32-1.7-.38zm17.48 3.12c-.54.06-1.1-.56-1.65-1.87-.22-.5-.52-1.38-.9-2.65-.6.15-1.35.4-2.28.72l-2.26.75c-.2.8-.55 1.96-1.07 3.5-.15.35-.38.54-.7.58-.24.03-.45-.03-.66-.18-.2-.14-.32-.34-.35-.6-.03-.26.27-1.37.93-3.3-.12-.14-.2-.3-.22-.5-.05-.47.2-.8.75-1 .5-1.33 1.17-2.85 1.98-4.57 1.1-2.36 1.83-3.56 2.17-3.6.46-.05.8.23 1.06.84l.9 2.83 2.04 5.86.67 1.3c.24.44.36.74.38.9.03.24-.04.46-.2.65-.15.2-.35.3-.58.33zm-4.3-9.52l-2 4.3c.67-.27 1.7-.6 3.1-1.04l-1.1-3.26zm20.38 5.35c.03.28.04.75.03 1.4 0 .6-.3.93-.82 1-.32.03-.72-.13-1.22-.5-2.64-1.92-5.75-4.8-9.33-8.6l.2 1.96.2 1.98.3 2.15c.15.94.25 1.66.3 2.15.2 1.55 0 2.36-.6 2.43-.33.04-.6-.03-.8-.2-.2-.16-.3-.37-.34-.6-.04-.26-.06-.63-.1-1.12 0-.5-.04-.86-.07-1.1-.04-.36-.1-.9-.16-1.62l-.16-1.6c-.04-.4-.12-.96-.23-1.73-.12-.76-.2-1.33-.24-1.7-.05-.37-.15-.9-.3-1.62-.17-.7-.27-1.25-.32-1.6-.02-.28.07-.53.27-.78s.45-.4.74-.42c.32-.04.74.25 1.28.86 1.7 1.98 3.23 3.6 4.57 4.9 1.6 1.5 3.3 2.94 5.13 4.28 0-.25-.06-.6-.13-1.1l-.16-1.08c-.33-2.54-.68-4.54-1.06-6-.04-.16-.16-.46-.35-.9-.17-.37-.27-.67-.3-.9-.08-.66.2-1.03.8-1.1 1.02-.13 1.76 1.68 2.22 5.42.08.64.2 1.6.33 2.88l.33 2.87zm12.46-4.88c-.14 1.82-.72 3.33-1.74 4.53-1.03 1.2-2.32 1.9-3.9 2.08-1.42.18-2.55-.1-3.36-.8-.8-.7-1.32-1.85-1.5-3.44-.2-1.5-.03-3.08.48-4.75.52-1.67 1.28-3.06 2.27-4.17.66-.75 1.4-1.17 2.23-1.27.53-.05 1.25.03 2.16.28 1.1.28 1.7.68 1.75 1.18.03.23-.03.46-.18.66-.16.2-.35.32-.6.35-.13.02-.3-.03-.57-.15-.95-.42-1.73-.6-2.35-.53-.43.05-.86.33-1.28.84-.2.25-.5.7-.88 1.35-1.13 1.92-1.57 3.9-1.3 5.98.12 1.08.38 1.82.78 2.2.42.44 1.12.6 2.1.48 1.05-.13 1.9-.57 2.6-1.3.72-.8 1.16-1.86 1.32-3.2-1.6.3-2.94.77-4.03 1.45-.12.1-.25.13-.38.15-.26.03-.5-.04-.68-.22-.18-.16-.28-.36-.3-.6-.05-.3.07-.58.36-.8 1.16-.92 3.28-1.57 6.35-1.94.25-.04.47 0 .66.16.18.15.3.35.32.6.05.38-.08.66-.38.86zm3.46-8.42l1.2 9.63c.06.52-.17.8-.7.87-.5.06-.8-.17-.86-.68l-.15-1.06c-.08-.46-.14-.8-.16-1.04l-.45-3.77-.45-3.76c-.06-.52.16-.8.68-.87.52-.07.8.16.87.67zm1.6 12.92c.04.2-.03.4-.17.57-.15.16-.33.26-.54.3-.24.02-.5-.1-.76-.38-.26-.25-.4-.5-.44-.73-.02-.22.04-.4.2-.58.13-.17.3-.27.53-.3.23-.02.48.1.75.37.26.25.4.5.43.72zm3.4-13.53l1.2 9.62c.05.52-.18.8-.7.87-.5.05-.8-.17-.87-.7l-.15-1.04-.15-1.05-.44-3.75-.46-3.77c-.06-.5.17-.8.68-.86.52-.06.8.16.87.67zm1.6 12.9c.03.22-.03.4-.18.58-.15.18-.32.27-.53.3-.25.03-.5-.1-.77-.36-.26-.26-.4-.5-.43-.74-.03-.2.03-.4.18-.57.15-.16.33-.26.54-.28.23-.03.48.1.76.36.25.26.4.5.42.73zm3.4-13.5l1.18 9.62c.06.5-.16.8-.68.86-.52.06-.8-.16-.87-.67l-.16-1.05-.15-1.05-.44-3.76-.45-3.77c-.06-.5.17-.8.68-.86.53-.05.82.17.9.7zm1.6 12.9c.02.2-.04.4-.2.57-.13.18-.3.28-.52.3-.23.03-.5-.1-.76-.36-.26-.25-.4-.5-.43-.73-.04-.2.02-.4.17-.57.15-.17.33-.27.54-.3.24-.02.5.1.77.37.25.26.4.5.42.73z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "crash"
    }
  }, [_c('path', {
    attrs: {
      "id": "crash_2",
      "fill": "#FCE5BE",
      "d": "M3353.68 165.02c9.34-5.14 18.12-6.84 26.33-5.1 8.23 1.73 15.3 6.52 21.2 14.36 5.6-5.75 11.74-8.14 18.43-7.15 6.68 1 14.1 4.28 22.2 9.87-2.05-6.73-1.8-10.96.76-12.7 2.55-1.7 6.12-.48 10.7 3.72-6.12-7.73-8.84-13.37-8.15-16.9.68-3.54 6.3-6.38 16.85-8.5-10.43-3-16.84-5.7-19.25-8.1-2.4-2.4-1.3-5.03 3.28-7.87-25.93-.4-40.58-2.05-43.94-4.95-1.43-1.23-.6-5.5 2.47-12.8-7.84 7.32-12.9 10.77-15.17 10.32-2.27-.44 2.53-6.85 14.4-19.22-15.4 9.76-27.65 14.72-36.73 14.87-9.1.15-19.74-.96-31.95-3.34 5.2 5.97 7.58 9.74 7.14 11.3-.44 1.58-3.2 3.43-8.28 5.56 3 .35 5.26 1.14 6.74 2.36 1.5 1.23-2.75 7.06-12.72 17.5 7.66-.17 13.34.47 17.06 1.93 3.72 1.44 6.6 6.4 8.62 14.82z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "crash_1",
      "fill": "#E2B56C",
      "d": "M3364 132.7c-.38-.08-.6-.35-.7-.82-.08-.4-.2-.65-.3-.76-.1-.1-.4-.18-.88-.28-.84-.18-1.9.26-3.18 1.3-1.74 1.43-2.78 2.9-3.1 4.43-.16.73-.06 1.42.3 2.05.38.65.9 1.05 1.6 1.2.6.13 1.2.1 1.87-.08.38-.1.97-.33 1.76-.7.38-.16.65-.22.82-.2.25.06.43.2.56.42.13.22.17.45.12.68-.06.25-.2.46-.47.6-1.8 1.02-3.5 1.37-5.04 1.04-1.2-.25-2.1-.92-2.72-2-.6-1.05-.78-2.18-.53-3.38.43-1.94 1.67-3.76 3.73-5.45 1.73-1.4 3.28-1.97 4.66-1.67.27.06.52.12.74.2.22.07.4.15.57.25.27-.25.57-.34.9-.28.38.1.58.4.57.94 0 .48-.08 1.06-.23 1.73-.05.24-.15.43-.32.58-.2.2-.45.26-.73.2zm9.47 12.18c-.22-.05-.4-.2-.56-.4-1.5-2.28-3.33-4-5.52-5.13l-.3 1.7-.3 1.7c-.06.25-.2.44-.4.58-.2.13-.4.17-.66.12-.24-.05-.43-.18-.56-.38-.13-.2-.16-.43-.1-.7.1-.44.2-1.12.36-2.02.14-.9.27-1.58.36-2.04.1-.5.34-1.28.68-2.3.33-1.02.56-1.8.67-2.3.06-.3.13-.74.2-1.32.06-.6.13-1.02.2-1.32.06-.32.2-.6.45-.8.28-.25.6-.33 1-.22l2.03.6c.77.27 1.4.6 1.88 1 2.06 1.73 2.9 3.47 2.52 5.25-.18.86-.74 1.54-1.68 2.05-.75.4-1.63.64-2.65.72 1.6 1.33 2.7 2.62 3.36 3.87.1.2.15.42.1.63-.05.24-.18.43-.4.57-.2.14-.43.2-.66.14zm-3.07-12.5l-1.25-.4-.14 1.07c-.04.43-.1.78-.15 1.05-.1.46-.26 1.02-.48 1.7l-.54 1.65.37.1.38.08c1.47.3 2.6.35 3.42.12.36-.1.7-.28 1.04-.5.37-.27.58-.5.63-.73.17-.8-.12-1.63-.9-2.5-.68-.82-1.48-1.36-2.37-1.65zm15.92 15.4c-.53-.12-.85-.9-.95-2.33-.04-.55-.03-1.5.02-2.82-.62-.05-1.4-.06-2.4-.06h-2.4c-.44.68-1.17 1.67-2.17 2.96-.25.28-.53.4-.85.32-.23-.04-.42-.17-.56-.37-.15-.2-.2-.43-.14-.68.06-.27.7-1.23 1.97-2.86-.07-.17-.08-.35-.04-.54.1-.47.45-.7 1.04-.72.92-1.08 2.05-2.32 3.38-3.7 1.83-1.88 2.9-2.78 3.24-2.7.45.1.7.47.73 1.13l-.08 3v6.25l.2 1.46c.08.5.1.83.06 1-.05.23-.2.42-.4.55-.2.13-.43.17-.66.12zm-.95-10.47l-3.3 3.45c.72-.03 1.82-.02 3.3.02v-3.46zm5.48 8.93c.05-.25.17-.42.37-.54.2-.13.43-.16.68-.1.28.05.5.27.63.63.2.5.4.85.6 1.05.42.43 1.1.74 2.02.93.9.2 1.76.2 2.6-.04 1.1-.28 1.72-.86 1.9-1.74.16-.72-.13-1.37-.86-1.97-.63-.5-1.44-.88-2.46-1.13-.9-.22-1.63-.58-2.2-1.08-.7-.63-.97-1.38-.8-2.25.23-1.03 1-1.83 2.35-2.43 1.26-.56 2.5-.72 3.68-.46.55.12 1.16.35 1.82.7.88.43 1.28.84 1.2 1.23-.1.5-.42.7-.94.6-.23-.06-.62-.2-1.17-.45-.55-.25-1-.4-1.3-.46-.9-.18-1.7-.12-2.43.18-.73.3-1.17.77-1.3 1.4-.1.47.25.9 1.06 1.27.3.14.9.34 1.8.6 1.28.37 2.22 1 2.8 1.9.54.8.7 1.68.5 2.63-.3 1.36-1.15 2.32-2.6 2.86-1.23.47-2.58.56-4.03.25-1.05-.2-1.96-.62-2.75-1.2-.97-.72-1.36-1.5-1.2-2.37zm26.47-4.8c-.13.22-.25.56-.35 1.03l-.15.76-.14.77c-.12.56-.36 1.4-.7 2.52-.34 1.1-.57 1.95-.7 2.52-.1.44-.2 1.1-.32 1.98-.12.88-.23 1.55-.32 2-.05.22-.17.4-.36.53-.2.12-.4.16-.64.1-.23-.04-.4-.16-.54-.35-.13-.2-.16-.4-.1-.64.08-.44.2-1.1.3-2 .13-.87.24-1.53.33-1.97.1-.42.2-.85.32-1.27-1-.2-2.23-.3-3.74-.33l-3.76-.06c-.1.5-.3 1.23-.62 2.16-.3.92-.5 1.64-.62 2.16-.05.24-.18.42-.37.55-.2.14-.4.18-.64.13-.25-.05-.42-.17-.55-.37-.12-.2-.16-.4-.1-.65.12-.6.37-1.5.72-2.67.36-1.18.6-2.08.73-2.7.07-.3.16-.78.27-1.42.1-.63.2-1.1.27-1.43.1-.45.27-1.12.52-2.02.26-.9.43-1.57.53-2.02.04-.24.16-.42.35-.55.2-.13.4-.17.64-.12.23.05.4.18.53.37.12.2.16.4.1.65-.1.46-.27 1.14-.52 2.04-.24.9-.42 1.58-.52 2.03l-.4 2.2 3.83.07c1.55.04 2.82.16 3.83.37.24-.82.54-2.05.9-3.7.08-.43.25-.85.48-1.27.33-.57.67-.82 1-.75.23.05.4.17.55.36.13.2.18.4.13.65-.02.08-.07.2-.16.33zm4.8.05l-2.04 9.56c-.1.5-.42.7-.93.6-.5-.1-.72-.42-.6-.93.04-.22.1-.58.2-1.04l.2-1.05.8-3.72c.38-1.65.65-2.9.83-3.72.1-.5.42-.7.93-.6.52.1.72.4.6.92zm-2.73 12.82c-.05.2-.17.37-.37.48-.2.12-.4.16-.6.1-.23-.03-.43-.23-.6-.58-.16-.33-.22-.6-.17-.84.04-.2.16-.37.36-.48.2-.12.4-.15.6-.1.23.04.43.24.6.6.16.3.22.6.17.82zm7.64-11.77l-2.03 9.55c-.1.5-.4.7-.92.6-.52-.1-.72-.42-.6-.92.04-.24.1-.6.2-1.06l.2-1.05.8-3.72c.38-1.66.65-2.9.83-3.73.12-.5.43-.7.94-.6.5.1.7.42.6.93zm-2.72 12.8c-.05.22-.17.38-.36.5-.2.12-.4.15-.6.1-.24-.04-.43-.24-.6-.58-.16-.33-.22-.6-.17-.85.03-.2.15-.36.35-.48.2-.1.4-.15.6-.1.23.05.43.24.6.6.16.32.22.6.17.82zm7.65-11.76l-2.04 9.55c-.1.5-.4.7-.93.6-.5-.1-.7-.4-.6-.92l.2-1.06.2-1.04.82-3.73.82-3.72c.1-.5.42-.7.93-.6.5.1.7.4.6.92zm-2.72 12.82c-.05.2-.17.36-.36.47-.2.12-.4.16-.62.1-.23-.04-.42-.23-.6-.58-.15-.34-.2-.62-.16-.85.04-.2.16-.37.36-.48.2-.12.4-.15.6-.1.23.04.43.24.6.58.16.33.22.6.17.84z"
    }
  })])]), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "hoop_10",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "2606 196 2667 196 2667 206 2606 206"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_9",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2607.36 190.93l59-41.93v13l-53.07 36.93c-4.58 3.18-7.3 8.4-7.3 13.95V449h-10V212.94c0-8.75 4.23-16.95 11.36-22z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hoop_8",
      "width": "10",
      "height": "140",
      "x": "2657",
      "y": "91",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_7",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2720.28 174l-12.33 57"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2710.28 174l-12.33 57"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_5",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2685.95 174l12.33 57-12.33-57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2695.95 174l12.33 57-12.33-57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2705.95 174l12.33 57-12.33-57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2730.28 174l-12.33 57"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hoop_1",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2667 169h67.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5H2667v-5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "chain_fence_89",
      "width": "10",
      "height": "220",
      "x": "2521",
      "y": "229",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "chain_fence_88",
      "cx": "2526",
      "cy": "219",
      "r": "10",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_87",
      "stroke": "#FFF",
      "d": "M2531.5 252.5h742",
      "opacity": ".6",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_86",
      "stroke": "#FFF",
      "d": "M2532.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_85",
      "stroke": "#FFF",
      "d": "M2531.1 421.7l131.4-182.2",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_84",
      "stroke": "#FFF",
      "d": "M2531.1 393.97l111.4-154.47",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_83",
      "stroke": "#FFF",
      "d": "M2531 366.38l91.5-126.88",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_82",
      "stroke": "#FFF",
      "d": "M2531.08 338.53l71.42-99.03",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_81",
      "stroke": "#FFF",
      "d": "M2531.06 310.82l51.44-71.32",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_80",
      "stroke": "#FFF",
      "d": "M2531 283.17l31.5-43.67",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_79",
      "stroke": "#FFF",
      "d": "M2552.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_78",
      "stroke": "#FFF",
      "d": "M2572.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_77",
      "stroke": "#FFF",
      "d": "M2592.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_76",
      "stroke": "#FFF",
      "d": "M2612.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_75",
      "stroke": "#FFF",
      "d": "M2632.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_74",
      "stroke": "#FFF",
      "d": "M2652.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_73",
      "stroke": "#FFF",
      "d": "M2672.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_72",
      "stroke": "#FFF",
      "d": "M2692.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_71",
      "stroke": "#FFF",
      "d": "M2712.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_70",
      "stroke": "#FFF",
      "d": "M2732.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_69",
      "stroke": "#FFF",
      "d": "M2752.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_68",
      "stroke": "#FFF",
      "d": "M2772.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_67",
      "stroke": "#FFF",
      "d": "M2792.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_66",
      "stroke": "#FFF",
      "d": "M2812.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_65",
      "stroke": "#FFF",
      "d": "M2832.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_64",
      "stroke": "#FFF",
      "d": "M2852.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_63",
      "stroke": "#FFF",
      "d": "M2872.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_62",
      "stroke": "#FFF",
      "d": "M2892.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_61",
      "stroke": "#FFF",
      "d": "M2912.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_60",
      "stroke": "#FFF",
      "d": "M2932.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_59",
      "stroke": "#FFF",
      "d": "M2952.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_58",
      "stroke": "#FFF",
      "d": "M2972.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_57",
      "stroke": "#FFF",
      "d": "M2992.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_56",
      "stroke": "#FFF",
      "d": "M3012.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_55",
      "stroke": "#FFF",
      "d": "M3032.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_54",
      "stroke": "#FFF",
      "d": "M3052.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_53",
      "stroke": "#FFF",
      "d": "M3072.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_52",
      "stroke": "#FFF",
      "d": "M3092.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_51",
      "stroke": "#FFF",
      "d": "M3112.5 447.5l150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_50",
      "stroke": "#FFF",
      "d": "M3132.5 447.5l140.7-195.1",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_49",
      "stroke": "#FFF",
      "d": "M3152.5 447.5l120.45-167.03",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_48",
      "stroke": "#FFF",
      "d": "M3172.5 447.5l100.56-139.45",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_47",
      "stroke": "#FFF",
      "d": "M3192.5 447.5l80.56-111.7",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_46",
      "stroke": "#FFF",
      "d": "M3212.5 447.5l60.47-83.85",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_45",
      "stroke": "#FFF",
      "d": "M3232.5 447.5l40.53-56.2",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_44",
      "stroke": "#FFF",
      "d": "M3252.5 447.5l20.53-28.46",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_43",
      "stroke": "#FFF",
      "d": "M3272.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_42",
      "stroke": "#FFF",
      "d": "M3273.9 421.7l-131.4-182.2",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_41",
      "stroke": "#FFF",
      "d": "M3273.9 393.97L3162.5 239.5",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_40",
      "stroke": "#FFF",
      "d": "M3274 366.38l-91.5-126.88",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_39",
      "stroke": "#FFF",
      "d": "M3273.92 338.53l-71.42-99.03",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_38",
      "stroke": "#FFF",
      "d": "M3273.94 310.82l-51.44-71.32",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_37",
      "stroke": "#FFF",
      "d": "M3274 283.17l-31.5-43.67",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_36",
      "stroke": "#FFF",
      "d": "M3252.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_35",
      "stroke": "#FFF",
      "d": "M3232.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_34",
      "stroke": "#FFF",
      "d": "M3212.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_33",
      "stroke": "#FFF",
      "d": "M3192.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_32",
      "stroke": "#FFF",
      "d": "M3172.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_31",
      "stroke": "#FFF",
      "d": "M3152.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_30",
      "stroke": "#FFF",
      "d": "M3132.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_29",
      "stroke": "#FFF",
      "d": "M3112.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_28",
      "stroke": "#FFF",
      "d": "M3092.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_27",
      "stroke": "#FFF",
      "d": "M3072.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_26",
      "stroke": "#FFF",
      "d": "M3052.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_25",
      "stroke": "#FFF",
      "d": "M3032.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_24",
      "stroke": "#FFF",
      "d": "M3012.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_23",
      "stroke": "#FFF",
      "d": "M2992.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_22",
      "stroke": "#FFF",
      "d": "M2972.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_21",
      "stroke": "#FFF",
      "d": "M2952.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_20",
      "stroke": "#FFF",
      "d": "M2932.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_19",
      "stroke": "#FFF",
      "d": "M2912.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_18",
      "stroke": "#FFF",
      "d": "M2892.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_17",
      "stroke": "#FFF",
      "d": "M2872.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_16",
      "stroke": "#FFF",
      "d": "M2852.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_15",
      "stroke": "#FFF",
      "d": "M2832.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_14",
      "stroke": "#FFF",
      "d": "M2812.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_13",
      "stroke": "#FFF",
      "d": "M2792.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_12",
      "stroke": "#FFF",
      "d": "M2772.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_11",
      "stroke": "#FFF",
      "d": "M2752.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_10",
      "stroke": "#FFF",
      "d": "M2732.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_9",
      "stroke": "#FFF",
      "d": "M2712.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_8",
      "stroke": "#FFF",
      "d": "M2692.5 447.5l-150-208",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_7",
      "stroke": "#FFF",
      "d": "M2672.5 447.5l-140.7-195.1",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_6",
      "stroke": "#FFF",
      "d": "M2652.5 447.5l-120.45-167.03",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_5",
      "stroke": "#FFF",
      "d": "M2632.5 447.5l-100.56-139.45",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_4",
      "stroke": "#FFF",
      "d": "M2612.5 447.5l-80.56-111.7",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_3",
      "stroke": "#FFF",
      "d": "M2592.5 447.5l-60.47-83.85",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_2",
      "stroke": "#FFF",
      "d": "M2572.5 447.5l-40.53-56.2",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chain_fence_1",
      "stroke": "#FFF",
      "d": "M2552.5 447.5l-20.53-28.46",
      "opacity": ".5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "player",
    class: _vm.player3_state,
    attrs: {
      "id": "player3"
    }
  }, [_c('path', {
    attrs: {
      "id": "player3_right_hand",
      "fill": "#C8A38E",
      "d": "M2747.3 356.35c-.13 1.4-1.08 1.73-2.23 3.3-1.34 1.86-1.5 5.36-3.07 8.2.3.7 2.66-.38 3.22-1.52.56-1.15 1-2.08 1.17-2.37.18-.28.57-.23.66.06.1.3-.5 10.62-.3 11.14.2.53 1.56.67 1.84.16.28-.5.97-8.65 1.1-8.85.14-.2.43-.08.55.04.12.14-.87 8.82-.7 9.16.18.34 1.6.4 1.77.15.18-.24 1-8.9 1.17-9.1.16-.18.46-.13.58.06.1.18-.98 8.5-.8 8.88.2.38 1.56.5 1.72.15.16-.36 1.18-8.74 1.33-8.85.14-.1.32-.08.43.04.12.1-.3 6.4-.1 6.76.17.36 1.2.53 1.4.12.18-.4.8-15.77.9-16.6.32-2.84-1.2-5.94-4.8-6.25-3.6-.32-5.56 2.28-5.85 5.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_arm_bottom",
      "fill": "#C8A38E",
      "d": "M2755.95 331.02c3.04.26 5.3 2.85 5.03 5.8l-1.93 21.3c-.27 2.94-2.95 5.12-6 4.86-3.04-.26-5.3-2.85-5.03-5.8l1.93-21.3c.27-2.94 2.95-5.12 6-4.86z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_arm_top",
      "fill": "#C8A38E",
      "d": "M2759.1 294.02c2.95.25 5.14 2.8 4.88 5.67l-3.27 36.52c-.25 2.88-2.85 5-5.8 4.76-2.95-.25-5.14-2.8-4.88-5.67l3.27-36.52c.25-2.88 2.85-5 5.8-4.76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_sleeve_2",
      "fill": "#F9F8F2",
      "d": "M2758.65 294.03c3.75.3 6.55 3.45 6.34 7.08l-1.55 25.9-15.45-1.3 3.14-25.76c.44-3.6 3.76-6.23 7.5-5.9z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_right_sleeve_1",
      "fill": "#9E0B1D",
      "points": "2764 324.316691 2763.75554 327 2748 325.676291 2748.328 323"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_right_sock",
      "width": "13",
      "height": "18",
      "x": "2755",
      "y": "418",
      "fill": "#353535"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_shoe_5",
      "fill": "#EDEBE4",
      "d": "M2741.45 439.76c2.42-.56 8.18-4.16 12.78-7.32 3.05.88 10.78.96 13.8 0 1.4-.45 2.6-.95 2.94.7.22 1.08-.76 1.77-2.95 2.06V448h-33.97c-.45-4.25 2.02-7 7.4-8.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_shoe_4",
      "fill": "#9E0B1D",
      "d": "M2740.45 439.94c2.33-.56 11.84-6.64 12.33-7.3.5-.65.64-3.15 1.08-7.77.85-1.05 5.2-1.37 5.92.32.72 1.68-.4 4.92-2.2 8.08-1.8 3.16-9.4 7.27-12.38 8.34-2.97 1.07-6.45-.33-4.75-1.68z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_right_shoe_3",
      "fill": "#515151",
      "points": "2750 434.369034 2752.29687 433 2756 436.425205 2753.67045 438"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_right_shoe_2",
      "fill": "#515151",
      "points": "2745 437.369034 2747.29687 436 2751 439.425205 2748.67045 441"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_right_shoe_1",
      "cx": "2761.5",
      "cy": "441.5",
      "r": "3.5",
      "fill": "#9E0B1D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_leg_bottom",
      "fill": "#C8A38E",
      "d": "M2761.5 388c3.6 0 6.5 2.9 6.5 6.5V418h-13v-23.5c0-3.6 2.9-6.5 6.5-6.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_leg_top",
      "fill": "#9E0B1D",
      "d": "M2761.23 347c4.84 0 8.77 3.93 8.77 8.77V401h-19l1.22-45.23c.14-4.88 4.13-8.77 9-8.77z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_left_sock",
      "width": "13",
      "height": "18",
      "x": "2775",
      "y": "418",
      "fill": "#353535"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_left_shoe_5",
      "fill": "#F9F8F2",
      "d": "M2761.45 439.76c2.42-.56 8.18-4.16 12.78-7.32 3.05.88 10.78.96 13.8 0 1.4-.45 2.6-.95 2.94.7.22 1.08-.76 1.77-2.95 2.06V448h-33.97c-.45-4.25 2.02-7 7.4-8.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_left_shoe_4",
      "fill": "#9E0B1D",
      "d": "M2760.45 439.94c2.33-.56 11.84-6.64 12.33-7.3.5-.65.64-3.15 1.08-7.77.85-1.05 5.2-1.37 5.92.32.72 1.68-.4 4.92-2.2 8.08-1.8 3.16-9.4 7.27-12.38 8.34-2.97 1.07-6.45-.33-4.75-1.68z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_left_shoe_3",
      "fill": "#515151",
      "points": "2770 434.369034 2772.29687 433 2776 436.425205 2773.67045 438"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_left_shoe_2",
      "fill": "#515151",
      "points": "2765 437.369034 2767.29687 436 2771 439.425205 2768.67045 441"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_left_shoe_1",
      "cx": "2781.5",
      "cy": "441.5",
      "r": "3.5",
      "fill": "#9E0B1D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_left_leg_bottom",
      "fill": "#C8A38E",
      "d": "M2781.5 388c3.6 0 6.5 2.9 6.5 6.5V418h-13v-23.5c0-3.6 2.9-6.5 6.5-6.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_left_leg_top",
      "fill": "#9E0B1D",
      "d": "M2780.77 347c4.88 0 8.87 3.9 9 8.77L2791 401h-19v-45.23c0-4.84 3.93-8.77 8.77-8.77z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_hip",
      "fill": "#9E0B1D",
      "d": "M2753 347h37v9c0 7.18-5.82 13-13 13h-11c-7.18 0-13-5.82-13-13v-9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_shirt_3",
      "fill": "#EDEBE4",
      "d": "M2770.87 291c3.2 0 12.85 1.52 15.48 3.55.7 7.14 4.25 63.78 3.56 67.67-4.4 1.3-33.83.75-38.9 0 .58-4 3.75-55.95 4.86-67.67 4.93-2.5 11.8-3.55 15-3.55z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_shirt_2",
      "fill": "#9E0B1D",
      "d": "M2772 310h9v8c0 1.66-1.34 3-3 3h-3c-1.66 0-3-1.34-3-3v-8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_shirt_1",
      "fill": "#9E0B1D",
      "d": "M2771.7 291c1.65 0 4.9.33 8.06.75 3 .4.76 10.1-9.33 10.25-10.1.15-9.4-10.3-6.73-10.6 3.1-.34 6.3-.4 8-.4z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "player3_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "player3_left_hand",
      "fill": "#C8A38E",
      "d": "M2782.4 356.8c0 1.4-.96 1.8-2 3.48-1.2 1.94-1.06 5.44-2.4 8.4.4.67 2.7-.6 3.16-1.8.47-1.2.83-2.15 1-2.45.15-.3.56-.28.68 0 .13.3.44 10.6.7 11.1.25.5 1.66.52 1.9 0 .25-.53.22-8.68.34-8.9.12-.22.43-.1.56 0 .13.12-.1 8.82.1 9.15.22.32 1.68.27 1.84 0 .15-.27.2-8.95.37-9.15.16-.2.48-.17.6 0 .14.18-.22 8.54 0 8.9.23.35 1.65.36 1.78 0 .13-.37.42-8.78.55-8.9.14-.12.32-.1.45 0s.27 6.4.5 6.73c.22.34 1.3.42 1.45 0 .16-.42-.6-15.72-.58-16.57.07-2.84-1.78-5.8-5.48-5.8s-5.5 2.75-5.52 5.8z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_left_arm_bottom",
      "width": "11",
      "height": "32",
      "x": "2782",
      "y": "331",
      "fill": "#C8A38E",
      "rx": "5.5"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_left_arm_top",
      "width": "11",
      "height": "47",
      "x": "2782",
      "y": "294",
      "fill": "#C8A38E",
      "rx": "5.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_left_sleeve_2",
      "fill": "#F9F8F2",
      "d": "M2787.5 294c3.64 0 6.6 2.9 6.72 6.53L2795 327h-15l.78-26.47c.1-3.64 3.08-6.53 6.72-6.53z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_left_sleeve_1",
      "fill": "#9E0B1D",
      "points": "2795 324 2795 327 2780 327 2780.07953 324"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_neck",
      "fill": "#B78B72",
      "d": "M2767.65 286.53c.4 2.58 0 5.8-2.27 5.8-.26 1.38-1.94 7.5 4.64 7.67 6.58.15 7.96-4.74 7.98-7.67-2.56 0-3.16-2.92-2.56-5.8-.75-2.08-6.73-2-7.8 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_face",
      "fill": "#C8A38E",
      "fill-rule": "nonzero",
      "d": "M2790 267.6c1.06-.6 2.6-1.38 4.32 0 1.48 1.18.37 5.82-1.63 8.4-2 2.53-5.2 3.06-6.47 2.1-2.67 5.83-9.46 8.94-14 8.9-12.16-.1-17.23-12.08-17.23-22.02 0-15.7 6.44-20.98 17.23-20.98 9.68-.05 20.43 4.93 17.77 23.6z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_mouth_open",
    attrs: {
      "id": "player3_mouth_open_bottom",
      "fill": "#B78B72",
      "d": "M2765.04 282c.1 0 .9.64 1.46.82 1.67.5 4.5.27 5.44 0 .65-.2 1.82-.82 1.94-.82.8 0-2.54 3-5.07 3-2.53 0-4.08-1.96-3.76-3z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_mouth_closed",
    attrs: {
      "id": "player3_mouth_bottom",
      "fill": "#B78B72",
      "d": "M2766.2 282h7.66c.8 0-2.05 1-4.6 1-2.56 0-3.77-1-3.06-1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_mouth_top",
      "fill": "#98735E",
      "d": "M2765.25 282h9.58c1 0-2.56-2-5.76-2-3.2 0-4.7 2-3.82 2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_ear",
      "fill": "#B78B72",
      "d": "M2789.08 272.28c.96-1.97 2.46-3.8 4.3-3.15 1.83.65-.52 7.88-5.38 7.87.56-.34 2.1-1.92 2.15-3.15.05-1.23-.36-1.85-1.07-1.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_nose",
      "fill": "#B78B72",
      "d": "M2767.2 266.77c0-.98 2.45-1.07 2.45 0 0 1.06.8 6.62 0 7.6-.78 1-3.1.66-3.44 0-.35-.65-.28-1.72.5-2.02.77-.3.5-4.6.5-5.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_left_brow",
      "fill": "#33261A",
      "d": "M2773.02 263.57c.3-2.03 9.78-2.07 9.97-.25.18 1.82-1.8.96-4.42 1.3-2.6.35-5.86 1-5.56-1.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_brow",
      "fill": "#33261A",
      "d": "M2765.98 263.57c-.3-2.03-9.78-2.07-9.97-.25-.18 1.82 1.8.96 4.42 1.3 2.6.35 5.86 1 5.56-1.05z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_left_cheek",
      "cx": "2779",
      "cy": "276",
      "r": "3",
      "fill": "#CB9A88"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_right_cheek",
      "cx": "2761",
      "cy": "276",
      "r": "3",
      "fill": "#CB9A88"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_left_eye_whites",
      "fill": "#FFF",
      "d": "M2774 268.36c1.47-3.94 8.02-4.54 9-1.13 0 4.6-7.93 5-9 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_left_pupil",
      "cx": "2777",
      "cy": "268",
      "r": "2",
      "fill": "#33261A"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_eye_lid",
    attrs: {
      "id": "player3_left_eye_lids",
      "fill": "#B78B72",
      "d": "M2774 268.36c1.47-3.94 8.02-4.54 9-1.13 0 4.6-7.93 5-9 1.13z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_right_eye_whites",
      "fill": "#FFF",
      "d": "M2766 268.36c-1.47-3.94-8.02-4.54-9-1.13 0 4.6 7.93 5 9 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_right_pupil",
      "cx": "2760",
      "cy": "268",
      "r": "2",
      "fill": "#33261A"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_eye_lid",
    attrs: {
      "id": "player3_right_eye_lids",
      "fill": "#B78B72",
      "d": "M2766 268.36c-1.47-3.94-8.02-4.54-9-1.13 0 4.6 7.93 5 9 1.13z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player3_hair",
      "fill": "#33261A",
      "d": "M2787 273.54c.43-3.85 2.9-5.6 4-6 .06-7.36-1-21.64-2.6-22.8-1.6-1.14-29.13-.83-30.25 0-1.13.85-2.34 10.36-2.13 11.65 1.02-.6 28.55-.85 29.16 0 .62.82 0 15.98 0 16.87 0 .88 1.52.96 1.8.27z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "player",
    class: _vm.player1_state,
    attrs: {
      "id": "player1"
    }
  }, [_c('g', {
    attrs: {
      "id": "player1_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "player1_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "player1_left_hand",
      "fill": "#C8A38E",
      "d": "M2650.15 356.8c.12 1.37 1.1 2.05 2.1 3.58 1.2 1.78 1.37 5.15 2.75 7.9-.27.67-2.34-.38-2.83-1.5-.5-1.1-.88-2-1.05-2.27-.16-.27-.5-.22-.58.06-.1.3.5 10.22.32 10.73-.17.5-1.37.6-1.62.13-.25-.5-.9-8.33-1-8.53-.13-.2-.4-.08-.5.04-.1.12.82 8.48.67 8.8-.14.34-1.38.4-1.54.14-.15-.24-.92-8.6-1.07-8.76-.16-.18-.43-.14-.53.04-.1.18.9 8.2.74 8.56-.15.36-1.35.47-1.5.13-.13-.34-1.08-8.4-1.2-8.5-.13-.12-.28-.1-.4.02-.1.12.32 6.17.15 6.5-.16.36-1.06.52-1.23.12-.17-.4-.8-15.18-.9-16-.28-2.7 1.04-5.7 4.2-5.98 3.14-.27 4.75 1.87 5.03 4.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_arm_bottom",
      "fill": "#C8A38E",
      "d": "M2643.9 330.02c-2.57.23-4.47 2.52-4.24 5.12l2.03 23.56c.2 2.6 2.48 4.52 5.04 4.3 2.57-.23 4.47-2.53 4.24-5.13l-2.03-23.55c-.23-2.6-2.5-4.53-5.05-4.3z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_arm_top",
      "fill": "#C8A38E",
      "d": "M2641.3 300.02c-2.58.23-4.48 2.52-4.25 5.12l2.64 30.62c.2 2.6 2.48 4.53 5.04 4.3 2.57-.22 4.47-2.52 4.24-5.12l-2.64-30.62c-.23-2.6-2.5-4.53-5.05-4.3z"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_left_sock",
      "width": "12",
      "height": "17",
      "x": "2632",
      "y": "419",
      "fill": "#F9F8F2",
      "transform": "matrix(-1 0 0 1 5276 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_shoe_5",
      "fill": "#252525",
      "d": "M2656.14 440.5c-2.22-.54-7.52-4.02-11.75-7.08-2.82.86-9.93.93-12.7 0-1.3-.43-2.4-.9-2.72.67-.2 1.04.7 1.7 2.72 2v12.36h31.25c.42-4.1-1.85-6.77-6.8-7.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_shoe_4",
      "fill": "#4A90E2",
      "d": "M2656.57 439.44c-2.22-.54-11.28-6.44-11.76-7.07-.46-.64-.6-3.06-1-7.53-.82-1.02-4.98-1.33-5.66.3-.68 1.65.38 4.8 2.1 7.85 1.72 3.05 8.98 7.03 11.8 8.07 2.83 1.03 6.16-.33 4.53-1.63z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_left_shoe_3",
      "fill": "#515151",
      "points": "2642.84603 434.372378 2644.81903 433 2648 436.43357 2645.99893 438.012212",
      "transform": "matrix(-1 0 0 1 5290.846 0)"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_left_shoe_2",
      "fill": "#515151",
      "points": "2647.84603 437.372378 2649.81903 436 2653 439.43357 2650.99893 441.012212",
      "transform": "matrix(-1 0 0 1 5300.846 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_shoe_1",
      "fill": "#4A90E2",
      "d": "M2632.35 438c10.84.03 19.82 6.07 19.65 9.9-.46-.02-1.5 0-2.15 0 0-.43-5.77-5.58-17.5-5.58V438z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_leg_bottom",
      "fill": "#C8A38E",
      "d": "M2638 390c-3.3 0-6 2.7-6 6v23h12v-23c0-3.3-2.7-6-6-6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_leg_top",
      "fill": "#4A90E2",
      "d": "M2637.3 350c-4.58 0-8.3 3.72-8.3 8.3V402h18l-1.16-43.7c-.13-4.62-3.9-8.3-8.53-8.3z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_right_sock",
      "width": "12",
      "height": "17",
      "x": "2613",
      "y": "419",
      "fill": "#F9F8F2",
      "transform": "matrix(-1 0 0 1 5238 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_right_shoe_5",
      "fill": "#353535",
      "d": "M2637.14 440.5c-2.22-.54-7.52-4.02-11.75-7.08-2.82.86-9.93.93-12.7 0-1.3-.43-2.4-.9-2.72.67-.2 1.04.7 1.7 2.72 2v12.36h31.25c.42-4.1-1.85-6.77-6.8-7.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_right_shoe_4",
      "fill": "#4A90E2",
      "d": "M2637.57 439.44c-2.22-.54-11.28-6.44-11.76-7.07-.46-.64-.6-3.06-1-7.53-.82-1.02-4.98-1.33-5.66.3-.68 1.65.38 4.8 2.1 7.85 1.72 3.05 8.98 7.03 11.8 8.07 2.83 1.03 6.16-.33 4.53-1.63z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_right_shoe_3",
      "fill": "#515151",
      "points": "2623.84603 434.372378 2625.81903 433 2629 436.43357 2626.99893 438.012212",
      "transform": "matrix(-1 0 0 1 5252.846 0)"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_right_shoe_2",
      "fill": "#515151",
      "points": "2628.84603 437.372378 2630.81903 436 2634 439.43357 2631.99893 441.012212",
      "transform": "matrix(-1 0 0 1 5262.846 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_right_shoe_1",
      "fill": "#4A90E2",
      "d": "M2612.35 438c10.84.03 19.82 6.07 19.65 9.9-.46-.02-1.5 0-2.15 0 0-.43-5.77-5.58-17.5-5.58V438z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_right_leg_bottom",
      "fill": "#C8A38E",
      "d": "M2619 390c-3.3 0-6 2.7-6 6v23h12v-23c0-3.3-2.7-6-6-6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_right_leg_top",
      "fill": "#4A90E2",
      "d": "M2619.7 350c-4.63 0-8.4 3.68-8.54 8.3L2610 402h18v-43.7c0-4.58-3.72-8.3-8.3-8.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_hip",
      "fill": "#4A90E2",
      "d": "M2646 350h-35v9c0 7.18 5.82 13 13 13h9c7.18 0 13-5.82 13-13v-9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_shirt_3",
      "fill": "#F9F8F2",
      "d": "M2628.5 295c-2.97 0-11.94 1.48-14.4 3.44-.64 6.93-3.95 61.88-3.3 65.65 4.1 1.25 31.5.72 36.2 0-.54-3.9-3.5-54.3-4.53-65.66-4.58-2.43-10.98-3.44-13.96-3.44z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_shirt_2",
      "fill": "#4A90E2",
      "points": "2628.86957 316 2635.08696 316 2635.08696 333.181818 2637 333.181818 2637 337 2626.95652 337 2626.95652 332.704545 2628.86957 332.704545 2628.86957 319.818182 2626 319.818182"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_shirt_1",
      "fill": "#4A90E2",
      "d": "M2627.96 295c-1.53 0-4.56.33-7.5.75-2.8.4-.7 10.1 8.7 10.24 9.4.14 8.73-10.3 6.26-10.6-2.9-.34-5.86-.4-7.46-.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_right_hand",
      "fill": "#C8A38E",
      "d": "M2618.15 358.22c0 1.36.92 2.12 1.8 3.74 1.03 1.88.9 5.25 2.05 8.1-.33.65-2.3-.58-2.7-1.73-.4-1.14-.7-2.07-.84-2.36-.14-.3-.48-.27-.6 0-.1.28-.37 10.22-.58 10.7-.22.5-1.42.52-1.63 0-.2-.5-.18-8.37-.28-8.58-.1-.22-.37-.12-.48 0-.12.1.07 8.5-.1 8.82-.2.32-1.43.26-1.56 0-.14-.25-.18-8.64-.32-8.83-.13-.2-.4-.17-.52 0-.1.16.2 8.23 0 8.58-.2.35-1.4.35-1.5 0-.12-.35-.36-8.47-.48-8.6-.1-.1-.27-.1-.38 0-.1.12-.23 6.18-.42 6.5-.2.34-1.1.42-1.24 0-.14-.4.5-15.17.5-16-.07-2.73 1.5-5.58 4.67-5.58 3.16 0 4.58 2.28 4.6 5.22z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_right_arm_bottom",
      "width": "9",
      "height": "33",
      "x": "2609",
      "y": "330",
      "fill": "#C8A38E",
      "transform": "matrix(-1 0 0 1 5227 0)",
      "rx": "4.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_right_arm_top",
      "width": "9",
      "height": "40",
      "x": "2609",
      "y": "300",
      "fill": "#C8A38E",
      "transform": "matrix(-1 0 0 1 5227 0)",
      "rx": "4.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_neck",
      "fill": "#B78B72",
      "d": "M2632.43 291.48c-.38 2.5 0 5.6 2.2 5.6.25 1.33 1.88 7.25-4.48 7.4-6.37.14-7.7-4.58-7.72-7.4 2.48 0 3.06-2.82 2.48-5.6.73-2 6.52-1.94 7.53 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_face",
      "fill": "#C8A38E",
      "fill-rule": "nonzero",
      "d": "M2611.37 273.9c-1-.6-2.4-1.34-4.03 0-1.38 1.15-.34 5.65 1.52 8.14 1.85 2.47 4.85 2.98 6.03 2.04 2.47 5.67 8.8 8.7 13.04 8.65 11.33-.1 16.06-11.72 16.06-21.37 0-15.23-6-20.36-16.06-20.36-9.03-.05-19.05 4.78-16.57 22.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_mouth_open",
    attrs: {
      "id": "player1_mouth_open_bottom",
      "fill": "#B78B72",
      "d": "M2633.96 287c-.1 0-.84.54-1.4.7-1.58.4-4.3.22-5.17 0-.63-.17-1.75-.7-1.86-.7-.75 0 2.42 2.52 4.83 2.52 2.42 0 3.9-1.64 3.6-2.52z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_mouth_closed",
    attrs: {
      "id": "player1_mouth_bottom",
      "fill": "#B78B72",
      "d": "M2633.8 287h-7.23c-.75 0 1.94 1.44 4.35 1.44 2.42 0 3.56-1.44 2.9-1.44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_mouth_top",
      "fill": "#98735E",
      "d": "M2634.76 286.92h-9.05c-.92 0 2.44-1.92 5.45-1.92 3.02 0 4.45 1.92 3.6 1.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_ear",
      "fill": "#B78B72",
      "d": "M2612 278.18c-.9-1.9-2.3-3.68-4.02-3.05-1.7.62.48 7.64 5.02 7.63-.53-.33-1.96-1.86-2-3.05-.05-1.2.33-1.8 1-1.52z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_nose",
      "fill": "#B78B72",
      "d": "M2631.77 272.77c0-.98-2.5-1.07-2.5 0s-.8 6.64 0 7.63c.8 1 3.15.66 3.52 0 .35-.65.28-1.73-.5-2.03-.8-.3-.53-4.62-.53-5.6z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "player1_right_cheek",
      "cx": "2620.99",
      "cy": "282.05",
      "fill": "#CB9A88",
      "transform": "matrix(-1 0 0 1 5241.977 0)",
      "rx": "3.01",
      "ry": "3.05"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "player1_left_cheek",
      "cx": "2636.99",
      "cy": "282.05",
      "fill": "#CB9A88",
      "transform": "matrix(-1 0 0 1 5273.977 0)",
      "rx": "3.01",
      "ry": "3.05"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_right_eye_whites",
      "fill": "#FFF",
      "d": "M2625 274.13c-1.3-3.67-7.15-4.23-8.03-1.05 0 4.3 7.08 4.67 8.03 1.05z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "player1_right_pupil",
      "cx": "2621.99",
      "cy": "274.04",
      "fill": "#33261A",
      "transform": "matrix(-1 0 0 1 5243.984 0)",
      "rx": "2.01",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_left_eye_whites",
      "fill": "#FFF",
      "d": "M2632.97 274.13c1.3-3.67 7.15-4.23 8.03-1.05 0 4.3-7.08 4.67-8.03 1.05z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "player1_left_pupil",
      "cx": "2637.99",
      "cy": "274.04",
      "fill": "#33261A",
      "transform": "matrix(-1 0 0 1 5275.984 0)",
      "rx": "2.01",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_eye_lid",
    attrs: {
      "id": "player1_right_eye_lids",
      "fill": "#B78B72",
      "d": "M2632.97 274.13c1.3-3.67 7.15-4.23 8.03-1.05 0 4.3-7.08 4.67-8.03 1.05z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_eye_lid",
    attrs: {
      "id": "player1_left_eye_lids",
      "fill": "#B78B72",
      "d": "M2625 274.13c-1.3-3.67-7.15-4.23-8.03-1.05 0 4.3 7.08 4.67 8.03 1.05z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player1_hair",
      "fill": "#4A220B",
      "d": "M2653.3 271.85c-6.95 5.92-13.74 1.5-13.46-2.9-2.1 4.54-11.57 4.2-13.14-1.64-.35 6.98-11.1 6.82-13 3.5-.85 6.64-8.36 7.24-11.04 5.14-9.25-7.3-4.18-16.44 2.1-16.88-4.77-8.8 5.34-17.6 12.66-12.67.32-8.7 16.4-10.6 19.43-1.37 7.03-2.95 14.16 3.53 11.5 10.98 6.56-.66 11.9 9.93 4.95 15.85z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "player",
    class: [_vm.player2_state, _vm.player2_state.direction],
    attrs: {
      "id": "player2"
    }
  }, [_c('g', {
    attrs: {
      "id": "player2_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "player2_right_hand",
      "fill": "#DBBFAF",
      "d": "M2673.58 353.95c-.2 1.35-1.13 1.63-2.3 3.1-1.38 1.74-1.67 5.1-3.28 7.76.28.7 2.6-.27 3.2-1.35.58-1.08 1.03-1.96 1.22-2.22.2-.27.57-.2.65.08.08.3-.86 10.17-.68 10.68.17.5 1.5.68 1.78.2.3-.46 1.25-8.25 1.4-8.44.12-.2.4-.06.5.06.12.12-1.14 8.4-.98 8.75.16.33 1.53.44 1.72.2.18-.24 1.27-8.52 1.45-8.7.17-.16.47-.1.57.08.1.18-1.24 8.12-1.07 8.5.17.36 1.5.52 1.66.2.17-.34 1.46-8.34 1.6-8.44.14-.1.3-.08.42.04.1.12-.5 6.13-.34 6.48.18.35 1.17.55 1.37.17.2-.4 1.34-15.1 1.46-15.9.4-2.7-.97-5.74-4.47-6.15-3.5-.42-5.5 2-5.88 4.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_arm_bottom",
      "fill": "#DBBFAF",
      "d": "M2682.4 330.04c2.88.35 4.9 2.94 4.56 5.8l-2.55 20.6c-.34 2.85-2.95 4.87-5.8 4.52-2.88-.35-4.9-2.94-4.56-5.8l2.55-20.6c.34-2.85 2.95-4.87 5.8-4.52z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_arm_top",
      "fill": "#DBBFAF",
      "d": "M2687.38 294.04c2.88.34 4.93 2.85 4.58 5.6l-4.48 34.94c-.36 2.76-2.98 4.72-5.86 4.38-2.88-.34-4.93-2.85-4.58-5.6l4.48-34.94c.36-2.76 2.98-4.72 5.86-4.38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_shoulder",
      "fill": "#FFE018",
      "d": "M2686.2 294.05c3.54.44 6.1 3.65 5.77 7.25l-2.35 25.7-14.62-1.82 3.86-25.5c.54-3.58 3.8-6.07 7.34-5.63z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player2_right_sock",
      "fill": "#F9F8F2",
      "points": "2683 429 2693 429 2693 432 2683 432"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_shoe_6",
      "fill": "#D0B717",
      "d": "M2688 432.27c.1-2.98-5.64-3.07-5.32 0 .22 2.14-.32 2.8-2.1 4.55-1.76 1.75-6.25 3.87-7.58 4.37.33 1.04 3.1 1.36 5.02 1.8 7.26-2.95 9.9-7.75 9.98-10.73z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_shoe_5",
      "fill": "#FFE018",
      "d": "M2686.87 431.7c.44-.85 4.3-1.02 5.82 0 .66-.27 2-.78 2.27.28.2.7-.57 1.36-2.28 1.98.12 8.05.12 12.73 0 14.04h-24.54c-.17-1.43-1.17-6.1 5.1-7.85.66.48 1.37 1 3.64 1.75 8.35-3.52 9.53-9.32 9.97-10.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_shoe_4",
      "fill": "#F9F8F2",
      "d": "M2675.75 445.98H2693c-.02.24-.02.9 0 2.02h-25.9c-.14-1.16-.73-5.13 4.12-6.96 1.34-.4 4.34 2.06 4.53 4.94z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_shoe_3",
      "fill": "#F9F8F2",
      "d": "M2680.9 441.15c-.43-.74-3.13-2-4.12-2.14-.4-.06-.83.3-.77.76 1.25.26 3.6 1.5 4.02 2 .4.5 1.3.14.87-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_shoe_2",
      "fill": "#F9F8F2",
      "d": "M2684.9 439.15c-.43-.74-3.13-2-4.12-2.14-.4-.06-.83.3-.77.76 1.25.26 3.6 1.5 4.02 2 .4.5 1.3.14.87-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_shoe_1",
      "fill": "#F9F8F2",
      "d": "M2686.88 436.15c-.44-.74-3.3-2-4.35-2.14-.43-.06-.58.45-.52.9 1.33.26 3.53 1.37 3.96 1.87.44.5 1.37.13.92-.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_leg_bottom",
      "fill": "#DBBFAF",
      "d": "M2688 387c2.76 0 5 2.24 5 5v37h-10v-37c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_leg_top",
      "fill": "#DBBFAF",
      "d": "M2688 353c2.76 0 5 2.24 5 5v32c0 2.76-2.24 5-5 5s-5-2.24-5-5v-32c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_leg_pant",
      "fill": "#4A4A4A",
      "d": "M2688.5 343c4.7 0 8.5 3.8 8.5 8.5V385h-17v-33.5c0-4.7 3.8-8.5 8.5-8.5z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player2_left_sock",
      "fill": "#F9F8F2",
      "points": "2704 429 2714 429 2714 432 2704 432"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_shoe_6",
      "fill": "#D0B717",
      "d": "M2710 432.27c.1-2.98-5.64-3.07-5.32 0 .22 2.14-.32 2.8-2.1 4.55-1.76 1.75-6.25 3.87-7.58 4.37.33 1.04 3.1 1.36 5.02 1.8 7.26-2.95 9.9-7.75 9.98-10.73z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_shoe_5",
      "fill": "#FFE018",
      "d": "M2708.87 431.7c.44-.85 4.3-1.02 5.82 0 .66-.27 2-.78 2.27.28.2.7-.57 1.36-2.28 1.98.12 8.05.12 12.73 0 14.04h-24.54c-.17-1.43-1.17-6.1 5.1-7.85.66.48 1.37 1 3.64 1.75 8.35-3.52 9.53-9.32 9.97-10.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_shoe_4",
      "fill": "#F9F8F2",
      "d": "M2697.75 445.98H2715c-.02.24-.02.9 0 2.02h-25.9c-.14-1.16-.73-5.13 4.12-6.96 1.34-.4 4.34 2.06 4.53 4.94z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_shoe_3",
      "fill": "#F9F8F2",
      "d": "M2701.9 441.15c-.43-.74-3.13-2-4.12-2.14-.4-.06-.83.3-.77.76 1.25.26 3.6 1.5 4.02 2 .4.5 1.3.14.87-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_shoe_2",
      "fill": "#F9F8F2",
      "d": "M2704.9 439.15c-.43-.74-3.13-2-4.12-2.14-.4-.06-.83.3-.77.76 1.25.26 3.6 1.5 4.02 2 .4.5 1.3.14.87-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_shoe_1",
      "fill": "#F9F8F2",
      "d": "M2707.88 436.15c-.44-.74-3.3-2-4.35-2.14-.43-.06-.58.45-.52.9 1.33.26 3.53 1.37 3.96 1.87.44.5 1.37.13.92-.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_leg_bottom",
      "fill": "#DBBFAF",
      "d": "M2709 387c2.76 0 5 2.24 5 5v37h-10v-37c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_leg_top",
      "fill": "#DBBFAF",
      "d": "M2709 353c2.76 0 5 2.24 5 5v32c0 2.76-2.24 5-5 5s-5-2.24-5-5v-32c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_leg_pant",
      "fill": "#4A4A4A",
      "d": "M2708.5 343c4.7 0 8.5 3.8 8.5 8.5V385h-17v-33.5c0-4.7 3.8-8.5 8.5-8.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_devyn_hip",
      "fill": "#4A4A4A",
      "d": "M2680 343h38v7c0 10.5-8.5 19-19 19s-19-8.5-19-19v-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_shirt",
      "fill": "#F9F8F2",
      "d": "M2698.08 288c6.54 0 6.7.08 6.7 2.8 16.22 2.94 15.98 56.28 16.22 77.4-4.2 1.26-40.16.82-45 .1.55-18.14 0-75.72 14.64-77.5 0-2.65.9-2.8 7.44-2.8z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "basketball",
      "cx": "2718.08",
      "cy": "342.08",
      "r": "16.08",
      "fill": "#CA6E37"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_hand",
      "fill": "#DBBFAF",
      "d": "M2717.13 352.56c0 1.35-.9 1.74-1.88 3.34-1.13 1.88-1 5.23-2.25 8.06.36.65 2.52-.58 2.96-1.7.44-1.15.78-2.08.93-2.37.14-.3.52-.28.64 0 .12.27.4 10.16.65 10.64.23.5 1.55.5 1.78 0 .23-.5.2-8.32.3-8.53.12-.2.4-.1.54 0 .12.12-.1 8.48.1 8.8.2.3 1.57.24 1.7 0 .16-.27.2-8.6.36-8.8.15-.18.45-.16.57 0 .13.18-.2 8.2 0 8.54.22.35 1.54.35 1.66 0 .13-.35.4-8.42.53-8.53.13-.1.3-.1.43 0 .12.1.25 6.14.46 6.47.2.33 1.2.4 1.36 0 .15-.4-.56-15.1-.54-15.9.07-2.73-1.67-5.57-5.14-5.57-3.48 0-5.15 2.64-5.17 5.56z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player2_left_arm_bottom",
      "width": "10",
      "height": "31",
      "x": "2717",
      "y": "328",
      "fill": "#DBBFAF",
      "rx": "5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player2_left_arm_top",
      "width": "10",
      "height": "45",
      "x": "2711.03",
      "y": "292.17",
      "fill": "#DBBFAF",
      "transform": "rotate(-20 2716.03 314.67)",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_shoulder",
      "fill": "#FFE018",
      "d": "M2708.8 293.36c3.42-1.25 7.2.45 8.56 3.83l9.44 23.66-14.1 5.13-7.98-24.2c-1.14-3.46.67-7.2 4.08-8.44z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "player2_head"
    }
  }, [_c('path', {
    attrs: {
      "id": "player2_neck",
      "fill": "#CAA792",
      "d": "M2694.53 285.42c.4 2.38.62 4.05-.53 5.36.92 1.57 8.13 1.68 9 0-1.04-1.34-1.15-2.7-.53-5.36-.77-1.92-6.87-1.86-7.94 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_hair",
      "fill": "#B45D2A",
      "d": "M2702.17 243c9.4.2 17.36 5.85 18.25 16.07.88 10.22-3.88 15.73-5.3 16.96 6.8.03 2.73 11.54 12.88 6.68 0 4.22-4.66 7.8-8.6 8.2-3.92.4-11.32.12-10.43-9.08-1.17.98-4.8 3.87-9.75 3.98-4.95.1-13.56-4.57-15.4-12.44-.84-.5-4.87-7-1.5-18.6 2.66-9.1 10.45-11.93 19.85-11.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_face",
      "fill": "#DBBFAF",
      "fill-rule": "nonzero",
      "d": "M2715.25 268.8c1-.58 2.46-1.3 4.1 0 1.4 1.1.35 5.45-1.55 7.86-1.88 2.4-4.93 2.9-6.13 1.97-2.54 5.5-9 8.4-13.3 8.37-11.55-.1-16.37-11.34-16.37-20.67 0-7.85 4.53-12.3 12.8-13.17.27.97 2.95 4.57 3.66 4.73-.1-.97-.32-4.04-.2-4.9.38.93 1.7 3.64 2.4 3.77-.08-1.23-.1-2.73 0-3.68 8.2.54 15.6 4.1 14.6 15.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_ear",
      "fill": "#CAA792",
      "d": "M2714.08 272.28c.96-1.97 2.46-3.8 4.3-3.15 1.83.65-.52 7.88-5.38 7.87.56-.34 2.1-1.92 2.15-3.15.05-1.23-.36-1.85-1.07-1.57z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_10",
      "cx": "2702.5",
      "cy": "275.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_9",
      "cx": "2701.5",
      "cy": "277.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_8",
      "cx": "2704.5",
      "cy": "276.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_7",
      "cx": "2707.5",
      "cy": "275.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_6",
      "cx": "2706.5",
      "cy": "277.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_5",
      "cx": "2686.5",
      "cy": "274.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_4",
      "cx": "2685.5",
      "cy": "276.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_3",
      "cx": "2688.5",
      "cy": "275.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_2",
      "cx": "2691.5",
      "cy": "274.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_freckles_1",
      "cx": "2691.5",
      "cy": "277.5",
      "r": "1",
      "fill": "#C6A089"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_mouth_open",
    attrs: {
      "id": "player2_mouth_open_bottom",
      "fill": "#CAA792",
      "fill-rule": "nonzero",
      "d": "M2694.2 281c-.56.48.04 3 2.27 3 2.24 0 4.7-2.47 4.52-2.7-.17-.25-2.46 1.2-4.53 1.2-2.23-.05-2.28-1.5-2.28-1.5z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_mouth_closed",
    attrs: {
      "id": "player2_mouth_bottom",
      "fill": "#CAA792",
      "fill-rule": "nonzero",
      "d": "M2694 281.04c.8.15 5.3.2 6.8-.03.8-.1-1 1-4 1s-2.8-.96-2.8-.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_mouth_top",
      "fill": "#AB836B",
      "fill-rule": "nonzero",
      "d": "M2693 280.83c0-.45.53-.83 3.28-.83 1.9 0 4.96.62 6.5.34.3-.06.3.1-.1.2-1.97.46-3.87.46-6.77.46-1.9-.03-2.9-.17-2.9-.17z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_nose",
      "fill": "#CAA792",
      "d": "M2695.2 269.77c0-.98 2.45-1.07 2.45 0 0 1.06.8 6.62 0 7.6-.78 1-3.1.66-3.44 0-.35-.65-.28-1.72.5-2.02.77-.3.5-4.6.5-5.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_eye_whites",
      "fill": "#FFF",
      "d": "M2701 271.36c1.3-3.94 7.13-4.54 8-1.13 0 4.6-7.05 5-8 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_left_pupil",
      "cx": "2706",
      "cy": "271",
      "r": "2",
      "fill": "#778F5F"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_eye_lid",
    attrs: {
      "id": "player2_left_eye_lids",
      "fill": "#C09880",
      "d": "M2701 271.36c1.3-3.94 7.13-4.54 8-1.13 0 4.6-7.05 5-8 1.13z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_eye_whites",
      "fill": "#FFF",
      "d": "M2693 271.36c-1.3-3.94-7.13-4.54-8-1.13 0 4.6 7.05 5 8 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_right_pupil",
      "cx": "2690",
      "cy": "271",
      "r": "2",
      "fill": "#778F5F"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "player_eye_lid",
    attrs: {
      "id": "player2_right_eye_lids",
      "fill": "#C09880",
      "d": "M2693 271.36c-1.3-3.94-7.13-4.54-8-1.13 0 4.6 7.05 5 8 1.13z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_right_brow",
      "fill": "#5F3A19",
      "fill-rule": "nonzero",
      "d": "M2693 265.96c-.96-.03-5.88-.13-7.8.04-.9.06 1.16-1 4.6-1 3.44 0 3.2.96 3.2.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "player2_left_brow",
      "fill": "#5F3A19",
      "fill-rule": "nonzero",
      "d": "M2701 265.96c.94-.03 5.88-.16 7.8.03.88.1-1.17-1-4.58-1-3.45 0-3.22.96-3.22.96z"
    }
  })])]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "car_back_tire_2",
      "cx": "3299.5",
      "cy": "449.5",
      "r": "34.5",
      "fill": "#3B3B3B"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "car_back_tire_1",
      "cx": "3300",
      "cy": "449",
      "r": "22",
      "fill": "#D8D8D8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "car_front_tire_2",
      "cx": "3541.5",
      "cy": "449.5",
      "r": "34.5",
      "fill": "#3B3B3B"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "car_front_tire_1",
      "cx": "3541",
      "cy": "449",
      "r": "22",
      "fill": "#D8D8D8"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "car_body"
    }
  }, [_c('path', {
    attrs: {
      "id": "car_Path-3",
      "fill": "#4A90E2",
      "stroke": "#4A90E2",
      "d": "M3486.08 374.1c-12.1-8.75-21.06-34.23-37.77-39.3-16.7-5.05-79.06-10.67-121.36 9.1-42.3 19.78-76.6 66.67-85.94 101.24h18.5c.48-5 9.1-34.76 40.67-34.57 31.56.2 41.12 22.2 40.95 45.43 10.62 0 151.6-.1 160.4 0-1.1-26.02 12.38-45.43 38.36-45.43 25.97 0 42.27 19.58 44.06 34.57H3603c-4.5-30.12-36.57-73.47-116.92-71.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_rim",
      "fill": "#79ABE5",
      "d": "M3256 443.8h4.88c.42-4.26 8.22-32.52 39.18-32.7 30.96-.18 39.5 22.88 39.33 45.9h7c6.23-28.17-2.5-60.53-46.34-60-39.17.5-44.13 37.68-44.06 46.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_front_rim",
      "fill": "#79ABE5",
      "d": "M3497.4 457h4.93c-1.76-21.46 8.47-45.32 39.17-45.32 23.93 0 37.7 16.9 40.3 32.9h6c2.1-24.4-12.22-48.58-46.04-48.58-48.48 0-50.32 49.77-44.35 61z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_bumper_2",
      "fill": "#D8D8D8",
      "d": "M3242.14 443H3263l-2.45 12h-18.4c-3.4 0-6.15-2.7-6.15-6s2.75-6 6.14-6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_bumper_1",
      "fill": "#D8D8D8",
      "d": "M3602.9 443H3581l1.22 12h20.7c3.35 0 6.08-2.7 6.08-6s-2.73-6-6.1-6z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "car_gas",
      "cx": "3297.5",
      "cy": "385.5",
      "r": "7.5",
      "fill": "#3F80CB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_door_6",
      "fill": "#3F80CB",
      "d": "M3400 334c-13.6 0-36.3.6-47.34 6.48-11.04 5.88-32.5 28.58-39.66 38.05v14.3c33.47 6.5 42.48 30.6 38.42 59.17H3400V334z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_door_5",
      "fill": "#79ABE5",
      "d": "M3324 389h20c0-3.4-3.33-5.07-10-5-6.67.08-10 1.74-10 5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_door_4",
      "fill": "#3771B4",
      "d": "M3325 389h18c-.67 1.95-3.67 2.95-9 3-5.33.05-8.33-.95-9-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_door_3",
      "fill": "#DEEBFB",
      "d": "M3396.53 338c-13.6 0-33.38-.35-43.35 6.48-9.96 6.83-24.65 21.24-32.65 31.06-.32.38-.5.83-.53 1.33-.07 1.1.77 2.06 1.87 2.13h71.66c1.65 0 3-1.34 3-3v-38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_door_2",
      "fill": "#FFF",
      "d": "M3376 338.4c-2.4.2-4.77.5-7.04.87-.37.67-9.68 13.92-27.96 39.73h7.83c17.57-26.17 26.63-39.7 27.17-40.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_door_1",
      "fill": "#FFF",
      "d": "M3387.38 338c-1.15 0-2.3.03-3.5.06-1.16 2.06-9.8 15.7-25.88 40.92h4.04l25.34-40.98z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_front_door_6",
      "fill": "#3F80CB",
      "d": "M3403 334c13.6 0 36.3.6 47.34 6.48 11.04 5.88 22.5 28.58 29.66 38.05V452h-77V334z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_front_door_5",
      "fill": "#79ABE5",
      "d": "M3407 389h20c0-3.4-3.33-5.07-10-5-6.67.08-10 1.74-10 5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_front_door_4",
      "fill": "#3771B4",
      "d": "M3408 389h18c-.67 1.95-3.67 2.95-9 3-5.33.05-8.33-.95-9-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_front_door_3",
      "fill": "#DEEBFB",
      "d": "M3407 338c13.6 0 31.38-.35 41.34 6.48 9.97 6.83 17.66 21.24 25.66 31.06.32.38.5.83.52 1.33.08 1.1-.76 2.06-1.86 2.13H3410c-1.66 0-3-1.34-3-3v-38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_front_door_2",
      "fill": "#FFF",
      "d": "M3440.6 341c.96.3 1.88.63 2.76 1-1.14 1.94-9.13 14.3-24 37.05H3416c15.6-24.12 23.82-36.8 24.6-38.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_front_door_1",
      "fill": "#FFF",
      "d": "M3448.5 345c1.9 1.3 3.74 2.9 5.5 4.68-1.87 2.93-7.95 12.7-18.23 29.32H3427c11.84-19 19-30.33 21.5-34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_mirror",
      "fill": "#79ABE5",
      "d": "M3478 373v19.85c5.34 0 7.97-3.3 7.9-9.93-.07-6.6-2.7-9.92-7.9-9.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_head_light",
      "fill": "#FFF",
      "d": "M3582.24 404.88c9.04-4.3 17.47 8.1 12.05 17.12-6.22-.5-13.76-10.85-12.06-17.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "car_back_light",
      "fill": "#C13849",
      "d": "M3258.4 406.16c-5.77-1.82-12.9 12.16-9.53 16.93 3.73-1.52 9.86-13.66 9.54-16.94z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "car_music",
    attrs: {
      "d": "M3523.0265,347.994751 C3520.80273,347.994751 3519,346.651958 3519,344.995538 C3519,343.339119 3520.80273,341.996325 3523.0265,341.996325 C3523.75878,341.996325 3524.44541,342.141933 3525.03704,342.396399 C3525.03704,341.916523 3525.02469,337.117723 3525,328 L3537,327 L3535,331 L3527,332 C3527,340.561954 3527,344.8938 3527,344.995538 C3527,346.651958 3525.25028,347.994751 3523.0265,347.994751 Z M3533.0265,346.994751 C3530.80273,346.994751 3529,345.651958 3529,343.995538 C3529,342.339119 3530.80273,340.996325 3533.0265,340.996325 C3533.75878,340.996325 3534.44541,341.141933 3535.03704,341.396399 C3535.03704,340.916523 3535.02469,337.451057 3535,331 L3537,327 C3537,338.228621 3537,343.8938 3537,343.995538 C3537,345.651958 3535.25028,346.994751 3533.0265,346.994751 Z",
      "id": "car_music_2",
      "fill": "#3B3B3B"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "car_music",
    attrs: {
      "d": "M3506.0265,352.994751 C3508.25028,352.994751 3510.053,351.651958 3510.053,349.995538 C3510.053,349.842932 3510.053,346.847502 3510.053,337.010299 C3511.05766,338.010036 3516.10505,337.010299 3515.1037,341.095652 C3518.08942,335.993354 3513.07288,337.000047 3508.03704,332.994751 C3508.03704,333.720024 3508.03704,346.676585 3508.03704,347.396399 C3507.44541,347.141933 3506.75878,346.996325 3506.0265,346.996325 C3503.80273,346.996325 3502,348.339119 3502,349.995538 C3502,351.651958 3503.80273,352.994751 3506.0265,352.994751 Z",
      "id": "car_music_1",
      "fill": "#3B3B3B"
    }
  })]), _vm._v(" "), _c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pins_active),
      expression: "pins_active"
    }],
    attrs: {
      "id": "pin_group"
    }
  }, [_c('g', {
    staticClass: "pin",
    on: {
      "click": function($event) {
        _vm.pin_open('ad')
      },
      "mouseenter": function($event) {
        _vm.pin_audio.play()
      }
    }
  }, [_c('g', {
    attrs: {
      "id": "pin_ad_3"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#000",
      "filter": "url(#filter-2)",
      "xlink:href": "#path-1"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#383838",
      "xlink:href": "#path-1"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "pin_ad_2",
      "cx": "4169.81",
      "cy": "175.81",
      "r": "26.81",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "pin_ad_1",
      "fill": "#4A4A4A",
      "points": "4178 177.6 4171.6 177.6 4171.6 184 4168.4 184 4168.4 177.6 4162 177.6 4162 174.4 4168.4 174.4 4168.4 168 4171.6 168 4171.6 174.4 4178 174.4"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "pin",
    on: {
      "click": function($event) {
        _vm.pin_open('texter')
      },
      "mouseenter": function($event) {
        _vm.pin_audio.play()
      }
    }
  }, [_c('g', {
    attrs: {
      "id": "pin_texter_3"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#000",
      "filter": "url(#filter-4)",
      "xlink:href": "#path-3"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#BD10E0",
      "xlink:href": "#path-3"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "pin_texter_2",
      "cx": "4424.81",
      "cy": "175.81",
      "r": "26.81",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "pin_texter_1",
      "fill": "#4A4A4A",
      "points": "4433 177.6 4426.6 177.6 4426.6 184 4423.4 184 4423.4 177.6 4417 177.6 4417 174.4 4423.4 174.4 4423.4 168 4426.6 168 4426.6 174.4 4433 174.4"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "pin",
    on: {
      "click": function($event) {
        _vm.pin_open('dylan')
      },
      "mouseenter": function($event) {
        _vm.pin_audio.play()
      }
    }
  }, [_c('g', {
    attrs: {
      "id": "pin_dylan_3"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#000",
      "filter": "url(#filter-6)",
      "xlink:href": "#path-5"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#778F5F",
      "xlink:href": "#path-5"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "pin_dylan_2",
      "cx": "3806.81",
      "cy": "175.81",
      "r": "26.81",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "pin_dylan_1",
      "fill": "#4A4A4A",
      "points": "3815 177.6 3808.6 177.6 3808.6 184 3805.4 184 3805.4 177.6 3799 177.6 3799 174.4 3805.4 174.4 3805.4 168 3808.6 168 3808.6 174.4 3815 174.4"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "pin",
    on: {
      "click": function($event) {
        _vm.pin_open('car')
      },
      "mouseenter": function($event) {
        _vm.pin_audio.play()
      }
    }
  }, [_c('g', {
    attrs: {
      "id": "pin_car_3"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#000",
      "filter": "url(#filter-8)",
      "xlink:href": "#path-7"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#4A90E2",
      "xlink:href": "#path-7"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "pin_car_2",
      "cx": "3402.81",
      "cy": "245.81",
      "r": "26.81",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "pin_car_1",
      "fill": "#4A4A4A",
      "points": "3411 247.6 3404.6 247.6 3404.6 254 3401.4 254 3401.4 247.6 3395 247.6 3395 244.4 3401.4 244.4 3401.4 238 3404.6 238 3404.6 244.4 3411 244.4"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_88",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2423.9 111.8c0 61.47-39.05 127.65-114.23 136.12-14.58 1.64-23.5-4.5-39.6-9.26-41.26-12.2-143.6-49.1-152.44-132.16-4.1 104.1 116.5 135.34 160.83 170.27 16.74 13.2 33.96 19.4 38.27 9.23 4.47-10.57 52.12-32.7 72.73-52.2 19.2-18.2 48.74-75.04 34.44-122z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_87",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2326.96 97.04c-26.7 49.03-32.02 80.27-48.06 80.27s-39.9-36.42-63.32-69.1c13.4 43.54 36.44 65.9 55.58 130.62.64 2.18 1.3 4.42 1.92 6.7 2.63 9.42 4.26 19.8 5.05 30.7 5.08 69.62-23.66 161.66-43.94 172.34h90.02c16.25-32.53 2.74-119.47-20.54-233.95-5.3-26.13 14.87-72.5 23.28-117.56z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_86",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2087 110.8c12.94-3.4 25.37 9.27 23.46 21.4-10.26 3.92-25.17-7.77-23.47-21.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_85",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2088.26 162.7c7.53-11.07 25.22-9.66 31.74.75-5.17 9.68-24.1 10.65-31.74-.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_84",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2151.96 118.16c7.64 11 0 27-12.07 29.37-7.2-8.3-1.3-26.3 12.06-29.37z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_83",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2120.3 69.43c10.67 8.1 8.34 25.7-2.4 31.66-9.4-5.67-9.37-24.62 2.4-31.67z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_82",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2243.3 77.67c6.46 11.74-2.83 26.86-15.06 27.94-6.28-9 1.45-26.3 15.07-27.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_81",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2269.1 53.54c11.57 6.75 11.4 24.5 1.47 31.72-10.02-4.48-12.3-23.3-1.47-31.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_80",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2235.74 32.77c13.18 2.4 19.1 19.12 12.23 29.3-10.95-.78-19.53-17.67-12.23-29.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_79",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2300.4 27.57c8.57 10.3 2.34 26.9-9.46 30.3-7.88-7.63-3.6-26.08 9.46-30.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_78",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2165.96 76.1c7.05 11.4-1.43 26.97-13.6 28.7-6.73-8.67.08-26.35 13.6-28.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_77",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2144.64 47.44c10.52 8.3 7.88 25.83-2.96 31.6-9.3-5.82-8.94-24.77 2.96-31.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_76",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2264.7 108.36c2.97 13.06-10.13 25.04-22.2 22.7-3.54-10.38 8.66-24.88 22.2-22.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_75",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2365.1 98.78c-3.3 12.98-20.4 17.7-30.1 10.15 1.55-10.86 19-18.24 30.1-10.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_74",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2357.17 136.56c-6.34 11.8-24.08 12.25-31.65 2.58 4.13-10.17 22.85-13.1 31.65-2.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_73",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2348.2 166.23c-6.35 11.8-24.08 12.25-31.65 2.58 4.12-10.16 22.85-13.1 31.64-2.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_72",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2350.3 57.2c6.03 11.96-3.78 26.74-16.04 27.4-5.97-9.22 2.36-26.24 16.04-27.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_71",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2300.74 66.64c13.38-.65 22.9 14.32 18.5 25.8-10.83 1.7-23-12.84-18.5-25.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_70",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2288.96 93.08c13.38.53 21.56 16.27 16.2 27.32-10.96.75-21.8-14.8-16.2-27.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_69",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2270.73 131.9c13.38-.63 22.9 14.34 18.5 25.8-10.84 1.7-23-12.82-18.5-25.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_68",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2195.3 67.5c13.3 1.7 20.06 18.08 13.75 28.62-10.98-.2-20.43-16.63-13.75-28.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_67",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2175.8 114.76c7.34-11.2 25.05-10.1 31.75.2-5 9.76-23.9 11.06-31.75-.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_66",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2189.55 147c6.13-11.9 23.86-12.67 31.6-3.13-3.95 10.24-22.62 13.5-31.6 3.13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_65",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2140.1 233.7c1.44-13.3 17.72-20.37 28.36-14.24 0 10.98-16.27 20.7-28.37 14.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_64",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2172.8 259.53c-2.5-13.16 11-24.67 22.98-21.92 3.2 10.5-9.5 24.57-22.97 21.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_63",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2109.26 198.7c7.53-11.07 25.22-9.66 31.74.75-5.17 9.68-24.1 10.65-31.74-.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_62",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2177.8 148.97c7.64 11 0 27-12.06 29.36-7.2-8.3-1.3-26.3 12.07-29.36z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_61",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2209.03 167.96c7.63 11-.02 27-12.07 29.36-7.2-8.3-1.3-26.3 12.07-29.36z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_60",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2389.2 114.68c12.76-4.08 25.83 7.92 24.56 20.14-10.03 4.44-25.54-6.45-24.56-20.14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_59",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2393.53 72.63c13.07-2.95 25.04 10.14 22.7 22.2-10.38 3.56-24.88-8.65-22.7-22.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_58",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2384.52 38c8.93 10 3.28 26.82-8.4 30.62-8.14-7.35-4.5-25.95 8.4-30.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_57",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2460.1 117.66c1.8 13.27-12.28 24.06-24.1 20.7-2.63-10.67 10.8-24.05 24.1-20.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_56",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2424.48 39.2c11.9 6.14 12.67 23.87 3.13 31.6-10.23-3.94-13.5-22.6-3.12-31.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_55",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2460.5 175.83c-3.53 12.92-20.7 17.35-30.27 9.63 1.74-10.84 19.32-17.92 30.26-9.63z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_54",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2450.94 80.56c4.96 12.44-6.1 26.32-18.37 25.9-5.14-9.7 4.64-25.93 18.37-25.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_53",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2381.17 144.08c13.27-1.8 24.06 12.28 20.68 24.1-10.65 2.63-24.03-10.8-20.68-24.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_52",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2361.03 178.16c13.28-1.8 24.07 12.27 20.7 24.08-10.66 2.64-24.04-10.78-20.7-24.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_51",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2418.5 259.23c-12.36 5.18-26.43-5.63-26.22-17.9 9.6-5.32 26 4.18 26.2 17.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_50",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2440.16 227.84c-11.5 6.85-26.95-1.9-28.46-14.1 8.78-6.58 26.34.54 28.46 14.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree2_49",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M2339.18 199.5c12.92 3.53 17.35 20.7 9.63 30.27-10.83-1.74-17.9-19.32-9.62-30.26z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_48",
      "cx": "2233.5",
      "cy": "202.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4467 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_47",
      "cx": "2190.5",
      "cy": "165.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4381 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_46",
      "cx": "2156.5",
      "cy": "152.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4313 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_45",
      "cx": "2171.5",
      "cy": "131.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4343 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_44",
      "cx": "2138.5",
      "cy": "102.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4277 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_43",
      "cx": "2096.5",
      "cy": "89.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4193 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_42",
      "cx": "2088.5",
      "cy": "145.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4177 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_41",
      "cx": "2121.5",
      "cy": "180.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4243 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_40",
      "cx": "2207.5",
      "cy": "251.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4415 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_39",
      "cx": "2151.5",
      "cy": "250.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4303 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_38",
      "cx": "2130.5",
      "cy": "221.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4261 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_37",
      "cx": "2239.5",
      "cy": "265.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4479 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_36",
      "cx": "2230.5",
      "cy": "174.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4461 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_35",
      "cx": "2259.5",
      "cy": "145.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4519 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_34",
      "cx": "2280.5",
      "cy": "120.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4561 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_33",
      "cx": "2222.5",
      "cy": "65.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4445 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_32",
      "cx": "2181.5",
      "cy": "91.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4363 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_31",
      "cx": "2171.5",
      "cy": "61.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4343 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_30",
      "cx": "2201.5",
      "cy": "51.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4403 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_29",
      "cx": "2263.5",
      "cy": "35.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4527 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_28",
      "cx": "2209.5",
      "cy": "128.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4419 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_27",
      "cx": "2259.5",
      "cy": "91.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4519 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_26",
      "cx": "2286.5",
      "cy": "76.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4573 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_25",
      "cx": "2322.5",
      "cy": "53.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4645 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_24",
      "cx": "2365.5",
      "cy": "81.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4731 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_23",
      "cx": "2350.5",
      "cy": "41.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4701 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_22",
      "cx": "2356.5",
      "cy": "120.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4713 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_21",
      "cx": "2317.5",
      "cy": "196.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4635 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_20",
      "cx": "2324.5",
      "cy": "151.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4649 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_19",
      "cx": "2377.5",
      "cy": "169.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4755 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_18",
      "cx": "2365.5",
      "cy": "150.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4731 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_17",
      "cx": "2347.5",
      "cy": "185.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4695 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_16",
      "cx": "2321.5",
      "cy": "231.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4643 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_15",
      "cx": "2386.5",
      "cy": "98.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4773 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_14",
      "cx": "2375.5",
      "cy": "128.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4751 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_13",
      "cx": "2404.5",
      "cy": "58.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4809 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_12",
      "cx": "2445.5",
      "cy": "57.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4891 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_11",
      "cx": "2410.5",
      "cy": "26.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4821 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_10",
      "cx": "2454.5",
      "cy": "106.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4909 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_9",
      "cx": "2435.5",
      "cy": "163.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4871 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_8",
      "cx": "2451.5",
      "cy": "149.63",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4903 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_7",
      "cx": "2433.5",
      "cy": "202.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4867 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_6",
      "cx": "2441.5",
      "cy": "243.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4883 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_5",
      "cx": "2415.5",
      "cy": "237.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4831 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_4",
      "cx": "2381.5",
      "cy": "258.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4763 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_3",
      "cx": "2362.5",
      "cy": "213.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4725 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_2",
      "cx": "2359.5",
      "cy": "265.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4719 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree2_1",
      "cx": "2390.5",
      "cy": "185.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 4781 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_14",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1734 394h350l-4.73 26.2c-3 16.68-17.5 28.8-34.44 28.8h-271.66c-16.93 0-31.43-12.12-34.44-28.8L1734 394z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "fountain_13",
      "width": "370",
      "height": "10",
      "x": "1724",
      "y": "384",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "fountain_12",
      "width": "90",
      "height": "120",
      "x": "1864",
      "y": "264",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_11",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1862 264h95c1.1 0 2-.9 2-2 0-.16-.02-.33-.06-.5l-4-16c-.23-.88-1.03-1.5-1.95-1.5h-87c-.9 0-1.7.62-1.93 1.5l-4 16c-.28 1.1.37 2.17 1.44 2.44.17.04.34.06.5.06z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "fountain_10",
      "width": "50",
      "height": "90",
      "x": "1884",
      "y": "154",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_9",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1844 124h130l-1.98 6c-4.74 14.32-18.14 24-33.23 24h-59.6c-15.08 0-28.48-9.68-33.22-24l-1.98-6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_8",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1842 124h134c1.1 0 2-.9 2-2 0-.45-.16-.9-.44-1.25l-3.9-4.88c-.96-1.18-2.4-1.87-3.9-1.87h-121.5c-1.52 0-2.96.7-3.9 1.87l-3.92 4.88c-.7.86-.55 2.12.3 2.8.36.3.8.45 1.26.45z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_7",
      "stroke": "#FFF",
      "stroke-dasharray": "10",
      "stroke-width": "2",
      "d": "M2052.48 384c13.33-180-11.23-270-73.67-270H1918"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_6",
      "stroke": "#FFF",
      "stroke-dasharray": "10",
      "stroke-width": "2",
      "d": "M2011.48 384c13.33-180-11.22-270-73.66-270H1908"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_5",
      "stroke": "#FFF",
      "stroke-dasharray": "10",
      "stroke-width": "2",
      "d": "M1972.68 384c9.8-180.53-11.44-270.53-63.68-270"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_4",
      "stroke": "#FFF",
      "stroke-dasharray": "10",
      "stroke-width": "2",
      "d": "M1909 114v270"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_3",
      "stroke": "#FFF",
      "stroke-dasharray": "10",
      "stroke-width": "2",
      "d": "M1845.32 384c-9.8-180.53 11.44-270.53 63.68-270"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_2",
      "stroke": "#FFF",
      "stroke-dasharray": "10",
      "stroke-width": "2",
      "d": "M1804.52 384c-13.33-180 11.22-270 73.66-270H1908"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fountain_1",
      "stroke": "#FFF",
      "stroke-dasharray": "10",
      "stroke-width": "2",
      "d": "M1764.52 384c-13.33-180 11.23-270 73.67-270h60.8"
    }
  }), _vm._v(" "), _c('g', {
    class: _vm.reeceData,
    attrs: {
      "id": "reeceModuleTwo"
    }
  }, [_c('g', {
    attrs: {
      "id": "reece_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "reece_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "reece_right_hand",
      "fill": "#DBBFAF",
      "d": "M1922.52 350.15c-.15 1.37-1.13 2.03-2.17 3.55-1.22 1.77-1.44 5.15-2.86 7.88.25.7 2.32-.34 2.83-1.44.52-1.1.9-2 1.08-2.27.18-.28.52-.22.6.06.07.3-.68 10.25-.52 10.76.17.5 1.36.65 1.62.17.25-.5 1.03-8.35 1.16-8.55.12-.2.37-.07.47.05.1.12-.96 8.5-.8 8.83.14.33 1.37.4 1.53.17.16-.25 1.07-8.62 1.22-8.8.15-.17.42-.12.52.06.1.2-1.04 8.2-.9 8.58.17.38 1.36.5 1.5.17.15-.34 1.23-8.42 1.36-8.52.13-.1.28-.08.38.04.1.1-.4 6.17-.25 6.52.15.35 1.04.53 1.2.13.2-.4 1.07-15.22 1.17-16.04.34-2.7-.93-5.73-4.06-6.06-3.12-.34-4.76 1.8-5.08 4.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_arm_bottom",
      "fill": "#CAA16C",
      "d": "M1930.5 316.94c3.83.4 6.6 3.92 6.2 7.84 0 .1 0 .2-.03.3l-3.7 25.66c-.18 1.26-1.3 2.15-2.54 2l-7.15-.75c-1.23-.15-2.15-1.26-2.07-2.53l1.6-25.9c.25-3.92 3.56-6.9 7.4-6.66l.3.04z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_arm_top",
      "fill": "#CAA16C",
      "d": "M1932.97 290.8c3.83.43 6.6 3.93 6.2 7.85l-2.67 25.98c-.4 3.9-3.83 6.75-7.66 6.34-3.83-.4-6.6-3.92-6.2-7.83l2.67-25.98c.4-3.92 3.84-6.76 7.67-6.35z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_shoe_4",
      "fill": "#4F3007",
      "d": "M1930.18 434.23h12.54V448h-27.1c.23-3.94 2.1-6.24 5.63-6.9 3.52-.63 6.5-2.93 8.93-6.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_shoe_3",
      "fill": "#BA9463",
      "d": "M1942.72 446.1v1.88h-27.1c.1-.87.18-1.5.27-1.88h26.82z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "reece_right_shoe_2",
      "fill": "#BA9463",
      "points": "1930.74164 440.81145 1929.73702 442.089288 1925.85046 439.47644 1927.08435 438.5"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "reece_right_shoe_1",
      "fill": "#BA9463",
      "points": "1932.92614 437.748187 1931.99458 439.146979 1928.17371 436.926678 1929.14407 435.65"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_leg_bottom",
      "fill": "#5580B0",
      "d": "M1936.5 380c5.25 0 9.5 4.25 9.5 9.5V435h-19v-45.5c0-5.25 4.25-9.5 9.5-9.5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "reece_right_leg_top",
      "width": "18.59",
      "height": "59.38",
      "x": "1927.24",
      "y": "339.23",
      "fill": "#5580B0",
      "rx": "9.29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_left_shoe_4",
      "fill": "#633C09",
      "d": "M1951.1 434.23h12.53V448h-27.1c.23-3.94 2.1-6.24 5.63-6.9 3.52-.63 6.5-2.93 8.93-6.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_left_shoe_3",
      "fill": "#BA9463",
      "d": "M1963.63 446.1v1.88h-27.1c.1-.87.18-1.5.27-1.88h26.83z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "reece_left_shoe_2",
      "fill": "#BA9463",
      "points": "1951.65082 440.81145 1950.6462 442.089288 1946.75964 439.47644 1947.99353 438.5"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "reece_left_shoe_1",
      "fill": "#BA9463",
      "points": "1953.83532 437.748187 1952.90376 439.146979 1949.08289 436.926678 1950.05325 435.65"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_left_leg_bottom",
      "fill": "#5580B0",
      "d": "M1957.5 380c5.25 0 9.5 4.25 9.5 9.5V435h-19v-45.5c0-5.25 4.25-9.5 9.5-9.5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "reece_left_leg_top",
      "width": "18.59",
      "height": "59.38",
      "x": "1948.15",
      "y": "339.23",
      "fill": "#5580B0",
      "rx": "9.29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_hip",
      "fill": "#5580B0",
      "d": "M1927.24 329.73h39.5v6.37c0 10.9-8.84 19.75-19.75 19.75-10.9 0-19.76-8.84-19.76-19.75v-6.38z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "reece_bag_3",
      "width": "39.32",
      "height": "56.48",
      "x": "1934.68",
      "y": "285.07",
      "fill": "#333",
      "rx": "19.66"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_top_3",
      "fill": "#F9F8F2",
      "d": "M1946.4 336c14.06.32 21.83.7 21.93 12.3.02 2.56-7 8.23-13.18 10.5-4.3-1.52-8.17-4.6-11.6-9.24-3.6 3.34-7.36 5.76-11.3 7.24-6.47-3.37-6.3-11-5.6-16.02.72-5 5.7-5.1 19.76-4.77z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_top_2",
      "fill": "#BA9463",
      "d": "M1930.4 290.24c4.74-6.2 27.03-5 32.5 0 7.86 7.18 6.78 53.64 6.16 54.63-5.52 8.88-37.85 5.96-41.92 1.46-1.74-1.92-1.44-5.22-.72-10.23.72-5.02 1.9-43.16 3.98-45.86z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_top_1",
      "fill": "#F9F8F2",
      "d": "M1935.77 285.17c.73-1.92 3.05-.6 8.75-.7 5.7-.1 8.72-1.8 9.46 0 .06.64.5 2.4 0 3.5s-4.3 7.54-6.58 9.14c-2.93-2.02-4.04-4.85-5.48-6.45-3.3 2.22-4.97 3.5-6.57 4.53-.92-1.5-1-6.24.42-10z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_bag_2",
      "fill": "#4A4A4A",
      "d": "M1958.6 287.93c2.42.02 4.25 1.53 5.55 3.2-11.23-.1-8.96 23.7-5.55 33.1 0 .87-.18 3.98 0 5-10.03-9.48-15.1-37.13 0-41.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_bag_1",
      "fill": "#4A4A4A",
      "d": "M1927.5 294.14c.52-3.3 3.42-5.18 5.2-5.74-2.23 11.83-4.03 26.02-5.2 36.9-1.64-12.5-1.53-21.23 0-31.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_left_hand",
      "fill": "#DBBFAF",
      "d": "M1959.42 350.64c0 1.37-.9 2.14-1.8 3.76-1.02 1.9-.9 5.27-2.03 8.13.32.66 2.27-.58 2.67-1.73.4-1.15.7-2.08.84-2.37.15-.3.5-.28.6 0 .1.27.38 10.27.6 10.76.2.47 1.4.5 1.6 0 .22-.52.2-8.43.3-8.64.1-.2.36-.1.47 0 .1.1-.08 8.56.1 8.87.17.3 1.4.26 1.54 0 .15-.26.2-8.68.33-8.87.13-.2.4-.17.52 0 .1.17-.2 8.28 0 8.63.2.33 1.4.34 1.5 0 .1-.37.35-8.52.47-8.64.12-.12.27-.1.38 0 .1.1.23 6.2.42 6.53.2.32 1.1.4 1.24 0 .13-.42-.5-15.26-.5-16.1.07-2.73-1.5-5.6-4.65-5.6-3.14 0-4.56 2.3-4.58 5.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_left_arm_bottom",
      "fill": "#CAA16C",
      "d": "M1963.96 316.9c3.86 0 6.98 3.13 6.98 6.98v.3l-.96 23.55c-.1 2.68-2.32 4.8-5 4.8h-2.04c-2.68 0-4.9-2.12-5-4.8l-.96-23.56c-.16-3.86 2.84-7.1 6.7-7.26h.28z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "reece_left_arm_top",
      "width": "14",
      "height": "40",
      "x": "1957",
      "y": "291",
      "fill": "#CAA16C",
      "rx": "7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_neck",
      "fill": "#CAA792",
      "d": "M1939.88 282.76c.38 2.5.53 3.5-.55 4.87.18.35 1.04 1.42 2.58 3.2 4.45-1.34 6.85-2.4 7.22-3.2-.98-1.4-.93-2.08-.34-4.87-.73-2-7.9-1.95-8.9 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_face",
      "fill": "#DBBFAF",
      "fill-rule": "nonzero",
      "d": "M1961.14 265.8c1-.6 2.4-1.35 4 0 1.4 1.15.35 5.68-1.5 8.18-1.84 2.48-4.83 3-6 2.04-2.48 5.7-8.8 8.73-13 8.7-11.3-.1-16-11.78-16-21.47 0-15.3 5.98-20.45 16-20.45 9-.05 18.97 4.8 16.5 23z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_mouth_bottom",
      "fill": "#CAA792",
      "d": "M1939.5 278.9h7.23c.74 0-1.93 1.44-4.34 1.44-2.4 0-3.55-1.44-2.9-1.44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_mouth_top",
      "fill": "#AB836B",
      "d": "M1938.63 278.92h9.02c.93 0-2.42-1.92-5.42-1.92s-4.43 1.92-3.6 1.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_ear",
      "fill": "#CAA792",
      "d": "M1960.3 269.75c.9-1.92 2.3-3.7 4-3.07 1.7.63-.47 7.68-5 7.67.53-.33 1.96-1.87 2-3.07.05-1.2-.33-1.8-1-1.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_nose",
      "fill": "#CAA792",
      "d": "M1940.87 265.9c0-1 2.48-1.08 2.48 0 0 1.07.8 6.67 0 7.67s-3.14.66-3.5 0c-.36-.66 1.02-6.7 1.02-7.67z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "reece_left_cheek",
      "cx": "1952.08",
      "cy": "273.89",
      "fill": "#DBB7A7",
      "rx": "3",
      "ry": "3.07"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "reece_right_cheek",
      "cx": "1935.36",
      "cy": "273.89",
      "fill": "#DBB7A7",
      "rx": "3",
      "ry": "3.07"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_left_eye_whites",
      "fill": "#FFF",
      "d": "M1947.22 265.88c1.3-3.1 7.13-3.6 8-.9 0 3.65-7.04 3.97-8 .9z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "reece_left_pupil",
      "cx": "1950.01",
      "cy": "265.74",
      "fill": "#3C2D20",
      "rx": "2",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_eye_whites",
      "fill": "#FFF",
      "d": "M1938.96 265.88c-1.3-3.1-7.12-3.6-8-.9 0 3.65 7.05 3.97 8 .9z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "reece_right_pupil",
      "cx": "1934.21",
      "cy": "265.74",
      "fill": "#3C2D20",
      "rx": "2",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_brow",
      "fill": "#322316",
      "d": "M1938.98 261.05c-.24-1.36-7.82-1.38-7.97-.17-.14 1.22 1.45.64 3.54.87 2.1.23 4.68.66 4.44-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "reece_right_brow",
      "fill": "#322316",
      "d": "M1947.02 261.05c.24-1.36 7.82-1.38 7.97-.17.14 1.22-1.45.64-3.54.87-2.1.23-4.68.66-4.44-.7z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "reece_hair",
      "fill": "#322316",
      "points": "1962.56994 260.462671 1961.33118 265.52323 1959.46397 268.589624 1958.93852 266.447485 1957.87581 270.762378 1955.63379 255.999386 1954.25709 260.100854 1951.30086 254.783081 1950.61251 259.339648 1946.68886 255.999386 1945.36093 261.442358 1940.54906 254.783081 1940.54906 259.339648 1934.46915 250.17688 1931.43124 258.595605 1930.74289 255.23999 1928.5054 266.447485 1927.35649 260.100854 1924.69293 261.442358 1926.74981 254.783081 1923.99187 255.23999 1932.43813 245.589233 1929.80497 244.067285 1934.27539 244.067285 1937.26158 240.561377 1937.26158 243.623364 1946.29023 239 1945.44102 241.73125 1955.18639 239 1952.90217 242.616309 1960.39326 242.616309 1957.06109 245.791943 1966.95824 250.828613 1961.16329 250.828613 1966.95824 257.593652 1962.26048 256.737648 1965.74126 261.442358"
    }
  })]), _vm._v(" "), _c('g', {
    class: _vm.haileyData,
    attrs: {
      "id": "haileyModuleTwo"
    }
  }, [_c('path', {
    attrs: {
      "id": "hailey_hair",
      "fill": "#DD9B2E",
      "d": "M1888.7 304.87h-37.66v-38.02c0-6.04-2.6-22.6 13.97-22.84 20.55-.3 23.5 8 23.7 18.84.14 7.23.14 21.24 0 42.03z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_bag_3",
      "width": "27.24",
      "height": "38.34",
      "x": "1846.89",
      "y": "288.6",
      "fill": "#333",
      "transform": "matrix(-1 0 0 1 3721.02 0)",
      "rx": "13.62"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "hailey_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "hailey_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "hailey_left_hand",
      "fill": "#DBBFAF",
      "d": "M1895.88 347.67c.22 1.35 1.26 1.96 2.4 3.42 1.32 1.7 1.73 5.05 3.32 7.7-.23.7-2.4-.22-2.98-1.3-.58-1.06-1.03-1.94-1.2-2.2-.2-.27-.54-.2-.6.1-.07.28 1.22 10.18 1.08 10.7-.14.52-1.35.73-1.63.26-.3-.47-1.5-8.27-1.63-8.46-.13-.2-.38-.05-.48.07-.1.13 1.42 8.43 1.3 8.77-.15.34-1.4.48-1.57.24-.2-.23-1.55-8.53-1.7-8.7-.18-.16-.45-.1-.54.1-.08.17 1.5 8.12 1.35 8.5-.13.37-1.34.57-1.5.24-.17-.34-1.7-8.34-1.82-8.44-.14-.1-.3-.06-.4.06-.08.13.75 6.15.6 6.5-.13.37-1.03.6-1.23.2-.2-.38-1.87-15.12-2.02-15.93-.5-2.7.65-5.77 3.82-6.27s4.95 1.53 5.43 4.44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_left_arm_bottom",
      "fill": "#6592C7",
      "d": "M1886.8 319.97c-2.6.4-4.36 2.84-3.95 5.42l3.7 23.42 9.36-1.48-3.7-23.43c-.4-2.58-2.83-4.34-5.4-3.93z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_left_arm_top",
      "fill": "#6592C7",
      "d": "M1882.45 290.08c-2.58.4-4.34 2.84-3.93 5.43l4.66 29.53c.4 2.58 2.84 4.35 5.42 3.94 2.6-.4 4.35-2.84 3.94-5.43l-4.67-29.52c-.4-2.6-2.83-4.35-5.42-3.94z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_left_shoe",
      "fill": "#633C09",
      "d": "M1886.86 423.8h-11.84V448h5.87c0-.92.48-1.38 1.48-1.4 1 0 1.48.46 1.46 1.4h15.86c-.3-3.66-1.4-5.92-3.3-6.8-5.12-2.34-7.97-5.14-8.6-7.44-.44-1.7-.76-5.03-.94-9.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_left_leg_bottom",
      "fill": "#CAA792",
      "d": "M1881 384c-3.3 0-6 2.7-6 6v34h12v-34c0-3.3-2.7-6-6-6z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_left_leg_top",
      "width": "12",
      "height": "52",
      "x": "1875",
      "y": "344",
      "fill": "#CAA792",
      "transform": "matrix(-1 0 0 1 3762 0)",
      "rx": "6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_right_shoe",
      "fill": "#73450A",
      "d": "M1867.44 423.8h-11.83V448h5.87c0-.92.5-1.38 1.5-1.4.98 0 1.47.46 1.46 1.4h15.85c-.3-3.66-1.4-5.92-3.28-6.8-5.14-2.34-8-5.14-8.6-7.44-.46-1.7-.78-5.03-.96-9.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_right_leg_bottom",
      "fill": "#CAA792",
      "d": "M1861 384c-3.3 0-6 2.7-6 6v34h12v-34c0-3.3-2.7-6-6-6z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_right_leg_top",
      "width": "12",
      "height": "52",
      "x": "1855",
      "y": "344",
      "fill": "#CAA792",
      "transform": "matrix(-1 0 0 1 3722 0)",
      "rx": "6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_skirt",
      "fill": "#333",
      "d": "M1884.67 325.13c5.84 19.53 8.8 29.8 8.87 30.82-1.02 1.8-3.13 3.24-5.9 4.33-.13-.1-.47-.5-1.02-1.23.07.9.07 1.43 0 1.6-2.03.7-4.35 1.22-6.82 1.57-.1-.13-.35-.65-.75-1.57-.16.9-.3 1.47-.42 1.72-2.08.25-4.24.38-6.42.4-.1-.2-.32-.8-.7-1.8-.24 1.03-.43 1.62-.55 1.78-1.97-.03-3.94-.16-5.83-.38-.1-.17-.2-.75-.34-1.75-.43.9-.74 1.44-.9 1.58-2.47-.35-4.8-.88-6.85-1.58-.05-.17-.05-.7 0-1.57-.5.63-.87 1.02-1.1 1.17-2.75-1.08-4.88-2.5-5.98-4.27.06-1.18 2.9-11.46 8.54-30.82h26.17z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_top_3",
      "fill": "#F9F8F2",
      "d": "M1871.15 289.07c-3.03 0-12 .56-14.5 1.34.5 6.8 1.6 15.96 2.64 24.03.1 5.06 0 7.57-1.28 11 4.17 1.25 21.6.72 26.38 0-.55-3.9-.63-5.2 0-11.68 5.6-5.3 0-13.96.8-22.65-3.27-1.82-11.03-2.03-14.05-2.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_top_2",
      "fill": "#5580B0",
      "d": "M1871.32 289.07c-3.02 0-13.72.64-15.25 1.66-1.54 1 .2 36.18.76 39.54.55 3.35 11.8 4.52 12.37.67.57-3.85.3-26.95-4.1-40.2.7-.33 11.66-.46 12.75-.33.6 4.62-1.7 37.84 0 40.54 1.88 2.96 9.42 2.02 10.7 0 1.27-2.02-2.42-38.68-3.2-39.84-.75-1.16-11-2.03-14.03-2.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_bag_2",
      "fill": "#4A4A4A",
      "d": "M1861.04 289.54c-1.26 0-4.34 0-5.37 1.06 6.4 0 5.37 23.08 5.67 26.08 0 .88.18 3.98 0 5 4.45-9.03 5.74-25.16-.3-32.14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_bag_1",
      "fill": "#4A4A4A",
      "d": "M1885.93 291.2c-1.1-1.08-2.07-1.57-3.9-2.13 2.28 11.82 5.7 21.94 6.77 31.52.17-14.6-2-28.55-2.87-29.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_top_1",
      "fill": "#6592C7",
      "d": "M1871.95 283.38c-11.72 0-11.66 5.97-10.7 9.7.93 3.73 1.92 6.74 6.5 9.04-.4-3.96-1.7-9.04-2.45-11.53h12.6c.23 3 0 7 0 11.52 2.84-2.16 4.5-4.32 5.04-9.04.53-4.7.74-9.7-11-9.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_right_hand",
      "fill": "#DBBFAF",
      "d": "M1861.22 349.33c0 1.38.94 2.14 1.83 3.76 1.05 1.87.92 5.26 2.08 8.12-.33.65-2.33-.6-2.74-1.74-.4-1.14-.72-2.08-.86-2.37-.14-.28-.5-.26-.6.02-.1.27-.38 10.25-.6 10.74-.22.5-1.45.5-1.66 0-.2-.5-.18-8.4-.28-8.62-.1-.2-.37-.1-.5 0-.1.1.1 8.55-.1 8.86-.17.32-1.43.26-1.56 0-.14-.26-.2-8.66-.32-8.86-.14-.2-.42-.16-.53 0-.13.17.18 8.27 0 8.62-.2.35-1.43.35-1.54 0-.12-.35-.37-8.5-.48-8.62-.12-.1-.28-.1-.4 0-.1.1-.23 6.2-.42 6.52-.2.33-1.12.4-1.26 0-.13-.4.52-15.23.5-16.05-.06-2.73 1.54-5.6 4.75-5.6 3.2 0 4.65 2.3 4.67 5.23z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_right_arm_bottom",
      "fill": "#6592C7",
      "d": "M1856.6 320.38c-2.6 0-4.73 2.12-4.73 4.74v23.73h9.47v-23.73c0-2.62-2.12-4.74-4.73-4.74z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_right_arm_top",
      "width": "9.47",
      "height": "39.38",
      "x": "1851.87",
      "y": "290.49",
      "fill": "#6592C7",
      "transform": "matrix(-1 0 0 1 3713.21 0)",
      "rx": "4.74"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_neck",
      "fill": "#CAA792",
      "d": "M1875.7 284.86c-.4 2.5 0 5.62 2.22 5.62-.32 1.5-1.95 4.1-5.1 4.1-3.14 0-6.64-1.48-7.28-4.1 2.5 0 3.1-2.83 2.5-5.62.74-2 6.62-1.94 7.65 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_face",
      "fill": "#DBBFAF",
      "fill-rule": "nonzero",
      "d": "M1854.26 267.45c-1-.6-2.45-1.35-4.1 0-1.4 1.15-.33 5.66 1.56 8.17 1.87 2.47 4.92 3 6.1 2.04 2.53 5.7 8.96 8.7 13.26 8.68 11.5-.1 16.3-11.76 16.3-21.45 0-15.28-6.1-20.43-16.3-20.43-9.16-.05-19.33 4.8-16.82 22.98z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_ear",
      "fill": "#CAA792",
      "d": "M1855.1 271.4c-.9-1.93-2.32-3.7-4.06-3.08-1.74.63.48 7.67 5.1 7.66-.54-.33-2-1.86-2.05-3.06-.05-1.2.33-1.8 1-1.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_mouth_bottom",
      "fill": "#DA52BB",
      "fill-rule": "nonzero",
      "d": "M1876.5 279.17c-.8.2-5.3.25-6.78-.05-.8-.15 1 1.35 3.98 1.35 3 0 2.8-1.3 2.8-1.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_mouth_top",
      "fill": "#C63CA7",
      "fill-rule": "nonzero",
      "d": "M1876.97 279.36c0-.65-.5-1.2-3.1-1.2-1.78 0-4.67.9-6.1.5-.3-.1-.3.15.1.3 1.83.65 3.62.65 6.36.65 1.8-.04 2.74-.24 2.74-.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_nose",
      "fill": "#CAA792",
      "d": "M1874.77 266.6c0-1-2.53-1.08-2.53 0 0 1.07-.82 6.66 0 7.65.8 1 3.2.67 3.57 0 .38-.66.3-1.73-.5-2.03-.8-.3-.53-4.64-.53-5.62z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "hailey_right_cheek",
      "cx": "1863.49",
      "cy": "275.05",
      "fill": "#DBB7A7",
      "transform": "matrix(-1 0 0 1 3726.986 0)",
      "rx": "3.06",
      "ry": "3.06"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "hailey_left_cheek",
      "cx": "1880.54",
      "cy": "275.05",
      "fill": "#DBB7A7",
      "transform": "matrix(-1 0 0 1 3761.084 0)",
      "rx": "3.06",
      "ry": "3.06"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_right_eye_whites",
      "fill": "#FFF",
      "d": "M1868.45 268.02c-1.34-3.7-7.27-4.25-8.16-1.06 0 4.3 7.18 4.7 8.15 1.06z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "hailey_right_pupil",
      "cx": "1865.09",
      "cy": "267.87",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 3730.183 0)",
      "rx": "2.04",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_left_eye_whites",
      "fill": "#FFF",
      "d": "M1876.4 268.02c1.33-3.7 7.26-4.25 8.15-1.06 0 4.3-7.2 4.7-8.16 1.06z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "hailey_left_pupil",
      "cx": "1881.67",
      "cy": "267.87",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 3763.334 0)",
      "rx": "2.04",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_right_brow",
      "fill": "#3C2D20",
      "d": "M1868.4 261.53c-1.02-.55-6.4-.65-7.57 0-1.18.65-.3 1.3.5 1.04.83-.26 5.7-.3 6.57 0 .87.3 1.52-.5.5-1.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_left_brow",
      "fill": "#C08522",
      "d": "M1876.88 261.53c1.02-.55 6.4-.65 7.56 0 1.18.65.32 1.3-.5 1.04-.82-.26-5.7-.3-6.56 0-.87.3-1.52-.5-.5-1.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hailey_bangs",
      "fill": "#DD9B2E",
      "d": "M1879.27 250.94c-2.72 10.68-9.73 11.8-17.5 13.78-7.75 1.98-2.5 11.32.54 15.33-3.85-1.52-10-5.53-10.17-12.35-.24-9.17-1.4-23.66 16.33-23.7 17.73-.04 19 10.6 18.92 22.74-1-4.6-3.22-11.06-8.1-15.8z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_89",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1393.1 111.8c0 61.47 39.05 127.65 114.23 136.12 14.58 1.64 23.5-4.5 39.6-9.26 41.26-12.2 143.6-49.1 152.44-132.16 4.1 104.1-116.5 135.34-160.83 170.27-16.74 13.2-33.96 19.4-38.27 9.23-4.47-10.57-52.12-32.7-72.73-52.2-19.2-18.2-48.74-75.04-34.44-122z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_88",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1490.04 97.04c26.7 49.03 32.02 80.27 48.06 80.27s39.9-36.42 63.32-69.1c-13.4 43.54-36.44 65.9-55.58 130.62-.64 2.18-1.3 4.42-1.92 6.7-2.63 9.42-4.26 19.8-5.05 30.7-5.08 69.62 23.66 161.66 43.94 172.34h-90.02c-16.25-32.53-2.74-119.47 20.54-233.95 5.3-26.13-14.87-72.5-23.28-117.56z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_87",
      "fill": "#FFF",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1518.5 305c6.17 1.94 11.25-5.6 11.25-12.5s-5.08-15.3-11.25-12.5c-6.17 2.8-8.5 5.6-8.5 12.5s2.33 10.56 8.5 12.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_86",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1730 110.8c-12.94-3.4-25.37 9.27-23.46 21.4 10.26 3.92 25.17-7.77 23.47-21.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_85",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1728.74 162.7c-7.53-11.07-25.22-9.66-31.74.75 5.17 9.68 24.1 10.65 31.74-.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_84",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1665.04 118.16c-7.64 11 0 27 12.07 29.37 7.2-8.3 1.3-26.3-12.06-29.37z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_83",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1696.7 69.43c-10.67 8.1-8.34 25.7 2.4 31.66 9.4-5.67 9.37-24.62-2.4-31.67z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_82",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1573.7 77.67c-6.46 11.74 2.83 26.86 15.06 27.94 6.28-9-1.45-26.3-15.07-27.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_81",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1547.9 53.54c-11.57 6.75-11.4 24.5-1.47 31.72 10.02-4.48 12.3-23.3 1.47-31.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_80",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1581.26 32.77c-13.18 2.4-19.1 19.12-12.23 29.3 10.95-.78 19.53-17.67 12.23-29.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_79",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1516.6 27.57c-8.57 10.3-2.34 26.9 9.46 30.3 7.88-7.63 3.6-26.08-9.46-30.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_78",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1651.04 76.1c-7.05 11.4 1.43 26.97 13.6 28.7 6.73-8.67-.08-26.35-13.6-28.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_77",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1672.36 47.44c-10.52 8.3-7.88 25.83 2.96 31.6 9.3-5.82 8.94-24.77-2.96-31.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_76",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1552.3 108.36c-2.97 13.06 10.13 25.04 22.2 22.7 3.54-10.38-8.66-24.88-22.2-22.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_75",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1451.9 98.78c3.3 12.98 20.4 17.7 30.1 10.15-1.55-10.86-19-18.24-30.1-10.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_74",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1459.83 136.56c6.34 11.8 24.08 12.25 31.65 2.58-4.13-10.17-22.85-13.1-31.65-2.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_73",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1468.8 166.23c6.35 11.8 24.08 12.25 31.65 2.58-4.12-10.16-22.85-13.1-31.64-2.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_72",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1466.7 57.2c-6.03 11.96 3.78 26.74 16.04 27.4 5.97-9.22-2.36-26.24-16.04-27.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_71",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1516.26 66.64c-13.38-.65-22.9 14.32-18.5 25.8 10.83 1.7 23-12.84 18.5-25.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_70",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1528.04 93.08c-13.38.53-21.56 16.27-16.2 27.32 10.96.75 21.8-14.8 16.2-27.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_69",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1546.27 131.9c-13.38-.63-22.9 14.34-18.5 25.8 10.84 1.7 23-12.82 18.5-25.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_68",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1621.7 67.5c-13.3 1.7-20.06 18.08-13.75 28.62 10.98-.2 20.43-16.63 13.75-28.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_67",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1641.2 114.76c-7.34-11.2-25.05-10.1-31.75.2 5 9.76 23.9 11.06 31.75-.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_66",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1627.45 147c-6.13-11.9-23.86-12.67-31.6-3.13 3.95 10.24 22.62 13.5 31.6 3.13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_65",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1676.9 233.7c-1.44-13.3-17.72-20.37-28.36-14.24 0 10.98 16.27 20.7 28.37 14.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_64",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1644.2 259.53c2.5-13.16-11-24.67-22.98-21.92-3.2 10.5 9.5 24.57 22.97 21.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_63",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1707.74 198.7c-7.53-11.07-25.22-9.66-31.74.75 5.17 9.68 24.1 10.65 31.74-.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_62",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1639.2 148.97c-7.64 11 0 27 12.06 29.36 7.2-8.3 1.3-26.3-12.07-29.36z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_61",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1607.97 167.96c-7.63 11 .02 27 12.07 29.36 7.2-8.3 1.3-26.3-12.07-29.36z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_60",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1427.8 114.68c-12.76-4.08-25.83 7.92-24.56 20.14 10.03 4.44 25.54-6.45 24.56-20.14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_59",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1423.47 72.63c-13.07-2.95-25.04 10.14-22.7 22.2 10.38 3.56 24.88-8.65 22.7-22.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_58",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1432.48 38c-8.93 10-3.28 26.82 8.4 30.62 8.14-7.35 4.5-25.95-8.4-30.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_57",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1356.9 117.66c-1.8 13.27 12.28 24.06 24.1 20.7 2.63-10.67-10.8-24.05-24.1-20.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_56",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1392.52 39.2c-11.9 6.14-12.67 23.87-3.13 31.6 10.23-3.94 13.5-22.6 3.12-31.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_55",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1356.5 175.83c3.53 12.92 20.7 17.35 30.27 9.63-1.74-10.84-19.32-17.92-30.26-9.63z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_54",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1366.06 80.56c-4.96 12.44 6.1 26.32 18.37 25.9 5.14-9.7-4.64-25.93-18.37-25.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_53",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1435.83 144.08c-13.27-1.8-24.06 12.28-20.68 24.1 10.65 2.63 24.03-10.8 20.68-24.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_52",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1455.97 178.16c-13.28-1.8-24.07 12.27-20.7 24.08 10.66 2.64 24.04-10.78 20.7-24.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_51",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1398.5 259.23c12.36 5.18 26.43-5.63 26.22-17.9-9.6-5.32-26 4.18-26.2 17.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_50",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1376.84 227.84c11.5 6.85 26.95-1.9 28.46-14.1-8.78-6.58-26.34.54-28.46 14.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "tree1_49",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1477.82 199.5c-12.92 3.53-17.35 20.7-9.63 30.27 10.83-1.74 17.9-19.32 9.62-30.26z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_48",
      "cx": "1583.5",
      "cy": "202.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_47",
      "cx": "1626.5",
      "cy": "165.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_46",
      "cx": "1660.5",
      "cy": "152.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_45",
      "cx": "1645.5",
      "cy": "131.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_44",
      "cx": "1678.5",
      "cy": "102.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_43",
      "cx": "1720.5",
      "cy": "89.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_42",
      "cx": "1728.5",
      "cy": "145.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_41",
      "cx": "1695.5",
      "cy": "180.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_40",
      "cx": "1609.5",
      "cy": "251.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_39",
      "cx": "1665.5",
      "cy": "250.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_38",
      "cx": "1686.5",
      "cy": "221.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_37",
      "cx": "1577.5",
      "cy": "265.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_36",
      "cx": "1586.5",
      "cy": "174.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_35",
      "cx": "1557.5",
      "cy": "145.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_34",
      "cx": "1536.5",
      "cy": "120.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_33",
      "cx": "1594.5",
      "cy": "65.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_32",
      "cx": "1635.5",
      "cy": "91.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_31",
      "cx": "1645.5",
      "cy": "61.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_30",
      "cx": "1615.5",
      "cy": "51.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_29",
      "cx": "1553.5",
      "cy": "35.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_28",
      "cx": "1607.5",
      "cy": "128.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_27",
      "cx": "1557.5",
      "cy": "91.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_26",
      "cx": "1530.5",
      "cy": "76.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_25",
      "cx": "1494.5",
      "cy": "53.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_24",
      "cx": "1451.5",
      "cy": "81.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_23",
      "cx": "1466.5",
      "cy": "41.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_22",
      "cx": "1460.5",
      "cy": "120.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_21",
      "cx": "1499.5",
      "cy": "196.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_20",
      "cx": "1492.5",
      "cy": "151.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_19",
      "cx": "1439.5",
      "cy": "169.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_18",
      "cx": "1451.5",
      "cy": "150.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_17",
      "cx": "1469.5",
      "cy": "185.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_16",
      "cx": "1495.5",
      "cy": "231.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_15",
      "cx": "1430.5",
      "cy": "98.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_14",
      "cx": "1441.5",
      "cy": "128.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_13",
      "cx": "1412.5",
      "cy": "58.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_12",
      "cx": "1371.5",
      "cy": "57.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_11",
      "cx": "1406.5",
      "cy": "26.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_10",
      "cx": "1362.5",
      "cy": "106.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_9",
      "cx": "1381.5",
      "cy": "163.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_8",
      "cx": "1365.5",
      "cy": "149.63",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_7",
      "cx": "1383.5",
      "cy": "202.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_6",
      "cx": "1375.5",
      "cy": "243.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_5",
      "cx": "1401.5",
      "cy": "237.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_4",
      "cx": "1435.5",
      "cy": "258.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_3",
      "cx": "1454.5",
      "cy": "213.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_2",
      "cx": "1457.5",
      "cy": "265.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "tree1_1",
      "cx": "1426.5",
      "cy": "185.5",
      "r": "2.5",
      "fill": "#FFF",
      "stroke": "#FFF"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_58",
      "width": "601",
      "height": "541",
      "x": "689",
      "y": "-92",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "transform": "matrix(-1 0 0 1 1979 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_57",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1159.6 370h128.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_56",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1204.67 370v27",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_55",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1256.67 370v27",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_54",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1179.67 397v27",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_53",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1231.67 397v27",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_52",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1136 397h130",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_51",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1159.6 423h128.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_50",
      "width": "289",
      "height": "6",
      "x": "966",
      "y": "341",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "transform": "matrix(1 0 0 -1 0 688)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_49",
      "width": "264",
      "height": "108",
      "x": "978",
      "y": "233",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_48",
      "width": "114",
      "height": "84",
      "x": "1116",
      "y": "245",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_47",
      "width": "114",
      "height": "84",
      "x": "990",
      "y": "245",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_46",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1212.4 273.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_45",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1213 246l-65 82",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_44",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1030 318l-7 9",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_43",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1087.4 245.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_42",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1067 246l-65 82",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_41",
      "width": "108",
      "height": "216",
      "x": "845",
      "y": "233",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_40",
      "width": "108",
      "height": "216",
      "x": "737",
      "y": "233",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_39",
      "width": "84",
      "height": "84",
      "x": "857",
      "y": "341",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_38",
      "width": "84",
      "height": "84",
      "x": "857",
      "y": "245",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_37",
      "width": "84",
      "height": "84",
      "x": "749",
      "y": "341",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_36",
      "width": "84",
      "height": "84",
      "x": "749",
      "y": "245",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_35",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M812.4 245.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_34",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M824 245l-65 82",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_33",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M832.4 356.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_32",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M833 342l-65 82",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_31",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M921 245l-50 62",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_30",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M933 245l-65 82",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_29",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M940.4 356.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_28",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M941 342l-65 82",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "house2_27",
      "cx": "899",
      "cy": "286",
      "r": "18",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "house2_26",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "737.043478 118 1241.95652 118 1266 186 713 186"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_25",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M713 187h553v14.6c0 25.84-51 25.84-50.93 0-.07 25.84-55.8 25.82-55.8 0 .03 25.84-55.6 25.82-55.77 0 .14 25.84-55.8 25.73-55.8 0-.03 25.84-55.77 25.84-55.77 0 0 25.84-55.8 25.8-55.8 0 .03 25.84-55.54 25.84-55.77 0 .2 25.84-55.8 25.9-55.8 0 .06 25.84-55.77 25.84-55.77 0 0 25.84-55.8 25.84-55.8 0V187z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_24",
      "width": "162",
      "height": "6",
      "x": "1092",
      "y": "89",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "transform": "matrix(1 0 0 -1 0 184)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_23",
      "width": "138",
      "height": "168",
      "x": "1103",
      "y": "-80",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_22",
      "width": "114",
      "height": "66",
      "x": "1116",
      "y": "10",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_20",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1213.4 10.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_19",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1187 22l-43 54",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_16",
      "width": "162",
      "height": "6",
      "x": "909",
      "y": "89",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "transform": "matrix(1 0 0 -1 0 184)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_15",
      "width": "138",
      "height": "168",
      "x": "921",
      "y": "-80",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_14",
      "width": "114",
      "height": "66",
      "x": "933",
      "y": "10",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_12",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1030.4 10.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_11",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1004 22l-43 54",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_8",
      "width": "162",
      "height": "6",
      "x": "725",
      "y": "89",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "transform": "matrix(1 0 0 -1 0 184)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_7",
      "width": "138",
      "height": "168",
      "x": "737",
      "y": "-80",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house2_6",
      "width": "114",
      "height": "66",
      "x": "749",
      "y": "10",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M846.4 10.6l-41.8 52.8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house2_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M821 22l-43 54",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_68",
      "width": "490",
      "height": "450",
      "y": "-1",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_67",
      "width": "410",
      "height": "150",
      "y": "299",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_66",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M70 409h40c22.1 0 40 17.9 40 40H30c0-22.1 17.9-40 40-40z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_65",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M70 419h40c16.57 0 30 13.43 30 30H40c0-16.57 13.43-30 30-30z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_64",
      "width": "410",
      "height": "10",
      "y": "298",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_63",
      "width": "490",
      "height": "10",
      "y": "152",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_62",
      "width": "490",
      "height": "10",
      "y": "6",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_61",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M212.5 356h107",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_60",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M250 356v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_59",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M293 356v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_58",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M229 378v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_57",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M272 378v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_56",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M193 378h108",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_55",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M212.5 400h107",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_54",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M382.5 62h107",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_53",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M420 62v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_52",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M463 62v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_51",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M399 84v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_50",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M442 84v22",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_49",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M368 84h108",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_48",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M382.5 106h107",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_47",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M380 192c0-5.52 4.48-10 10-10h60c5.52 0 10 4.48 10 10 5.52 0 10 4.48 10 10v146H370V202c0-5.52 4.48-10 10-10z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_46",
      "width": "80",
      "height": "146",
      "x": "380",
      "y": "202",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_45",
      "width": "140",
      "height": "96",
      "x": "200",
      "y": "36",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_44",
      "width": "62",
      "height": "86",
      "x": "205",
      "y": "41",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_43",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M228.36 102l-6.36 8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_42",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M266.55 52.82L240.5 85.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_41",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M260.12 42L206 110.28",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_40",
      "width": "62",
      "height": "86",
      "x": "273",
      "y": "41",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_39",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M334.55 68.82L308.5 101.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_38",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M334.12 50l-60.33 76.12",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_37",
      "width": "25",
      "height": "53",
      "x": "390",
      "y": "212",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_36",
      "width": "25",
      "height": "53",
      "x": "425",
      "y": "212",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_35",
      "width": "25",
      "height": "53",
      "x": "390",
      "y": "285",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_34",
      "width": "25",
      "height": "53",
      "x": "425",
      "y": "285",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "house1_33",
      "cx": "389",
      "cy": "275",
      "r": "4",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_32",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M640 449v-64.92c0-6.9-3.55-13.3-9.4-16.96l-105.74-66.08c-3.17-2-6.85-3.04-10.6-3.04H490v151h150z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_31",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M630 449v-60.9c0-5.05-2.55-9.77-6.8-12.54l-98.2-64.3c-3.27-2.12-7.07-3.26-10.96-3.26H490v141h140z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_30",
      "width": "80",
      "height": "25",
      "x": "430",
      "y": "349",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_29",
      "width": "80",
      "height": "25",
      "x": "470",
      "y": "374",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_28",
      "width": "90",
      "height": "25",
      "x": "500",
      "y": "399",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_27",
      "width": "130",
      "height": "25",
      "x": "500",
      "y": "424",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_26",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M500 449v-64.92c0-6.9-3.55-13.3-9.4-16.96l-105.74-66.08c-3.17-2-6.85-3.04-10.6-3.04H350v151h150z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_25",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M490 449v-60.9c0-5.05-2.55-9.77-6.8-12.54l-98.2-64.3c-3.27-2.12-7.07-3.26-10.96-3.26H350v141h140z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_24",
      "width": "140",
      "height": "96",
      "x": "30",
      "y": "182",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_23",
      "width": "62",
      "height": "86",
      "x": "35",
      "y": "187",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_22",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M58.36 248L52 256",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_21",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M96.55 198.82L70.5 231.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_20",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M90.12 188L36 256.28",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_19",
      "width": "62",
      "height": "86",
      "x": "103",
      "y": "187",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_18",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M164.55 214.82L138.5 247.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_17",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M164.12 196l-60.33 76.12",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_16",
      "width": "140",
      "height": "96",
      "x": "200",
      "y": "182",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_15",
      "width": "62",
      "height": "86",
      "x": "205",
      "y": "187",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_14",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M228.36 248l-6.36 8",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_13",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M266.55 198.82L240.5 231.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_12",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M260.12 188L206 256.28",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_11",
      "width": "62",
      "height": "86",
      "x": "273",
      "y": "187",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_10",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M334.55 214.82L308.5 247.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_9",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M334.12 196l-60.33 76.12",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_8",
      "width": "140",
      "height": "96",
      "x": "30",
      "y": "36",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_7",
      "width": "62",
      "height": "86",
      "x": "35",
      "y": "41",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "house1_6",
      "width": "62",
      "height": "86",
      "x": "103",
      "y": "41",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_5",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M58.36 102L52 110",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M96.55 52.82L70.5 85.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M90.12 42L36 110.28",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M164.55 68.82L138.5 101.5",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "house1_1",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M164.12 50l-60.33 76.12",
      "stroke-linecap": "square"
    }
  })]), _vm._v(" "), _c('background-characters'), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3784.96 447.02c-1.05 1.16-2.54 1.9-4.22 1.98h-53.29c-1.76 0-3.34-.75-4.43-1.95-1.05 1.14-2.53 1.88-4.2 1.95h-53.3c-3.3 0-6-2.7-6-6v-.24c.07-1.54.4-2.93 1.04-4.2-2.1-4.16-2.1-6.25 0-10.42-2.1-4.17-2.1-6.26 0-10.43-2.1-4.16-2.1-6.25 0-10.42-2.1-4.17-2.1-6.26 0-10.43-2.1-4.17-2.1-6.25 0-10.43-2.1-4.17-2.1-6.25 0-10.43-1.92-3.84-.38-8.5 3.45-10.43 1.8-.9 3.88-1.08 5.8-.47.43.13.84.28 1.25.46 4.57-2.14 5.6-1.9 10.5 0 4.2-2.08 6.3-2.08 10.5 0 4.2-2.08 6.28-2.08 10.48 0 4.2-2.08 6.3-2.08 10.5 0l.45-.2c3.5-1.5 7.47-.27 9.52 2.75.72-1.03 1.7-1.92 2.92-2.53 1.8-.9 3.88-1.08 5.8-.47.43.13.84.28 1.25.46 4.56-2.14 5.6-1.9 10.48 0 4.2-2.08 6.3-2.08 10.5 0 4.2-2.08 6.3-2.08 10.5 0 4.2-2.08 6.3-2.08 10.48 0l.46-.2c3.5-1.52 7.5-.26 9.54 2.8.72-1.07 1.72-1.97 2.94-2.6 1.8-.9 3.9-1.07 5.8-.46.43.13.85.28 1.25.46 4.57-2.14 5.6-1.9 10.5 0 4.2-2.08 6.3-2.08 10.5 0 4.2-2.08 6.3-2.08 10.5 0 4.18-2.08 6.28-2.08 10.48 0l.46-.2c3.93-1.7 8.5.1 10.22 4.05.9 2.13.84 4.54-.2 6.6 2.1 4.17 2.1 6.25 0 10.42 2.1 4.14 2.1 6.26 0 10.43 2.1 4.17 2.1 6.26 0 10.43 2.1 4.17 2.1 6.26 0 10.43 2.1 4.18 2.1 6.27 0 10.44 2.1 4.17 2.1 6.26 0 10.43.64 1.26.98 2.65 1.05 4.2.13 3.3-2.45 6.1-5.76 6.23h-53.29c-1.75 0-3.34-.76-4.44-1.98z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_36",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3686.37 383.9c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.15 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_35",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3712.37 405.9c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.15 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_34",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3695.3 409.17c4.16-.48 7.48 4 6.37 7.7-3.35.76-7.5-3.54-6.38-7.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_33",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3670.83 428.2c3.42-2.44 8.5-.12 9.32 3.65-2.57 2.3-8.27.53-9.32-3.64z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_32",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3675.17 440.5c.25-4.2 5.25-6.7 8.7-4.95.15 3.43-4.8 6.76-8.7 4.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_31",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3671.55 378.4c4.13.76 6 6.03 3.85 9.23-3.43-.26-6.13-5.58-3.85-9.23z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_30",
      "cx": "3678",
      "cy": "378",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7356 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_29",
      "cx": "3681",
      "cy": "381",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7362 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_28",
      "cx": "3706",
      "cy": "404",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7412 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_27",
      "cx": "3700",
      "cy": "404",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7400 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_26",
      "cx": "3703",
      "cy": "408",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7406 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_25",
      "cx": "3685",
      "cy": "431",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7370 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_24",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3747.37 383.9c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.15 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_23",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3774.37 405.9c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.15 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_22",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3757.3 409.17c4.16-.48 7.48 4 6.37 7.7-3.35.76-7.5-3.54-6.38-7.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_21",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3732.83 428.2c3.42-2.44 8.5-.12 9.32 3.65-2.57 2.3-8.27.53-9.32-3.64z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_20",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3737.17 440.5c.25-4.2 5.25-6.7 8.7-4.95.15 3.43-4.8 6.76-8.7 4.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_19",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3733.55 378.4c4.13.76 6 6.03 3.85 9.23-3.43-.26-6.13-5.58-3.85-9.23z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_18",
      "cx": "3740",
      "cy": "378",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7480 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_17",
      "cx": "3743",
      "cy": "381",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7486 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_16",
      "cx": "3768",
      "cy": "404",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7536 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_15",
      "cx": "3762",
      "cy": "404",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7524 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_14",
      "cx": "3765",
      "cy": "408",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7530 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_13",
      "cx": "3747",
      "cy": "431",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7494 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_12",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3810.37 383.9c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.15 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_11",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3837.37 405.9c1.54 3.9-1.94 8.28-5.8 8.16-1.6-3.04 1.5-8.15 5.8-8.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_10",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3820.3 409.17c4.16-.48 7.48 4 6.37 7.7-3.35.76-7.5-3.54-6.38-7.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_9",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3795.83 428.2c3.42-2.44 8.5-.12 9.32 3.65-2.57 2.3-8.27.53-9.32-3.64z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_8",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3800.17 440.5c.25-4.2 5.25-6.7 8.7-4.95.15 3.43-4.8 6.76-8.7 4.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "scrub1_7",
      "fill": "#FACE86",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M3796.55 378.4c4.13.76 6 6.03 3.85 9.23-3.43-.26-6.13-5.58-3.85-9.23z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_6",
      "cx": "3803",
      "cy": "378",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7606 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_5",
      "cx": "3806",
      "cy": "381",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7612 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_4",
      "cx": "3831",
      "cy": "404",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7662 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_3",
      "cx": "3825",
      "cy": "404",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7650 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_2",
      "cx": "3828",
      "cy": "408",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7656 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "scrub1_1",
      "cx": "3810",
      "cy": "431",
      "r": "1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "transform": "matrix(-1 0 0 1 7620 0)"
    }
  })], 1), _vm._v(" "), _c('svg', {
    class: {
      speaking: _vm.ria_speaking, frown: _vm.ria_frown, head_flip: _vm.ria_head_flip
    },
    attrs: {
      "id": "ria",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "160",
      "height": "500",
      "viewBox": "0 0 160 500"
    }
  }, [_c('title', [_vm._v("Ria")]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_left_foot_2",
      "fill": "#CC9D69",
      "fill-rule": "nonzero",
      "d": "M103.82 449c.1 19.56 16.03 28.26 21.9 31.88-7.24 1.47-38.12-1.46-39.98-3.62.3-6.16 3.9-18.08 3.42-28.25-.2-6.05 14.66-2.14 14.66 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_foot_1",
      "fill": "#BC2F2F",
      "fill-rule": "nonzero",
      "d": "M121.9 477.75c.4.6-4.2-4.9-5.67-6.35-2.15 0-10.16 1.46-13.78 2.93 3.62 4.4 5.38 5.97 1.47 5.1-11.24-2.17-15.64-2.65-18.08-3.63-2.74 3.22-3.7 13.1-2.25 15.93 3.6 2.16 10.35 1.76 12.1 1.57.6-.7.5-1.86 2.26-1.37 1.17.3 1.27 1.08 1.95 1.66 3.04.97 38.22-.4 41.16-1.08 4.98-1.18 3.9-6.65 0-8.02-7.63-2.74-17.2-5.87-19.16-6.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_leg_bottom",
      "fill": "#2B5189",
      "fill-rule": "nonzero",
      "d": "M77.53 465.04h43.4V366.3c0-11.74-9.5-21.22-21.2-21.22h-.7c-11.82 0-21.5 9.58-21.5 21.5v98.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_leg_top",
      "fill": "#2B5189",
      "fill-rule": "nonzero",
      "d": "M99.23 388.5c12.02 0 21.7-9.7 21.7-21.72v-76.55c0-12.03-9.68-21.7-21.7-21.7s-21.7 9.67-21.7 21.7v76.55c0 11.93 9.68 21.7 21.7 21.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_foot_2",
      "fill": "#D8A96F",
      "fill-rule": "nonzero",
      "d": "M52.02 449c.1 19.56 16.03 28.26 21.9 31.88-7.24 1.47-38.12-1.46-39.98-3.62.3-6.16 3.9-18.08 3.43-28.25-.2-6.05 14.65-2.14 14.65 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_foot_1",
      "fill": "#C92F2F",
      "fill-rule": "nonzero",
      "d": "M70.1 477.75c.4.6-4.2-4.9-5.66-6.35-2.15 0-10.17 1.46-13.78 2.93 3.6 4.4 5.37 5.97 1.46 5.1-11.24-2.17-15.63-2.65-18.08-3.63-2.73 3.22-3.7 13.1-2.25 15.93 3.6 2.16 10.35 1.76 12.1 1.57.6-.7.5-1.86 2.26-1.37 1.17.3 1.27 1.08 1.96 1.66 3.03.97 38.2-.4 41.14-1.08 4.98-1.18 3.9-6.65 0-8.02-7.62-2.74-17.2-5.87-19.16-6.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_leg_bottom",
      "fill": "#2F539B",
      "fill-rule": "nonzero",
      "d": "M25.74 465.04h43.4V366.3c0-11.74-9.5-21.22-21.22-21.22h-.68c-11.83 0-21.5 9.58-21.5 21.5v98.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_leg_top",
      "fill": "#2F539B",
      "fill-rule": "nonzero",
      "d": "M47.43 388.5c12.02 0 21.7-9.7 21.7-21.72v-76.55c0-12.03-9.68-21.7-21.7-21.7s-21.7 9.67-21.7 21.7v76.55c0 11.93 9.68 21.7 21.7 21.7z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_left_arm"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_left_arm_top",
      "fill": "#DDD",
      "fill-rule": "nonzero",
      "d": "M121.05 223.3l1.16-.18c9.1-1.27 15.43-9.67 14.15-18.77l-8.62-61.38c-1.28-9.1-9.67-15.43-18.77-14.15l-1.16.16c-9.1 1.28-15.42 9.68-14.14 18.78l8.63 61.38c1.27 9.1 9.65 15.43 18.75 14.15z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_left_hand",
      "fill": "#D8A96F",
      "d": "M136.56 267.3c.53 3 1.5 9.66 8.57 17.88 3.36 3.9 4.44 11.8 8.48 17.9-.55 1.68-6.02-.3-7.5-2.8-1.47-2.48-2.62-4.5-3.1-5.12-.45-.6-1.32-.4-1.47.27-.16.68 3.23 23.92 2.9 25.15-.36 1.23-3.4 1.8-4.12.72-.72-1.08-3.87-19.38-4.2-19.83-.35-.44-.98-.1-1.2.22-.25.3 3.68 19.74 3.35 20.55-.32.8-3.47 1.23-3.92.7-.44-.55-4-20-4.4-20.4-.43-.37-1.1-.2-1.32.24-.2.44 3.87 19.05 3.53 19.94-.35.9-3.38 1.44-3.8.67-.43-.75-4.38-19.5-4.72-19.73-.33-.22-.72-.12-.96.18-.23.3 1.95 14.43 1.6 15.28-.35.85-2.6 1.44-3.12.55-.5-.88-4.37-24.82-4.24-30.4.13-5.6.4-15.87-.08-18.58 1.1-.2 17.55-3.02 19.76-3.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_arm_bottom",
      "fill": "#DDD",
      "fill-rule": "nonzero",
      "d": "M114.33 285.74l31.45-4.42c.78-.1 1.28-.77 1.17-1.55L136.2 203.2c-1.3-9.1-9.68-15.44-18.78-14.16l-1.16.17c-9.1 1.3-15.42 9.68-14.14 18.78l10.76 76.58c.1.68.77 1.28 1.45 1.18z"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_right",
      "fill": "#F4F4F4",
      "fill-rule": "nonzero",
      "d": "M5.2 383.5s-.96 8.8 67.45 8.8c5.57 0 10.55-.1 15.24-.2.38-10.55.38-267.7.1-280.2-4.7-1.38-9.7-2.16-14.87-2.16-27.16 0-49.74 21.12-51.5 48.3L5.2 383.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_left",
      "fill": "#EAEAEA",
      "fill-rule": "nonzero",
      "d": "M87.22 392.1c52.86-1.17 52.86-8.6 52.86-8.6l-16.33-225.46c-1.45-22-16.42-40.1-36.43-46.15.3 9.57.3 273.56-.1 280.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_shirt",
      "fill": "#2F539B",
      "fill-rule": "nonzero",
      "d": "M88.28 148.85l6.84-33.24H70.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_neck",
      "fill": "#CC9D69",
      "fill-rule": "nonzero",
      "d": "M94.15 95.07c-2.94 9.78-2.15 16.82 2.93 21.5-6.06 6.08-24.43 5.88-33.23 1 2.93-4.9 6.84-10.76 1.95-22.5.98-14.66 30.3-12.7 28.35 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_collar_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M67.76 107.8l20.52 41.05-28.34-10.76L58 110.7c2.92-.98 6.83-1.96 9.76-2.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_collar_1",
      "fill": "#F4F4F4",
      "fill-rule": "nonzero",
      "d": "M94.15 112.67L88 148.85l16.9-8.8-2.94-22.5c-2.54-1.55-6.06-3.6-7.8-4.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_pocket",
      "fill": "#F4F4F4",
      "fill-rule": "nonzero",
      "d": "M118.58 171.34l-22.48 4.9v6.83l22.48-4.9z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "ria_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_right_hand",
      "fill": "#D8A96F",
      "d": "M42.43 268.07c0 3.05-.2 9.8 5.33 19.1 2.63 4.45 2.32 12.4 5.24 19.13-.84 1.54-5.88-1.37-6.9-4.08-1.02-2.7-1.8-4.9-2.16-5.58-.35-.68-1.24-.63-1.5 0-.28.66-.97 24.13-1.53 25.28-.55 1.15-3.62 1.2-4.15 0-.54-1.2-.46-19.76-.72-20.26-.26-.5-.94-.26-1.23 0-.28.26.2 20.1-.25 20.83-.46.73-3.64.6-3.98 0-.34-.62-.46-20.4-.8-20.84-.35-.45-1.05-.4-1.34 0-.3.4.5 19.44 0 20.26-.5.82-3.58.83-3.86 0-.28-.83-.9-19.98-1.2-20.26-.3-.28-.7-.25-1 0-.28.25-.58 14.55-1.07 15.33-.5.77-2.83.95-3.17 0-.35-.97 0-25.22 1.1-30.7 1.1-5.47 3.14-15.55 3.14-18.3l20.06.07z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_arm_bottom",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M18.6 284.46h31.76c.8 0 1.37-.6 1.37-1.37v-77.35c0-9.2-7.43-16.62-16.6-16.62h-1.2c-9.17 0-16.6 7.43-16.6 16.62v77.34c0 .67.6 1.36 1.27 1.36z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_arm_top",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M33.94 223.55h1.18c9.18 0 16.6-7.43 16.6-16.62v-62c0-9.18-7.42-16.6-16.6-16.6h-1.18c-9.18 0-16.6 7.42-16.6 16.6v62c0 9.2 7.42 16.62 16.6 16.62z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_head"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_face",
      "fill": "#D8A96F",
      "fill-rule": "nonzero",
      "d": "M49.3 64.57c0 22.4 16.2 41.75 34.1 41.75 22.57 0 30.88-22.78 30.88-41.75 0-29.92-12.4-40.38-32.45-40.38-17.98-.1-32.54 17.88-32.54 40.37z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_hair",
      "fill": "#CCC",
      "fill-rule": "nonzero",
      "d": "M107.73 21.94c-6.06-5.86-19.15-19.46-45.05-13.3C40.48 13.92 42.54 32 37.76 37.1c-7.82 8.2-13.4 4.98-17.7 14.47-3.32 7.33 2.26 13 .2 20.53C18.9 77.08 6 95.86 32.2 99.38c27.55 3.7 19.73-20.34 20.12-28.26.3-6.35 9.48-2.54 17.6-12.7C77.13 49.3 72.83 32 75.66 28c4-5.57 18.96-3.13 25.5 1.27 13.1 8.6 18.58 40.87 5.88 63.85 9.18 13.2 40.85 4.7 23.74-20.63-5.28-7.83 5.37-12.04-1.28-24.84-5.76-11.15-21.8-25.72-21.8-25.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_open_bottom",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M95.03 92.16c.97.98-.1 6.07-4.1 6.07-4.02 0-8.4-5-8.12-5.48.3-.5 4.4 2.44 8.12 2.44 4-.1 4.1-3.04 4.1-3.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_bottom",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M96 92.92c-1.56.4-10.36.5-13.3-.1-1.55-.3 1.97 2.65 7.83 2.65S96 92.92 96 92.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_top",
      "fill": "#634235",
      "fill-rule": "nonzero",
      "d": "M96.98 92.83c0-1.28-.98-2.35-6.06-2.35-3.52 0-9.2 1.76-12.02.98-.6-.2-.6.3.2.58 3.6 1.27 7.13 1.27 12.5 1.27 3.52-.08 5.38-.47 5.38-.47z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_nose",
      "fill": "#C99B69",
      "fill-rule": "nonzero",
      "d": "M88.67 82.36h3.03c1.27 0 2.25-.97 2.25-2.24L92.78 63.3c0-1.27-.98-2.25-2.25-2.25h-.78c-1.27 0-2.25.98-2.25 2.25l-1.17 16.82c.1 1.17 1.17 2.24 2.34 2.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_4",
      "fill": "#C92F2F",
      "fill-rule": "nonzero",
      "d": "M92 64.67c0-8.6 7.03-15.55 15.53-15.55 8.6 0 15.64 6.94 15.64 15.65 0 8.7-6.94 15.64-15.64 15.64-8.6 0-15.53-6.93-15.53-15.54v1.08h-3.62v-1.86H92v.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_3",
      "fill": "#C92F2F",
      "fill-rule": "nonzero",
      "d": "M72.74 80.4c-8.63 0-15.63-7-15.63-15.63 0-8.64 7-15.65 15.64-15.65s15.64 7 15.64 15.65c0 8.64-7 15.64-15.64 15.64z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M107.53 78.65c-7.66 0-13.87-6.22-13.87-13.88 0-7.67 6.2-13.9 13.87-13.9 7.67 0 13.88 6.23 13.88 13.9 0 7.66-6.2 13.88-13.87 13.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M72.74 78.65c-7.66 0-13.87-6.22-13.87-13.88 0-7.67 6.2-13.9 13.87-13.9 7.67 0 13.88 6.23 13.88 13.9 0 7.66-6.2 13.88-13.88 13.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_brow",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M99.72 47.17c1.95-.1 12.02-.4 15.93.1 1.85.2-2.35-2.94-9.4-2.94-7.02 0-6.53 2.84-6.53 2.84z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_brow",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M80.85 47.26c-1.95-.1-12.3-.48-16.32.1-1.85.3 2.45-3.03 9.58-3.03 7.24 0 6.75 2.93 6.75 2.93z"
    }
  })])])]), _vm._v(" "), _c('svg', {
    class: _vm.aye_state,
    attrs: {
      "id": "aye",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "162",
      "height": "454",
      "viewBox": "0 0 162 454"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "orb_path",
      "d": "M73 147c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15z"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "orb_filter",
      "width": "136.7%",
      "height": "136.7%",
      "x": "-18.3%",
      "y": "-18.3%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "in": "SourceAlpha",
      "result": "shadowBlurInner1"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dx": "1",
      "dy": "1",
      "in": "shadowBlurInner1",
      "result": "shadowOffsetInner1"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowOffsetInner1",
      "in2": "SourceAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1",
      "result": "shadowInnerInner1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
      "in": "shadowInnerInner1"
    }
  })], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_left_arm_hand"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_left_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_left_hand_2",
      "fill": "#BCC1BC",
      "d": "M132.96 279c1.6 5.1 5 15 5.02 17 .03 2-4.2 2.34-5.55-1.73-1.35-4.06-2.03-6.27-2.43-7.27-.27.65 0 15 0 17 0 1.98-4.97 2.07-4.97 0 0-2.1 0-14.97-.03-16-.03-1.03-1.06-1.04-1 0 .06 1.04-.07 14.87-.07 17 0 2.1-4.93 2.1-4.93 0v-17c0-.9-1-.95-1 0v16c0 2.02-5 2.05-5 0 .02-2.08 0-14.96 0-16 0-1.04-1-1.22-1 0v12c0 1.9-4.02 2.05-4 0 .02-2.05 0-15.05 0-21 0-5.95 22-9.43 24.96 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_hand_1",
      "fill": "#B3B9B3",
      "d": "M120.5 292c-6.9 0-12.5-5.6-12.5-12.5s5.6-12.5 12.5-12.5 12.5 5.6 12.5 12.5-5.6 12.5-12.5 12.5z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_3",
      "fill": "#D8D8D8",
      "d": "M120.5 292c-6.92 0-12.5-5.6-12.5-12.53v-74.94c0-6.93 5.58-12.53 12.5-12.53s12.5 5.6 12.5 12.53v74.94c0 6.93-5.67 12.53-12.5 12.53z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_2",
      "fill": "#D8D8D8",
      "d": "M120.5 217c-6.92 0-12.5-5.6-12.5-12.53v-74.94c0-6.93 5.58-12.53 12.5-12.53s12.5 5.6 12.5 12.53v74.94c0 6.93-5.67 12.53-12.5 12.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_1",
      "fill": "#BCC1BC",
      "d": "M108 204.5c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5-5.6-12.5-12.5-12.5-12.5 5.6-12.5 12.5z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_4",
      "fill": "#BCC1BC",
      "d": "M102.3 415.05c3.3 10.67 21.6 22.45 26.18 23.12 3.23.5 3.83 7.37-1.05 7.54-7.3.27-40.17.35-49.04.27-1.22 0-2.27-1.1-2.35-2.46-.45-6.85 2.03-25.32 3.24-27.86 1.42-3.05 22.03-3.73 23-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_3",
      "fill": "#D8D8D8",
      "d": "M91 432c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_2",
      "fill": "#D8D8D8",
      "d": "M91 332c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_1",
      "fill": "#BCC1BC",
      "d": "M76 317c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_body_main",
      "fill": "#E2E2E2",
      "d": "M120.48 121.17c-16.98-17.2-75.3-17.53-88.9-1.12C16.96 137.58 30.84 228 76.03 228c45.2 0 58.93-92.17 44.45-106.83z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_orb_offset"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#777",
      "xlink:href": "#orb_path"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#000",
      "filter": "url(#orb_filter)",
      "xlink:href": "#orb_path"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb",
      "fill": "#D0021B",
      "d": "M75 147c0 7.18 5.37 13 12 13s12-5.82 12-13-5.37-13-12-13-12 5.82-12 13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb_glare_2",
      "fill": "#FFF",
      "d": "M93.5 142c-.74.5-.95 1.5-.45 2.25v.02c.66.94.97 1.85.95 2.73-.02.88-.34 1.78-.96 2.7-.5.77-.3 1.8.46 2.3.77.5 1.8.3 2.32-.46.05-.07.1-.14.12-.2.7-1.48 1.06-2.9 1.06-4.3s-.35-2.87-1.07-4.37c-.4-.83-1.4-1.18-2.22-.8-.06.05-.13.1-.2.13z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb_glare_1",
      "fill": "#FFF",
      "d": "M92.5 141c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_4",
      "fill": "#BCC1BC",
      "d": "M63.3 415.05c3.3 10.67 21.6 22.45 26.18 23.12 3.23.5 3.83 7.37-1.06 7.54-7.3.27-40.16.35-49.03.27-1.22 0-2.27-1.1-2.35-2.46-.45-6.85 2.03-25.32 3.24-27.86 1.42-3.05 22.03-3.73 23-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_3",
      "fill": "#EFEFEF",
      "d": "M53 432c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_2",
      "fill": "#EFEFEF",
      "d": "M53 332c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_1",
      "fill": "#BCC1BC",
      "d": "M38 317c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_right_hand_2",
      "fill": "#BCC1BC",
      "d": "M45.97 278.84c1.6 5.1 5 15 5.03 17 .02 2-4.2 2.34-5.55-1.73-1.35-4.06-2.04-6.26-2.43-7.26-.27.64 0 15 0 17 0 1.98-4.98 2.06-4.98 0 0-2.1 0-14.98-.02-16-.03-1.03-1.07-1.05-1 0 .06 1.04-.07 14.87-.07 17 0 2.1-4.93 2.1-4.93 0v-17c0-.9-1-.95-1 0v16c0 2.02-5 2.05-5 0 .02-2.08 0-14.96 0-16 0-1.04-1-1.22-1 0v12c0 1.9-4.03 2.05-4 0 .02-2.05 0-15.06 0-21 0-5.95 22-9.43 24.95 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_hand_1",
      "fill": "#B2B2B2",
      "d": "M33.5 292c-6.9 0-12.5-5.6-12.5-12.5S26.6 267 33.5 267 46 272.6 46 279.5 40.4 292 33.5 292z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_3",
      "fill": "#EFEFEF",
      "d": "M33.5 292c6.92 0 12.5-5.6 12.5-12.53v-74.94C46 197.6 40.42 192 33.5 192S21 197.6 21 204.53v74.94C21 286.4 26.58 292 33.5 292z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_2",
      "fill": "#EFEFEF",
      "d": "M33.5 217c6.92 0 12.5-5.6 12.5-12.53v-74.94C46 122.6 40.42 117 33.5 117S21 122.6 21 129.53v74.94C21 211.4 26.58 217 33.5 217z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_1",
      "fill": "#BCC1BC",
      "d": "M21 204.5c0 6.9 5.6 12.5 12.5 12.5S46 211.4 46 204.5 40.4 192 33.5 192 21 197.6 21 204.5z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_3",
      "fill": "#EFEFEF",
      "d": "M60.64 103h25.72C108.3 103 126 83.96 126 60.54 126 37.04 108.3 18 86.36 18H60.64C38.7 18 21 37.04 21 60.46 21 83.96 38.78 103 60.64 103z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_2",
      "fill": "#BCC1BC",
      "d": "M24 45c-4.22 6.78-3.37 21.98-1 29 1.16.1 8.9.6 8.97-14.73C32.05 44.52 24.93 45.1 24 45z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_1",
      "fill": "#777",
      "d": "M67.43 26h22.14C106.95 26 121 40.53 121 58.5v10c0 17.97-14.05 32.5-31.43 32.5H67.43C50.05 101 36 86.47 36 68.5v-10C36 40.53 50.13 26 67.43 26z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_face"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_mouth_frown",
      "fill": "#D7F4E5",
      "d": "M74.54 76.24c5.76-2.76 12.58-3.93 18.48.42 1.52 1.18 2.73-1.67 1.22-2.85-6.52-4.84-14.17-3.76-20.53-.74-1.58.75-.75 3.94.84 3.18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_unsure",
      "fill": "#D7F4E5",
      "d": "M75.08 71.2c1.15.3 1.92 1.25 2.77 2.3.32.37.7.86 1.15.68.43-.18.76-.96 1.02-1.43.64-1.1 1.33-2 2.37-2.22 1.1-.25 2.27.3 3.23 1.1 1.04.87 2.03 2.37 3.25 2.7 1.1.3 1.56-1.4 2.23-2.3 2.17-2.98 4.9-.5 6.64 1.88.8 1.12-.44 2.85-1.25 1.75-.88-1.2-2.27-3.2-3.65-2.38-.97.57-1.36 2.32-2.27 3.07-2.67 2.22-4.77-2.7-7.14-3.34-1.38-.37-1.85 1.1-2.67 2.33-.77 1.17-1.83 1.7-2.93 1.07-1.07-.63-1.7-2.26-2.83-2.7-1.4-.56-2.65.72-2.98 2.62-.26 1.54-1.95.9-1.7-.65.52-3 2.57-5 4.76-4.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_neutral",
      "fill": "#D7F4E5",
      "d": "M96.03 72c1.3-.05 1.3 2.56 0 2.6-8.35.32-16.7.78-25.04 1.4-1.3.1-1.3-2.5 0-2.6 8.34-.63 16.68-1.1 25.03-1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_smile",
      "fill": "#D7F4E5",
      "d": "M74.68 72.65c5.74 2.57 12.53 3.66 18.42-.4 1.5-1.08 2.72 1.56 1.2 2.65-6.48 4.52-14.1 3.5-20.45.7-1.58-.7-.75-3.65.83-2.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_eye",
      "fill": "#D7F4E5",
      "d": "M68.5 62c1.43 0 2.5-1.03 2.5-2.2v-1.6c0-1.25-1.16-2.2-2.5-2.2-1.42 0-2.5 1.03-2.5 2.2v1.6c-.08 1.17 1.08 2.2 2.5 2.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_eye",
      "fill": "#D7F4E5",
      "d": "M99.5 62c1.43 0 2.5-1.03 2.5-2.2v-1.6c0-1.25-1.16-2.2-2.5-2.2-1.43 0-2.5 1.03-2.5 2.2v1.6c0 1.17 1.16 2.2 2.5 2.2z"
    }
  })])])]), _vm._v(" "), (_vm.lab_ready_state.doors_active) ? _c('svg', {
    class: _vm.lab_ready_state,
    attrs: {
      "id": "lab_doors",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1280",
      "height": "570",
      "viewBox": "0 0 1280 570"
    }
  }, [_c('title', [_vm._v("mod_2_lab_doors")]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "right_door"
    }
  }, [_c('path', {
    attrs: {
      "id": "right_door_glass",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M640 0h640v570H640z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_5",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M977.7 571.1h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_4",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M934.7 571.1h-70l200-259h70z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M763.7 570.1h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M1031.7 261.1h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M988.7 261.1h-70l200-259h70z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_frame_shadow",
      "fill": "#C1C1C1",
      "fill-rule": "nonzero",
      "d": "M695 571h-53V1h53v265l584.9-.4.2 50-585.1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_frame",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M690 571h-50V1h50v260h590v50H690z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_shadow",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M978.8 367.5H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.1c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6V349c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_4",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M978.8 367.5H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.1c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6V349c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M970.5 355.5H768.8c-7.8 0-14.1-6.3-14.1-14.1V229.6c0-7.8 6.3-14.1 14.1-14.1h201.7c7.8 0 14.1 6.3 14.1 14.1v111.7c.1 7.9-6.3 14.2-14.1 14.2z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "fingerprint_scanner"
    },
    on: {
      "click": _vm.open_lab
    }
  }, [_c('path', {
    attrs: {
      "id": "fingerprint_scanner_shadow",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M978.8 368H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.6c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6v126.9c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_4",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M978.8 368H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.6c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6v126.9c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M970.5 356H768.8c-7.8 0-14.1-6.3-14.1-14.1V230.1c0-7.8 6.3-14.1 14.1-14.1h201.7c7.8 0 14.1 6.3 14.1 14.1v111.7c.1 7.9-6.3 14.2-14.1 14.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "button_3",
      "fill": "#6D8C4A",
      "fill-rule": "nonzero",
      "d": "M962.3 342.5h-70.7c-6.2 0-11.2-5-11.2-11.2v-90.7c0-6.2 5-11.2 11.2-11.2h70.7c6.2 0 11.2 5 11.2 11.2v90.7c-.1 6.2-5.1 11.2-11.2 11.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "button_2",
      "fill": "#7ED320",
      "fill-rule": "nonzero",
      "d": "M958.9 339.1h-67.7c-6.2 0-11.2-5-11.2-11.2v-87.7c0-6.2 5-11.2 11.2-11.2h67.7c6.2 0 11.2 5 11.2 11.2v87.7c-.1 6.2-5.1 11.2-11.2 11.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "button_1",
      "fill": "#FFF",
      "d": "M904.9 266h-6.1c-.05-.1-.1-.23-.1-.4 0-.18.07-.35.2-.5l1.66-.2v-13.87h-1.45c-.25 0-.4-.12-.4-.35 0-.12.05-.32.14-.6l.05-.2h6.2c1.06 0 1.95.14 2.67.44.73.3 1.3.7 1.75 1.18.45.48.77 1 .98 1.6.2.56.3 1.12.3 1.68 0 .55-.1 1.1-.3 1.68-.2.58-.53 1.1-.98 1.6-.44.47-1.02.86-1.75 1.17-.72.3-1.6.44-2.66.44h-3.14v5.18h2.7c.27 0 .4.12.4.35 0 .12-.04.32-.12.6l-.05.2zm-2.94-7.48h3.15c1.3 0 2.34-.33 3.1-1 .76-.68 1.14-1.6 1.14-2.74 0-1.16-.38-2.07-1.14-2.74-.76-.68-1.8-1-3.1-1h-3.14v7.48zm23.73 7.13l-2.5.48c-.27-.16-.5-.34-.7-.56l.2-2.5c-.48 1.02-1.12 1.8-1.93 2.36-.8.55-1.72.82-2.76.82-1.24 0-2.2-.4-2.9-1.2-.67-.8-1-1.94-1-3.43v-6.94h-1.9c-.06-.12-.1-.24-.1-.36 0-.15.06-.3.16-.47l2.48-.47c.28.15.5.33.7.55v7.7c0 1.1.24 1.98.72 2.6.5.6 1.16.92 2.03.92.75 0 1.47-.23 2.13-.7.65-.45 1.18-1.05 1.58-1.8.4-.77.6-1.6.6-2.5v-5.47h-1.9c-.04-.12-.06-.24-.06-.36 0-.15.05-.3.15-.47l2.46-.47c.3.15.52.33.7.55v10.9h1.9c.05.1.08.23.08.35 0 .15-.05.3-.15.47zm2.56-.97l-.05-2.73c.13-.05.25-.07.4-.07.15 0 .3.05.46.14l.53 2.58c.8.37 1.75.55 2.8.55 1.05 0 1.86-.22 2.46-.65.6-.43.9-1.02.9-1.75 0-.6-.23-1.1-.68-1.52-.46-.42-1.18-.77-2.17-1.06-1.1-.3-2-.64-2.64-.98-.65-.35-1.1-.75-1.38-1.2-.28-.43-.42-.96-.42-1.57 0-1 .38-1.76 1.14-2.33.76-.57 1.8-.85 3.1-.85.6 0 1.23.06 1.88.18.64.1 1.12.26 1.43.44.2.22.35.47.5.75l.04 2.48c-.14.05-.26.07-.38.07-.16 0-.32-.05-.47-.15l-.54-2.3c-.7-.26-1.5-.4-2.37-.4-2 0-3 .7-3 2.1 0 .4.1.72.3 1 .2.27.53.52 1 .75.5.24 1.16.5 2 .75 1.4.42 2.43.93 3.07 1.54.65.6.97 1.37.97 2.3 0 1.07-.42 1.93-1.25 2.55-.85.64-2 .95-3.5.95-.7 0-1.37-.07-2.02-.23-.66-.15-1.2-.34-1.64-.6-.2-.2-.34-.46-.48-.75zm24.5 1.32h-4.82c-.05-.13-.08-.25-.08-.35 0-.13.05-.3.15-.47l1.7-.2v-7.1c0-2.36-.98-3.53-2.96-3.53-.8 0-1.5.23-2.16.7-.66.45-1.2 1.05-1.6 1.8-.4.77-.6 1.6-.6 2.5v5.57h1.46c.26 0 .4.12.4.35 0 .1-.04.28-.1.53l-.05.2h-4.84c-.05-.13-.07-.25-.07-.35 0-.13.04-.3.14-.47l1.7-.2v-14.56H939c-.04-.1-.06-.23-.06-.34 0-.16.05-.3.15-.48l2.6-.47c.27.15.5.33.7.55v6.4c.4-.8 1-1.45 1.74-2 .75-.56 1.7-.83 2.82-.83 1.34 0 2.35.4 3.05 1.2.7.78 1.06 1.92 1.06 3.43v7.05h1.45c.28 0 .4.1.4.34 0 .1-.02.28-.1.53l-.04.2zm-35.9 21.3v-7.7h-1.9c-.05-.13-.07-.25-.07-.35 0-.17.04-.33.14-.5l1.82-.23.4-2.62c.14-.03.3-.05.48-.05.1 0 .27.02.47.05v2.6h3.46c.27 0 .4.12.4.35 0 .1-.03.27-.1.52l-.05.23h-3.7v7.2c0 .78.06 1.4.15 1.9.1.46.28.8.57 1.03.3.2.75.32 1.37.32.3 0 .62-.03 1-.07.38-.06.75-.13 1.1-.23.16.27.25.58.3.95-.36.17-.8.3-1.3.4-.5.1-1 .15-1.5.15-.97 0-1.72-.28-2.25-.85s-.8-1.6-.8-3.1zm12.7 2.85c.87 0 1.63-.22 2.3-.67.65-.46 1.16-1.1 1.5-1.9.37-.82.55-1.76.55-2.83s-.17-2-.52-2.82c-.36-.82-.87-1.45-1.53-1.9-.66-.46-1.42-.68-2.3-.68-.85 0-1.62.22-2.27.67-.66.46-1.17 1.1-1.53 1.9-.36.82-.54 1.76-.54 2.83s.2 2 .55 2.82c.36.82.86 1.45 1.5 1.9.66.46 1.43.68 2.3.68zm0 1.1c-1.16 0-2.18-.27-3.03-.8-.86-.55-1.53-1.3-2.02-2.3-.47-.96-.7-2.1-.7-3.4 0-1.3.23-2.44.7-3.4.5-1 1.17-1.75 2.02-2.3.86-.53 1.88-.8 3.04-.8 1.17 0 2.18.27 3.04.8.86.55 1.53 1.3 2 2.3.5.96.74 2.1.74 3.4 0 1.3-.24 2.44-.73 3.4-.47 1-1.14 1.75-2 2.3-.86.53-1.87.8-3.04.8zm-24.92 23.82c1.2 0 2.24-.3 3.13-.88.9-.6 1.6-1.44 2.08-2.5.5-1.1.74-2.34.74-3.77 0-1.44-.26-2.7-.75-3.75-.5-1.07-1.18-1.9-2.08-2.5-.9-.58-1.93-.88-3.13-.88s-2.25.3-3.14.9c-.9.58-1.58 1.4-2.08 2.48-.5 1.06-.73 2.3-.73 3.75 0 1.45.23 2.7.72 3.77.5 1.07 1.2 1.9 2.08 2.5.9.58 1.94.88 3.14.88zm0 1.18c-1.5 0-2.8-.35-3.9-1.04-1.12-.68-2-1.65-2.6-2.9-.62-1.23-.93-2.7-.93-4.38 0-1.66.32-3.12.94-4.36.6-1.24 1.48-2.2 2.6-2.9 1.1-.7 2.4-1.04 3.9-1.04 1.48 0 2.78.35 3.9 1.04 1.1.7 1.98 1.66 2.6 2.9.6 1.24.92 2.7.92 4.37 0 1.68-.3 3.14-.92 4.38-.62 1.25-1.5 2.22-2.6 2.9-1.12.7-2.42 1.05-3.9 1.05zm15.6 4.38h-6.08c-.05-.12-.07-.24-.07-.36 0-.15.04-.3.14-.47l1.7-.2v-14.53c-.55.2-1.04.4-1.48.6-.23-.28-.37-.6-.42-.92.78-.45 1.7-.8 2.77-1.1 1.08-.26 2.1-.4 3.04-.4 1.25 0 2.34.27 3.28.8.95.55 1.68 1.3 2.2 2.26.53.97.8 2.1.8 3.38 0 1.3-.24 2.44-.72 3.43-.48 1-1.13 1.77-1.98 2.32-.84.56-1.8.83-2.9.83-1.24 0-2.32-.33-3.23-1v4.3h2.7c.25 0 .4.12.4.35 0 .1-.05.27-.1.53l-.06.2zm-2.95-15.93v9.25c1 .78 2.08 1.18 3.2 1.18.85 0 1.57-.23 2.2-.7.63-.45 1.1-1.08 1.46-1.9.35-.8.53-1.74.53-2.8 0-1.62-.46-2.92-1.36-3.9-.9-.97-2.1-1.45-3.6-1.45-.4 0-.8.02-1.2.08-.42.06-.84.14-1.25.24zm20.74 4.78h-8.4v.27c0 1.62.42 2.9 1.26 3.86.84.97 1.97 1.45 3.4 1.45.64 0 1.3-.1 2-.28.7-.18 1.25-.4 1.7-.62.12.13.22.28.3.44.05.15.1.3.1.47-1.37.8-2.82 1.18-4.34 1.18-1.16 0-2.18-.27-3.05-.8-.85-.55-1.53-1.3-2-2.3-.5-.96-.74-2.1-.74-3.4 0-1.32.23-2.46.7-3.44.45-.96 1.1-1.72 1.95-2.25.86-.53 1.86-.8 3-.8 3.08 0 4.6 1.82 4.6 5.48-.12.28-.28.53-.46.75zm-8.3-1.08h7.45c0-2.7-1.1-4.05-3.3-4.05-1.1 0-2 .37-2.75 1.1-.74.73-1.2 1.72-1.4 2.95zm24.5 7.6h-4.83c-.04-.13-.06-.25-.06-.35 0-.13.05-.3.15-.47l1.7-.2v-7.1c0-2.36-1-3.53-3-3.53-.77 0-1.5.23-2.15.7-.66.45-1.2 1.05-1.6 1.8-.4.77-.6 1.6-.6 2.5v5.57h1.46c.28 0 .4.12.4.35 0 .1-.02.28-.1.53l-.04.2h-4.82c-.05-.13-.08-.25-.08-.35 0-.13.05-.3.15-.47l1.7-.2v-10.3h-1.9c-.04-.12-.06-.24-.06-.36 0-.15.05-.3.15-.47l2.46-.48c.3.16.52.34.7.56l-.17 2.5c.45-1.02 1.1-1.8 1.9-2.36.83-.55 1.77-.82 2.84-.82 1.33 0 2.35.4 3.05 1.2.7.78 1.04 1.92 1.04 3.43v7.05H954c.25 0 .4.1.4.34 0 .1-.05.28-.1.53l-.06.2z"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_pound_2",
      "cx": "845.9",
      "cy": "328.9",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_pound_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M849.4 330.3h-1.7l-.4 2.1h-.1-.4l.4-2.1h-1.7l-.4 2.1h-.1-.5l.4-2.1h-1.2v-.3c0-.1 0-.2.1-.3h1.2l.5-2.4h-1.6v-.3c0-.1 0-.2.1-.3h1.7l.4-2.1h.5l-.4 2.1h1.7l.4-2.1h.5l-.4 2.1h1.2v.3c0 .1 0 .2-.1.3h-1.2l-.5 2.4h1.6v.6zm-2.2-.6l.5-2.4H846l-.5 2.4h1.7z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_asterisk_2",
      "cx": "788.6",
      "cy": "328.9",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_asterisk_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M788.9 331.1l-.6-1.3-1 1.1c-.1-.1-.2-.1-.2-.2l-.2-.2 1.1-1-1.3-.6c.1-.2.1-.4.3-.5l1.3.7.1-1.5h.3c.1 0 .2 0 .3.1l-.3 1.5 1.4-.3c0 .1.1.2.1.3v.3l-1.5.2.8 1.3c-.1.1-.2.1-.3.2-.1.1-.2-.1-.3-.1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_zero_2",
      "cx": "817.3",
      "cy": "328.9",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_zero_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M817.6 333c-.5 0-1-.1-1.4-.4-.4-.2-.7-.5-.9-.9-.2-.4-.4-.8-.5-1.3-.1-.5-.2-.9-.2-1.4 0-.5 0-.9.2-1.4.1-.5.3-.9.5-1.3s.5-.7.9-.9c.4-.2.8-.4 1.4-.4.5 0 1 .1 1.4.4.4.3.7.5.9.9.2.4.4.8.5 1.3.1.5.2.9.2 1.4 0 .5-.1.9-.2 1.4-.1.5-.3.9-.5 1.3s-.5.7-.9.9c-.4.3-.9.4-1.4.4zm0-.5c.4 0 .8-.1 1-.3.3-.2.5-.5.7-.8.2-.3.3-.7.4-1.1.1-.4.1-.8.1-1.2 0-.4 0-.8-.1-1.2-.1-.4-.2-.8-.4-1.1-.2-.3-.4-.6-.7-.8-.3-.2-.6-.3-1-.3s-.8.1-1 .3c-.2.2-.5.5-.7.8-.2.3-.3.7-.4 1.1-.1.4-.1.8-.1 1.2 0 .4 0 .8.1 1.2.1.4.2.8.4 1.1.2.3.4.6.7.8.2.2.6.3 1 .3z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_nine_2",
      "cx": "846.1",
      "cy": "300",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_nine_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M844.3 303.3c1-.4 1.8-1 2.4-1.6.6-.6 1-1.4 1.2-2.3-.2.4-.5.8-.8 1.1-.3.3-.8.4-1.3.4-.4 0-.9-.1-1.2-.3-.4-.2-.7-.5-.9-.9-.2-.4-.3-.8-.3-1.3s.1-.9.3-1.3c.2-.4.5-.7.9-.9.4-.2.8-.3 1.3-.3s1 .1 1.4.4c.4.2.7.6.9 1 .2.5.3 1 .3 1.6 0 .7-.2 1.4-.5 2-.3.6-.8 1.2-1.3 1.7-.6.5-1.3.9-2.1 1.2-.2-.1-.3-.3-.3-.5zm1.6-3c.4 0 .7-.1 1-.3.3-.2.5-.4.6-.7.2-.3.2-.6.2-1 0-.6-.2-1-.5-1.4-.3-.4-.8-.5-1.3-.5s-1 .2-1.3.5c-.3.4-.5.8-.5 1.4 0 .6.2 1 .5 1.4.3.4.7.6 1.3.6z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_eight_2",
      "cx": "817.3",
      "cy": "299.9",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_eight_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M818.3 300.1c.6.2 1.1.5 1.3.8.3.4.4.8.4 1.3s-.1.9-.3 1.2c-.2.3-.5.6-.9.8-.4.2-.9.3-1.4.3-.5 0-1-.1-1.4-.3-.4-.2-.7-.4-.9-.8-.2-.3-.3-.7-.3-1.2s.1-.9.4-1.3c.3-.4.7-.7 1.3-.8-.4-.2-.8-.4-1-.7-.2-.3-.3-.7-.3-1 0-.4.1-.7.3-1 .2-.3.5-.5.8-.7.3-.2.7-.2 1.1-.2.4 0 .8.1 1.1.2.3.1.6.4.8.7.2.3.3.6.3 1s-.1.7-.3 1c-.2.3-.6.6-1 .7zm1 2.1c0-.3-.1-.6-.3-.9-.2-.3-.4-.5-.7-.6-.3-.2-.6-.2-1-.2s-.7.1-1 .2c-.3.2-.5.4-.7.6-.2.3-.3.6-.3.9 0 .3.1.6.3.9.2.2.4.4.7.6.3.1.6.2 1 .2s.7-.1 1-.2c.3-.1.5-.3.7-.6.2-.3.3-.5.3-.9zm-.4-3.8c0-.4-.1-.7-.4-1-.3-.3-.7-.4-1.1-.4-.4 0-.8.1-1.1.4-.3.3-.4.6-.4 1s.1.8.4 1c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.2-.2.4-.6.4-1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_seven_2",
      "cx": "788.6",
      "cy": "299.9",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_seven_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M786.8 303.4l3.5-6.9h-3.6l-.3 1.3c-.1.1-.2.1-.2.1h-.2v-1.6l.3-.3h4.5c.1.1.2.3.3.4l-3.6 7.4c-.3-.1-.5-.2-.7-.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_six_2",
      "cx": "845.9",
      "cy": "271.1",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_six_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M843.9 271.7c.2-.4.5-.8.8-1.1.4-.3.8-.4 1.3-.4.4 0 .9.1 1.2.3.4.2.7.5.9.9.2.4.3.8.3 1.3s-.1.9-.3 1.3c-.2.4-.5.7-.9.9-.4.2-.8.3-1.3.3s-1-.1-1.4-.4c-.4-.3-.7-.6-.9-1-.2-.4-.3-1-.3-1.6 0-.7.2-1.4.5-2 .3-.6.8-1.2 1.4-1.7.6-.5 1.3-.9 2.1-1.2.1.1.2.3.3.5-1 .4-1.8 1-2.4 1.6-.6.6-1.1 1.4-1.3 2.3zm2 3c.5 0 1-.2 1.3-.5.3-.4.5-.8.5-1.4 0-.6-.2-1-.5-1.4-.3-.4-.8-.5-1.3-.5-.4 0-.7.1-1 .3-.3.2-.5.4-.6.7-.2.3-.2.6-.2 1 0 .6.2 1 .5 1.4.3.2.8.4 1.3.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_five_2",
      "cx": "817.3",
      "cy": "271.1",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_five_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M814.9 270.4l.3-3.2c.1-.1.2-.3.3-.4l.9.3c.3.1.6.1.9.1.2 0 .5 0 .8-.1.3 0 .6-.1.8-.2.1.1.2.3.2.5-.1.1-.3.1-.5.2s-.4.1-.7.1c-.3 0-.5.1-.7.1h-.8c-.3 0-.5-.1-.7-.1l-.2 2.4c.2 0 .4-.1.6-.1h.7c.8 0 1.4.2 1.9.6.5.4.7 1 .7 1.8 0 .5-.1.9-.4 1.3-.2.4-.6.7-1 .9-.4.2-.9.3-1.5.3-.8 0-1.5-.2-2.2-.6 0-.2.1-.3.2-.5.6.3 1.3.5 1.8.5.7 0 1.3-.2 1.7-.5.4-.3.6-.8.6-1.4 0-.6-.2-1-.5-1.4-.3-.3-.8-.5-1.4-.5-.3 0-.5 0-.8.1-.3 0-.5.1-.6.2l-.4-.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_four_2",
      "cx": "788.6",
      "cy": "271",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_four_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M791.1 275h-2.7v-.2c0-.1 0-.2.1-.2l1.2-.1v-1.6H786c-.1-.1-.2-.2-.2-.4l4.2-5.3c.1 0 .1 0 .2.1.1 0 .1.1.2.1v5h1.1c.1 0 .2.1.2.2s0 .2-.1.3v.1h-1.2v1.5h.7c.1 0 .2.1.2.2-.1 0-.1.1-.2.3zm-1.4-2.6v-3.9l-3 3.9h3z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_three_2",
      "cx": "846.1",
      "cy": "242.1",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_three_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M848.7 238.9l-2.4 2.9h.2c.7 0 1.3.2 1.7.6.4.4.6.9.6 1.6 0 .5-.1.9-.4 1.2-.2.4-.6.6-1 .9-.4.3-.9.3-1.5.3-.8 0-1.5-.2-2.2-.6 0-.2.1-.3.2-.5.6.3 1.3.5 1.8.5.7 0 1.3-.2 1.7-.5.4-.3.6-.8.6-1.3s-.2-.9-.5-1.2c-.3-.3-.8-.4-1.3-.4h-.4c-.1 0-.3 0-.4.1 0 0-.1-.1-.1-.2s-.1-.1-.1-.2l2.5-3h-3l-.3 1.1c-.1.1-.2.1-.2.1h-.2V239l.3-.3h4.1c.2-.1.3 0 .3.2z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_two_2",
      "cx": "817.3",
      "cy": "242.1",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_two_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M819.8 245.7h-4.3l-.3-.3v-.2c0-.3.1-.7.2-1 .1-.3.4-.6.7-.9.3-.3.7-.7 1.3-1.1.5-.4.8-.7 1.1-.9.3-.3.5-.5.6-.7.1-.2.2-.5.2-.7 0-.4-.1-.8-.4-1-.3-.3-.6-.4-1.1-.4-.7 0-1.3.3-1.8 1-.2-.1-.3-.2-.4-.4.2-.4.6-.6 1-.8.4-.2.8-.3 1.3-.3.6 0 1.2.2 1.6.5.4.4.6.8.6 1.4 0 .3-.1.6-.2.9-.1.3-.3.6-.7.9-.3.3-.7.7-1.3 1.1-.5.4-.8.7-1.1 1-.3.3-.5.5-.6.8-.1.2-.2.5-.2.8h3.6l.3-1.4c.1-.1.2-.1.2-.1h.2v1.6c-.3 0-.4.1-.5.2z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_one_2",
      "cx": "788.6",
      "cy": "242.1",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_one_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M789.8 245.7h-3.5v-.2c0-.1 0-.2.1-.2l1.5-.1v-6.4l-1.6.9c-.1-.1-.2-.3-.3-.4l2.1-1.4c.1 0 .1 0 .2.1.1 0 .1.1.2.1v7.1h1.2c.1 0 .2.1.2.2 0 0-.1.1-.1.3z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "left_door"
    }
  }, [_c('path', {
    attrs: {
      "id": "door_left_glass",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M0 0h640v570H0z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_frame_left_shadow",
      "fill": "#C1C1C1",
      "fill-rule": "nonzero",
      "d": "M587 1h53v570h-53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_frame_left",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M585 1h50v570h-50z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_glare_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M192.6 571h-28.9L585 24.4V62z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_glare_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M131.2 571H17.4L456.8 1h113.7z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_sign_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M522 435H61.9c-4.3 0-7.9-3.5-7.9-7.9V141.9c0-4.3 3.5-7.9 7.9-7.9h460.2c4.3 0 7.9 3.5 7.9 7.9v285.2c-.1 4.4-3.7 7.9-8 7.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_sign_1",
      "fill": "#A0D1F2",
      "fill-rule": "nonzero",
      "d": "M522.1 435H61.9c-4.3 0-7.9-3.5-7.9-7.88V252h476v175.12c0 4.4-3.6 7.88-7.9 7.88z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "text_2",
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "30",
      "letter-spacing": "1"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "81",
      "y": "319"
    }
  }, [_vm._v("MODULE 2:")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "81",
      "y": "354"
    }
  }, [_vm._v("External Influencers -")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "81",
      "y": "389"
    }
  }, [_vm._v("Get Conscious")])]), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "exit_4",
      "width": "230",
      "height": "74",
      "x": "83",
      "y": "158",
      "fill": "#4CAF50",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "exit_3",
      "fill": "#FFF",
      "d": "M190.1 188.94l2.95 1.8 3.5-7h6.56l-4.93 10.22-1.9 10.92h-10.6l-2.35 4.44h16.55l2.4-12.45 9.37 20.47h4.6L206.25 195l4.4-8.6 4.7 5.68H222v25.26l-4.36 4.66h-5.6l2.62-3.45h-4.57l-2.74 3.45H183l5.02-4.66v-6.82H181l3.6-7.12H188V168H222v20.56h-5.16l-7.02-8.4h-15.07l-4.64 8.78zm21.32-9.72c2.36 0 4.27-2 4.27-4.5 0-2.46-1.92-4.48-4.28-4.48-2.36 0-4.27 2.02-4.27 4.5 0 2.47 1.9 4.48 4.27 4.48z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "exit_2",
      "fill": "#FFF",
      "d": "M122.86 183.86h-14.33v5.64h13.16v4.62h-13.17v6.82h15v4.78H103v-26.56h19.86v4.7zm3 21.86l6.83-9.95-6.55-9.65h6.4l3.36 5.7 3.28-5.7h6.23l-6.57 9.56 6.83 10.04h-6.52l-3.45-5.9-3.5 5.9h-6.34zm28.6-21.98h-5.32V179h5.3v4.74zm-5.32 2.34h5.3v19.64h-5.3v-19.64zm8.63 3.84v-3.66h2.8v-5.48h5.18v5.48H169v3.66h-3.25v10.38c0 .8.1 1.3.3 1.5.22.2.86.3 1.92.3h.5l.53-.04v3.84l-2.48.1c-2.47.07-4.16-.35-5.07-1.27-.6-.6-.88-1.5-.88-2.72v-12.08h-2.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "exit_1",
      "fill": "#FFF",
      "d": "M234 186.67v11.62h36.22L256.5 212h16.36L293 192.54 272.86 173H256.5l13.72 13.67z"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.school_doors),
      expression: "school_doors"
    }],
    attrs: {
      "id": "school_doors",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1280",
      "height": "571",
      "viewBox": "0 0 1280 571"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "right_door",
      "transform": "translate(640, 0)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M640 0h640v570H640z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M823.8 571H710L1149.4 1h113.7",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M887.9 570.6H859L1280.3 24v37.6",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#2A2522",
      "fill-rule": "nonzero",
      "d": "M720 570h-80V0h80"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "995",
      "cy": "285",
      "r": "60",
      "fill": "#F4F4F4",
      "stroke": "#4CAF50",
      "stroke-width": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#353535",
      "d": "M960 285l35-35 35 35h-13.12v35h-43.75v-35"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D2D2D2",
      "d": "M670 185h50c16.57 0 30 13.43 30 30v140c0 16.57-13.43 30-30 30h-50c-5.52 0-10-4.48-10-10s4.48-10 10-10h45c8.28 0 15-6.72 15-15V220c0-8.28-6.72-15-15-15h-45c-5.52 0-10-4.48-10-10s4.48-10 10-10z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "left_door",
      "transform": "translate(-640, 0)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M0 0h640v570H0z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M131.2 571H17.4L456.8 1h113.7",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "glare_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M192.6 571h-28.9L585 24.4V62z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#181513",
      "fill-rule": "nonzero",
      "d": "M634 570h6V0h-6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#2A2522",
      "fill-rule": "nonzero",
      "d": "M555 570h80V0h-80"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D2D2D2",
      "d": "M605 185h-50c-16.57 0-30 13.43-30 30v140c0 16.57 13.43 30 30 30h50c5.52 0 10-4.48 10-10s-4.48-10-10-10h-45c-8.28 0-15-6.72-15-15V220c0-8.28 6.72-15 15-15h45c5.52 0 10-4.48 10-10s-4.48-10-10-10z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "400",
      "height": "250",
      "x": "78",
      "y": "160",
      "fill": "#FFF",
      "rx": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "380",
      "height": "230",
      "x": "88",
      "y": "170",
      "fill": "#FFF",
      "stroke": "#FACE86",
      "stroke-width": "5",
      "rx": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#353535",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "30",
      "letter-spacing": "1"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "193.43",
      "y": "258.16"
    }
  }, [_vm._v("MODULE 2:")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "115.82",
      "y": "293.16"
    }
  }, [_vm._v("External Influencers - ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "171.84",
      "y": "328.16"
    }
  }, [_vm._v("Get Conscious")])])])])])]), _vm._v(" "), _c('control-panel', {
    attrs: {
      "text": _vm.active_text,
      "control_panel_active": _vm.control_panel_active
    },
    on: {
      "textProgress": function($event) {
        _vm.text_update($event)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.modal_active) ? _c('div', {
    staticClass: "info_modal"
  }, [_c('div', {
    staticClass: "info_modal_inner tan"
  }, [(_vm.selected_pin == 'car') ? _c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "span_6_xs left_panel"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "400",
      "height": "400",
      "viewBox": "0 0 400 400"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "77.5",
      "cy": "242.5",
      "r": "34.5",
      "fill": "#3B3B3B"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "78",
      "cy": "242",
      "r": "22",
      "fill": "#D8D8D8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "319.5",
      "cy": "242.5",
      "r": "34.5",
      "fill": "#3B3B3B"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "319",
      "cy": "242",
      "r": "22",
      "fill": "#D8D8D8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A90E2",
      "stroke": "#4A90E2",
      "d": "M264.08 167.1c-12.1-8.75-21.06-34.23-37.77-39.3-16.7-5.05-79.06-10.67-121.36 9.1-42.3 19.78-76.6 66.67-85.94 101.24h18.5c.48-5 9.1-34.76 40.67-34.57 31.56.2 41.12 22.2 40.95 45.43 10.62 0 151.6-.1 160.4 0-1.1-26.02 12.38-45.43 38.36-45.43 25.97 0 42.27 19.58 44.06 34.57H381c-4.5-30.12-36.57-73.47-116.92-71.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#79ABE5",
      "d": "M34 236.8h4.88c.42-4.26 8.22-32.52 39.18-32.7 30.96-.18 39.5 22.88 39.33 45.9h7c6.23-28.17-2.5-60.53-46.34-60-39.17.5-44.13 37.68-44.06 46.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#79ABE5",
      "d": "M275.4 250h4.93c-1.76-21.46 8.47-45.32 39.17-45.32 23.93 0 37.7 16.9 40.3 32.9h6c2.1-24.4-12.22-48.58-46.04-48.58-48.48 0-50.32 49.77-44.35 61z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D8D8D8",
      "d": "M20.14 236H41l-2.45 12h-18.4c-3.4 0-6.15-2.7-6.15-6s2.75-6 6.14-6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D8D8D8",
      "d": "M380.9 236H359l1.22 12h20.7c3.35 0 6.08-2.7 6.08-6s-2.73-6-6.1-6z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "75.5",
      "cy": "178.5",
      "r": "7.5",
      "fill": "#3F80CB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#3F80CB",
      "d": "M178 127c-13.6 0-36.3.6-47.34 6.48-11.04 5.88-32.5 28.58-39.66 38.05v14.3c33.47 6.5 42.48 30.6 38.42 59.17H178V127z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#79ABE5",
      "d": "M102 182h20c0-3.4-3.33-5.07-10-5-6.67.08-10 1.74-10 5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#3771B4",
      "d": "M103 182h18c-.67 1.95-3.67 2.95-9 3-5.33.05-8.33-.95-9-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DEEBFB",
      "d": "M174.53 131c-13.6 0-33.38-.35-43.35 6.48-9.96 6.83-24.65 21.24-32.65 31.06-.32.38-.5.83-.53 1.33-.07 1.1.77 2.06 1.87 2.13h71.66c1.65 0 3-1.34 3-3v-38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M154 131.4c-2.4.2-4.77.5-7.04.87-.37.67-9.68 13.92-27.96 39.73h7.83c17.57-26.17 26.63-39.7 27.17-40.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M165.38 131c-1.15 0-2.3.03-3.5.06-1.16 2.06-9.8 15.7-25.88 40.92h4.04L165.38 131z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#3F80CB",
      "d": "M181 127c13.6 0 36.3.6 47.34 6.48 11.04 5.88 22.5 28.58 29.66 38.05V245h-77V127z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#79ABE5",
      "d": "M185 182h20c0-3.4-3.33-5.07-10-5-6.67.08-10 1.74-10 5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#3771B4",
      "d": "M186 182h18c-.67 1.95-3.67 2.95-9 3-5.33.05-8.33-.95-9-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DEEBFB",
      "d": "M185 131c13.6 0 31.38-.35 41.34 6.48 9.97 6.83 17.66 21.24 25.66 31.06.32.38.5.83.52 1.33.08 1.1-.76 2.06-1.86 2.13H188c-1.66 0-3-1.34-3-3v-38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M218.6 134c.96.3 1.88.63 2.76 1-1.14 1.94-9.13 14.3-24 37.05H194c15.6-24.12 23.82-36.8 24.6-38.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M226.5 138c1.9 1.3 3.74 2.9 5.5 4.68-1.87 2.93-7.95 12.7-18.23 29.32H205c11.84-19 19-30.33 21.5-34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#79ABE5",
      "d": "M256 166v19.85c5.34 0 7.97-3.3 7.9-9.93-.07-6.6-2.7-9.92-7.9-9.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M360.24 197.88c9.04-4.3 17.47 8.1 12.05 17.12-6.22-.5-13.76-10.85-12.06-17.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#C13849",
      "d": "M36.4 199.16c-5.77-1.82-12.9 12.16-9.53 16.93 3.73-1.52 9.86-13.66 9.54-16.94z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "span_6_xs right_panel"
  }, [_c('div', {
    staticClass: "right_panel_content"
  }, [_c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Please see your teacher. She/he will lead a discussion that will analyze messages you receive about men, women,\n                self, culture and relationships through music.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.modal_close
    }
  }, [_vm._v("proceed")])])])]) : (_vm.selected_pin == 'dylan') ? _c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "span_6_xs left_panel"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "400",
      "height": "400",
      "viewBox": "0 0 400 400"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#F0CDB8",
      "d": "M223.67 206.88c.14 1.26 1.05 1.87 2 3.28 1.14 1.63 1.35 4.76 2.67 7.28-.24.64-2.17-.3-2.64-1.33-.48-1-.85-1.84-1-2.1-.16-.25-.48-.2-.55.07-.07.26.63 9.48.48 9.95-.16.47-1.26.6-1.5.16-.24-.45-.97-7.72-1.08-7.9-.1-.2-.35-.07-.44.04-.08.1.9 7.86.76 8.17-.13.3-1.28.37-1.43.14-.15-.22-1-7.96-1.13-8.12-.15-.17-.4-.12-.48.05-.1.16.96 7.6.82 7.93-.15.34-1.26.46-1.4.15-.13-.32-1.13-7.8-1.25-7.9-.13-.08-.27-.06-.36.05-.1.1.38 5.72.23 6.04-.15.33-.98.5-1.14.13-.16-.37-.98-14.08-1.08-14.83-.3-2.52.87-5.3 3.78-5.62 2.9-.32 4.44 1.65 4.74 4.36z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#353535",
      "d": "M216.13 176.04c-3.68.38-6.34 3.62-5.95 7.23 0 .1.02.18.03.27l3.56 23.7c.17 1.15 1.25 1.97 2.43 1.85l6.84-.72c1.2-.12 2.07-1.14 2-2.32l-1.54-23.9c-.23-3.62-3.4-6.38-7.1-6.15l-.27.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#353535",
      "d": "M213.9 151.18c-3.64.32-6.33 3.5-6 7.14l2.1 24.1c.32 3.62 3.52 6.3 7.15 6 3.63-.33 6.3-3.53 6-7.16l-2.1-24.1c-.33-3.62-3.53-6.3-7.16-5.98z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#353535",
      "d": "M215.22 282.76h-11.88V296H229c-.2-3.8-2-6-5.32-6.62-3.33-.62-6.15-2.83-8.46-6.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#787B78",
      "d": "M203.34 294.34V296H229c-.08-.76-.16-1.32-.25-1.66h-25.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#787B78",
      "d": "M214.1 289.03l1.02 1.18 3.95-2.4-1.26-.9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#787B78",
      "d": "M212.44 286.4l.8 1.32 3.34-2.1-.84-1.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ABAFAB",
      "d": "M209.55 232.28c-4.8 0-8.7 3.9-8.7 8.7v41.78h17.4v-41.8c0-4.8-3.9-8.68-8.7-8.68z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "17.38",
      "height": "55.45",
      "x": "200.86",
      "y": "195.03",
      "fill": "#ABAFAB",
      "transform": "matrix(-1 0 0 1 419.103 0)",
      "rx": "8.69"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#3D3D3D",
      "d": "M195.36 282.76h-11.88V296h25.66c-.22-3.8-2-6-5.32-6.62-3.34-.62-6.15-2.83-8.46-6.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7C7F7C",
      "d": "M183.48 294.34V296h25.66c-.08-.76-.16-1.32-.25-1.66h-25.42z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7C7F7C",
      "d": "M194.24 289.03l1.02 1.18 3.95-2.4-1.24-.9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7C7F7C",
      "d": "M192.6 286.4l.8 1.32 3.32-2.1-.84-1.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ABAFAB",
      "d": "M189.7 232.28c-4.8 0-8.7 3.9-8.7 8.7v41.78h17.38v-41.8c0-4.8-3.9-8.68-8.7-8.68z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "17.38",
      "height": "55.45",
      "x": "181",
      "y": "195.03",
      "fill": "#ABAFAB",
      "transform": "matrix(-1 0 0 1 379.38 0)",
      "rx": "8.69"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ABAFAB",
      "d": "M218.24 185.93H181v5.38c0 10.3 8.34 18.63 18.62 18.63 10.28 0 18.62-8.34 18.62-18.62v-5.37z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "39.72",
      "height": "55.45",
      "x": "171.9",
      "y": "143.72",
      "fill": "#5B7046",
      "transform": "matrix(-1 0 0 1 383.517 0)",
      "rx": "19.86"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#BCC1BC",
      "d": "M214.6 149.06c-4.44-5.8-24.6-5.98-29.45-.7-11.52 12.55-4.02 35.83-6.76 41.08-2.75 5.25-1.2 8.66 0 10.6 5.14 8.32 34.06 11.03 40.37.74 1.37-2.24 1.9-9.1-.86-14.1s-1.36-35.1-3.3-37.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#353535",
      "d": "M213.17 143.56c-.86-7.92-23.26-9.27-24.6 0-1.34 9.27 8.72 11.8 14.48 6.6 6.52 2.93 10.98 1.33 10.12-6.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#778F5F",
      "d": "M185.7 147.03c-2.3.03-5.3 2.22-4.6 4.55 12.7.07 10.36 16.84 7.03 28.8 0 .84.17 3.75 0 4.72 9.56-8.9 11.96-34.15-2.42-38.07z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#778F5F",
      "d": "M218.44 152.3c-.48-3.08-2.94-5.04-5.16-5.27 2.12 11.06 2.58 24.6 3.7 34.76 1.57-11.67 2.93-20.23 1.46-29.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F0CDB8",
      "d": "M208.38 175.76c1.25-.2 1.8-1.2 3.15-2.27 1.56-1.27 4.66-1.64 7.1-3.15.64.23-.2 2.3-1.17 2.84-1 .54-1.8.96-2.04 1.14-.24.17-.17.5.1.56.26.07 9.4-1.1 9.88-.98.47.14.67 1.3.24 1.56-.43.28-7.63 1.4-7.8 1.52-.18.12-.05.36.07.45.12.1 7.78-1.3 8.1-1.18.3.13.45 1.32.23 1.5-.2.16-7.87 1.42-8.02 1.57-.15.16-.1.42.1.5.16.08 7.5-1.38 7.84-1.24.34.13.53 1.3.23 1.44-.3.16-7.7 1.57-7.78 1.7-.1.13-.07.28.05.37.1.1 5.67-.66 6-.53.33.14.54 1 .2 1.2-.36.18-13.97 1.7-14.72 1.84-2.5.46-5.34-.64-5.82-3.67-.47-3.03 1.4-4.72 4.08-5.17z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#353535",
      "d": "M178.04 184.32c.57 3.62 3.96 6.08 7.57 5.5.1 0 .2-.02.28-.04l21.02-4.23c2.62-.53 4.37-3.04 3.95-5.7l-.23-1.42c-.42-2.65-2.85-4.5-5.52-4.2l-21.3 2.48c-3.62.43-6.22 3.72-5.8 7.35 0 .1.02.18.04.27z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "13.24",
      "height": "37.24",
      "x": "176.75",
      "y": "150.43",
      "fill": "#353535",
      "transform": "rotate(176 177.47 0)",
      "rx": "6.62"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E5BDA6",
      "d": "M206.2 141.82c-.35 2.36-.54 4 .46 5.3-.26.5-.64 2-2.7 2.32-2.8.45-5.9-1.18-6.4-2.3.9-1.34 1-2.7.45-5.32.68-1.9 7.26-1.84 8.2 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F0CDB8",
      "fill-rule": "nonzero",
      "d": "M186.2 126.17c-.93-.55-2.27-1.25-3.78 0-1.3 1.07-.32 5.27 1.43 7.6 1.72 2.3 4.54 2.77 5.64 1.9 2.55 5.63 5.26 8.05 12.22 8.05 9.8 0 13.2.63 13.2-19.45 0-14.2-3.78-19.44-13.2-19.44-8.46-.05-17.85 4.46-15.52 21.34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DFB39B",
      "d": "M205.64 138.76h-7.13c-.73 0 1.92 1.65 4.3 1.65 2.37 0 3.5-1.64 2.84-1.64z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D3A185",
      "d": "M206.43 138.76h-8.72c-.9 0 2.34-1.66 5.25-1.66 2.9 0 4.28 1.66 3.48 1.66z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E5BDA6",
      "d": "M186.73 130.23c-.8-1.84-2.04-3.54-3.56-2.93-1.52.6.43 7.33 4.45 7.32-.47-.3-1.74-1.78-1.78-2.93-.04-1.16.3-1.73.9-1.47z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DFB39B",
      "d": "M204.1 126.22c0-.9-2.1-.98-2.1 0s-.68 6.1 0 7c.66.9 2.64.6 2.95 0 .3-.6-.86-6.1-.86-7z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "193.83",
      "cy": "133.38",
      "r": "2.9",
      "fill": "#EDC7B2",
      "transform": "matrix(-1 0 0 1 387.655 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "210.38",
      "cy": "133.38",
      "r": "2.9",
      "fill": "#EDC7B2",
      "transform": "matrix(-1 0 0 1 420.76 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M199.2 126.64c-1.2-3.26-6.63-3.75-7.44-.93 0 3.82 6.56 4.15 7.45.94z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196.83",
      "cy": "126.76",
      "r": "2.07",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 393.655 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DFB39B",
      "d": "M199.2 126.64c-1.2-3.26-6.63-3.75-7.44-.93 0 3.82 6.56 4.15 7.45.94z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M205.83 126.64c1.22-3.26 6.63-3.75 7.45-.93 0 3.82-6.57 4.15-7.45.94z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "210.72",
      "cy": "126.76",
      "r": "2.07",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 421.448 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DFB39B",
      "d": "M205.83 126.64c1.22-3.26 6.63-3.75 7.45-.93 0 3.82-6.57 4.15-7.45.94z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#33261A",
      "d": "M205.94 121.32c.5-1.04 8.14.7 8.07 1.72-.06 1-1.56.18-3.7-.12-2.16-.3-4.85-.56-4.36-1.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#33261A",
      "d": "M199.08 121.25c-.5-1.03-8.13.85-8.04 1.86.1 1.02 1.57.16 3.7-.18 2.16-.33 4.85-.64 4.34-1.67z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7F9568",
      "d": "M183.84 125.44c3.48.73 4.4 7.43 4.85 7.92.45.5 1.67.66 1.64 0-.03-.67-1.65-7.92.6-14.46-.94.1-3.42 1.05-7.46 2.85.2 1.96.3 3.2.36 3.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#1C1C1C",
      "d": "M201.76 104c-13.32.57-18.4.98-18.27 18.2 7-3.9 26.8-4.16 31.43-2.18-.13-9.76-4.8-16.36-13.17-16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#353535",
      "d": "M218.73 119.26c-6.24-5.52-23.7-4.26-28.6.08-1.6 1.42-.77 2.4.9 1.92 3.4-.93 21.37-1.4 26.68-.07 2.03.5 3.2 0 1.03-1.94z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "span_6_xs right_panel"
  }, [_c('div', {
    staticClass: "right_panel_content"
  }, [_c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Please see your teacher. She/he will lead a discussion that will analyze messages you receive about men, women,\n                self, culture and relationships through your environment.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.modal_close
    }
  }, [_vm._v("proceed")])])])]) : (_vm.selected_pin == 'ad') ? _c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "span_6_xs left_panel"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "400",
      "height": "400",
      "viewBox": "0 0 400 400"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#494949",
      "d": "M212 100h149.83v200H212z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#000",
      "d": "M304.05 138.85c-.52 3.73.18 7.78 2.1 8.7-4.64 9.55-3.27 16.98-3.07 21.65-.66 1.16-2.23 1.45-3.58 2 2.03-.07 2.76-.3 3.6-.55-.04.88-.17 1.63-.46 2.24-1.98 4.13-5.87 10.3-7.07 12.34-1.2 2.06 3.26 3.47 5.8 4.88 2.53 1.42-.65 4.62-1.86 5.08-1.2.45.9 4.3 3.38 5.25-.86.73-2.27.52-2.53 2.38-.26 1.86.56 3.68 2.86 4.06 2.3.37-1.1 7.8.95 10.35 2.04 2.55 15.6-1.02 23.08-4.03 7.47-3 9.93 7.45 10.64 10.3.7 2.88 2.76 9-1.57 11.18-4.33 2.18-41.13 7.7-47.14 10.13-4 1.62-8.33 24.75-12.95 55.17h85.63V126.76c-14.14-7.27-54.82-8.96-57.78 12.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#696969",
      "d": "M223.55 210.88c-7.27 8.4-.63 56.07 4.5 89.12h40.14c3.62-28.26 12.5-81.47 4.62-89.12-7.9-7.65-42-8.4-49.27 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#252525",
      "d": "M223.37 211.04c.2 0-3.56 2.53-2.37 16.15.3 3.47 2.86 27.74 7.67 72.8h39.74c4.43-44.6 6.82-68.86 7.17-72.8 1.1-12.53-2.95-16.16-2.7-16.16 1.95 0 65.23 29.43 69.77 32.65 3.47 5.54 9.26 24.3 17.4 56.3H212v-76.08c6.34-8.6 10.13-12.88 11.37-12.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#373737",
      "d": "M223.37 211.04c.2 0-3.56 2.53-2.37 16.15.3 3.47 2.86 27.74 7.67 72.8h39.56c4.55-44.6 7-68.86 7.34-72.8 1.1-12.53-2.95-16.16-2.7-16.16.4 0 3.6 1.32 8.38 3.44 4.76 6.77 12.43 42.96 13.37 50.16-1.13 5.84-4.73 17.62-10.8 35.36H212v-76.08c6.34-8.6 10.13-12.88 11.37-12.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#CECECE",
      "d": "M223.37 199h49.5v22.74l-14.3 16.4-10.45 29.55-11.86-29.56-12.9-16.4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#252525",
      "d": "M248.12 197.66c21.43 0 41.47-17.03 41.47-38.1 0-21.05-3.15-51.53-41.48-51.53-21 0-31.15 9-36.12 20.73v47.5c7 12.37 21.02 21.4 36.12 21.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D6D6D6",
      "d": "M285.28 164.84c6.9-2.38 9.83 2.37 8.7 8.6-1.13 6.2-7.37 8.7-8.7 11.15-1.33 2.42-1.02 5.9-5.6 6-4.6.12-1.3-23.38 5.6-25.76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DCDCDC",
      "d": "M212 186.96c.64 1.63 1.62 3.57 4.5 3.64 4.36.1 1.73-21.6-4.5-25.72v22.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E5E5E5",
      "d": "M241.45 217.13c2.65 0 5.04-1.34 6.7-1.34 1.64 0 4 1.33 6.68 1.33 2.67 0 22.07-7.98 28.76-47 2.9-17.02-3.42-25.55-13.98-34.53-15.98-13.58-34.55 4.38-27.1 18.15-11.75-.06-17.37-12.87-15.83-18.16-10.67 8.72-16.84 17.48-14.02 34.53 1.44 8.68 3.47 15.8 5.8 21.63 8.48 21.27 20.9 25.37 22.97 25.37z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DCDCDC",
      "d": "M248.14 215.8c1.65 0 4 1.33 6.7 1.33 2.66 0 22.06-7.98 28.75-47 2.9-17.02-3.42-25.55-13.98-34.53 5.43 7.9 9.83 16.7 11.38 27.56-7.82-7.2-28.17.6-32.86 4.92-2 8.9 0 19.6 0 24.56 0 10.87-1.65 23.15 0 23.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#252525",
      "d": "M254.2 162.32c.13 1.82-.03 4.16 1.15 4.1 1.17-.07 12.72-4.77 14.82-5.34 2.1-.57 7.6.4 10.2 1.76 2.57 1.37-2.9-6.35-8.68-5.6-5.8.73-17.62 3.25-17.5 5.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#252525",
      "d": "M242.04 162.32c-.13 1.82.03 4.16-1.14 4.1-1.18-.07-12.73-4.77-14.83-5.34-2.1-.57-7.6.4-10.2 1.76-2.57 1.37 2.9-6.35 8.68-5.6 5.78.73 17.6 3.25 17.5 5.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M258.1 169.92c2.34-3.6 12.34-4.06 16.6-1.35-1.04 2.18-5.68 3.48-7.58 3.67-1.9.2-7.86-.26-9-2.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#737373",
      "d": "M265.2 172.17c1.46.15 2.76-.9 2.9-2.36.16-1.44-.9-2.74-2.34-2.9-1.46-.15-2.76.9-2.9 2.36-.16 1.45.9 2.75 2.34 2.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#252525",
      "d": "M265.34 170.83c.72.08 1.36-.44 1.44-1.16.07-.72-.45-1.36-1.16-1.44-.72-.07-1.36.45-1.44 1.17-.08.72.45 1.36 1.16 1.43z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "264.43",
      "cy": "168.78",
      "r": "1",
      "fill": "#FFF",
      "transform": "rotate(6 264.43 168.783)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M238.13 169.92c-2.33-3.6-12.33-4.06-16.6-1.35 1.06 2.18 5.7 3.48 7.6 3.67 1.88.2 7.85-.26 9-2.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#737373",
      "d": "M231.04 172.17c-1.46.15-2.76-.9-2.9-2.36-.16-1.44.9-2.74 2.34-2.9 1.46-.15 2.76.9 2.9 2.36.16 1.45-.9 2.75-2.34 2.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#252525",
      "d": "M230.9 170.83c-.72.08-1.36-.44-1.44-1.16-.07-.72.45-1.36 1.16-1.44.72-.07 1.37.45 1.44 1.17.08.72-.44 1.36-1.16 1.43z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "231.81",
      "cy": "168.78",
      "r": "1",
      "fill": "#FFF",
      "transform": "rotate(174 222.966 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F0F0F0",
      "d": "M247.05 166.9h2.1c.53 0 .97.4 1 .95.34 8.5.63 13.34.85 14.5.34 1.78 4.48 1.73 4.48 4.7 0 .92-2.5.56-3.7 1.58-1.2 1-.78 3.02-3.68 3-2.9 0-2.92-2.08-4.04-3-1.1-.92-3.3-.8-3.3-1.58 0-2.87 4.16-2.74 4.44-4.7.18-1.27.47-6.1.85-14.5.03-.54.47-.96 1-.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D6D6D6",
      "d": "M248 215.77c1.15 0 2.2.46 2.76.62.55.15-1.95-5.64-2.77-5.62-.83.02-2.9 5.6-2.47 5.6.45 0 1.3-.6 2.46-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#BCBCBC",
      "d": "M248.16 203c8.03 0 9.35-3.36 10.04-4.03-.65 0-7.8.82-10.04.84-2.22.02-9.42-.83-10.03-.83.73.67 2 4.02 10.03 4.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#CBCBCB",
      "d": "M248.16 197.64c.85 0 2.28-1.32 3.35-1.32 1.08 0 6.18 2.47 6.7 2.65.5.2-7.8.82-10.04.84-2.22.02-10.43-.58-10.03-.83.4-.24 6.13-2.65 6.7-2.65.55 0 2.5 1.32 3.33 1.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E5E5E5",
      "d": "M258.04 174.5c2.94 1.7 15.64.72 17.7-1.13 2.06-1.85-4.98 19.27-10.33 19.27-5.34 0-10.3-19.85-7.36-18.14z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12.04",
      "height": "6.69",
      "x": "311.67",
      "y": "224.41",
      "fill": "#B07A22",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#96671A",
      "d": "M313 231.1h9.12v3.9H313z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F4DEB9",
      "d": "M303.96 235.12h26.9c1.64 0 3 1.34 3 3v30.05c0 1.65-1.36 3-3 3h-26.9c-1.65 0-3-1.35-3-3v-30.05c0-1.66 1.35-3 3-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D59F46",
      "d": "M308.78 237.12h17.48c2.76 0 5 2.24 5 5 0 .25-.02.5-.06.75l-2.83 18.67c-.37 2.44-2.47 4.25-4.94 4.25H311.6c-2.46 0-4.56-1.82-4.93-4.26l-2.83-18.67c-.4-2.73 1.47-5.28 4.2-5.7.24-.03.5-.05.74-.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F4DEB9",
      "d": "M302.6 235.12h29.47c.55 0 1 .44 1 1 0 .17-.05.34-.13.48l-5 8.95c-.53.95-1.53 1.54-2.62 1.54h-15.98c-1.1 0-2.1-.6-2.62-1.55l-5-8.95c-.27-.48-.1-1.1.38-1.36.15-.08.32-.12.5-.12z",
      "opacity": ".3"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "317.35",
      "cy": "255.52",
      "r": "5.02",
      "fill": "#96671A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M288.4 287.3v-9.47h5.25v.52h-4.7v4.04h4.17v.52h-4.16v4.37h-.56zm6.46-4.73c0-.67.13-1.3.38-1.88.26-.6.6-1.1 1.03-1.55.44-.44.95-.8 1.53-1.04.58-.25 1.2-.37 1.88-.37.67 0 1.3.12 1.9.38.57.26 1.1.6 1.53 1.05.45.44.8.95 1.05 1.54.26.57.4 1.2.4 1.87 0 .67-.14 1.3-.4 1.88-.25.58-.6 1.1-1.04 1.53-.43.44-.95.78-1.53 1.04-.6.25-1.22.38-1.9.38-.66 0-1.3-.13-1.87-.38-.58-.26-1.1-.6-1.53-1.04-.43-.44-.77-.95-1.03-1.53-.25-.6-.38-1.2-.38-1.88zm.55 0c0 .6.12 1.16.35 1.68.22.52.52.97.9 1.36.4.4.85.7 1.36.94.53.22 1.08.34 1.67.34.58 0 1.14-.12 1.67-.34.52-.23.98-.54 1.38-.93.4-.38.7-.83.93-1.35.22-.52.34-1.08.34-1.68 0-.6-.13-1.15-.35-1.67-.23-.53-.54-1-.93-1.37-.4-.4-.84-.7-1.36-.93-.52-.23-1.08-.34-1.67-.34-.6 0-1.15.1-1.67.34-.52.23-.98.54-1.37.93-.4.4-.7.85-.9 1.37-.24.52-.35 1.08-.35 1.68zm11.34 4.72v-9.47h2.1c.33 0 .67.05 1 .15.36.1.67.25.95.46.27.2.5.48.68.82.18.33.27.74.27 1.2 0 .53-.13 1.03-.4 1.5-.25.47-.67.82-1.24 1.05.08.1.18.28.32.5l.48.8c.18.3.37.6.56.94l.56.9.45.75.25.4h-.67l-.22-.37c-.1-.2-.24-.4-.4-.67l-.5-.84c-.2-.3-.37-.6-.54-.87-.2-.3-.35-.55-.5-.8l-.35-.58-.38.05-.4.02h-1.47v4.05h-.56zm.56-4.6h1.48c.47 0 .86-.08 1.17-.23.32-.16.56-.35.75-.58.18-.25.3-.5.38-.76.07-.26.1-.5.1-.7 0-.3-.05-.56-.16-.8-.1-.26-.28-.48-.48-.67-.2-.2-.47-.34-.76-.45-.3-.1-.63-.17-1-.17h-1.48v4.35zm10.64-5.3l1.1 1.62 1.2 1.72 1.17 1.67c.4.55.73 1.04 1.03 1.47l.46-.66c.2-.27.4-.6.67-.97l.82-1.2.88-1.27.87-1.25.8-1.1v9.9h-.58v-7.73-.27-.26c-.3.42-.63.9-1 1.4l-1.04 1.56-1.02 1.52c-.3.5-.6.93-.87 1.3l-.6-.8-.74-1.08-.82-1.18-.77-1.14-.63-.96-.4-.62v.26l.02.27v7.72h-.56v-9.9zm11.97 9.9v-9.47h5.8v.5h-5.23v3.94h4.7v.5h-4.7v4h5.42v.52h-6zm16.08-9.47v9.9c-.5-.64-1.08-1.34-1.7-2.08-.65-.75-1.3-1.52-1.93-2.3l-1.88-2.27c-.6-.75-1.14-1.43-1.6-2.04l-.26-.35.05.42v8.17h-.56v-9.9c.5.64 1.07 1.34 1.7 2.1.6.74 1.24 1.5 1.9 2.27l1.87 2.26 1.65 2.04.25.35-.04-.43v-8.17h.55z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#EAFDFF",
      "d": "M39 100.66h148.84v198.67H39z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#A0E7D8",
      "d": "M39 193.36c21.54 12.14 46.35 21 74.42 26.57 28.07 5.58 52.87 6.13 74.42 1.66v64.63H39v-92.87z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7DD4C1",
      "d": "M39 203.32c23.95 9.85 48.76 16.5 74.42 19.94 25.66 3.43 50.46 3.54 74.42.33v75.74H39v-96.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E3D0B0",
      "d": "M174.82 202.9c6.37 29.2-16.66 85.73-20.87 96.44H130.7l2.2-72.5c24.9-14.66 38.87-22.63 41.92-23.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A3421",
      "d": "M113.42 100.66h74.42c-8.2 49.46-16.1 80.76-23.66 93.9-11.57 4.2-57.4.55-82.5-4.9 8.5-11.45 13.64-21.85 18.75-35.94-7.03 12.4-16.77 24.86-25.22 34.35-2.82-.86-6.75-2.18-8.64-3.37 23.06-23.8 38.65-44.84 46.86-84.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E3D0B0",
      "d": "M114.75 100.66c.36 8.05-1.33 23.83-1.33 28.22-11.17 10.52-43.1 42.82-49.06 42.9-5.96.08-21-11.24-25.36-15.8V139.2c9.46 5.96 17.92 9.97 25.36 12 17.85-18.58 31.6-40.9 41.75-50.54h8.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#EFDBBC",
      "d": "M112.25 100.48c-6.6 9.8-14.18 20.56-16 24.8-1.8 4.25 2.78 18.22 9.4 22.16 4.4 2.63 7.87 9.75 10.42 21.36-17.58 8.8-28.13 17.24-31.64 25.28-10.92 25 14.1 79.25 21.02 105.26 6.95 0 16.25.1 27.9.27 1.8-37.76 1.98-60.65.5-68.66 2.87-6.05 26.97-24.43 39.36-30.88-5.47-9.92-18.23-21.04-17.13-25.75 1.3-5.5 27.74-37.42 31.77-41.08v-32.56l-75.6-.18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E3D0B0",
      "d": "M127.5 114.96c4.58 7.16 2.74 22.24.38 27.64.2 0-20.16 6.38-19.15 7.6.63.76 1.52 2.24 2 2.95 2.2-.12 5.92-1.14 9.94-2.4-.95 1.5-1.2 2.68-1.86 3.9 3.68-.8 8.8-4.43 10.88-8.06 1.9 4.4 5.98 9.2 12.13 9.48-.06-.4-.72-1.83-1.05-3.3 4.07 3.42 15.26 5.2 22.92 4.1.4-.07-12.5 8.95-11.54 20.06.72 8.36 8.43 17.12 7 24.9 1.38.7 12.38-1.96 13.83-1.84-.65-2.64-16.52-21.8-17.02-25.28.76-4.28 15.33-21.17 18.36-25.52-1.84-.37-42.98-6.6-42.73-6.6-.55-13.12 6.8-23.32 13.14-27.64-3.45-.03-7.72 4.2-9.98 3.98-3.44-.34-5.24-3.98-7.23-3.98z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E3D0B0",
      "d": "M181 132.6c2.05-4 3.73-8.86 6.84-9.34v10.63c-3.6 1.72-5.9 1.3-6.85-1.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E564AD",
      "d": "M159.13 116.96c-13.83-.13-21.93 10.2-28.8 22.3-3.85-15.37-16.74-24.66-23.92-26.98.43-.66 4.88-8.54 7.02-11.62h-1.7c-4.55 5.07-14.35 22.08-15.47 24.8-1.73 4.27-6.62 19 11.4 24.5 4.73 1.43 15.83-2.33 22.68-6.6 7.4 6.6 11.7 10.5 28.05 10.87 6.87.16 12.5-1.78 16.84-5.8l12.62-14.62c-2.24 1.1-3.97 1.38-5.18.83-1.13-.5-8.13-9.1-9.76-12.16-1.63-3.06.7-16.17 4.7-21.8h-3.06c-3.2 5.15-4.78 13.56-4.78 19.46-2.94-1.85-6.46-3.13-10.63-3.17z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#EB81BC",
      "d": "M132.8 138.97c4.56 0 8.57 2.9 9.48 6.82.9 3.92-.76 4.7 2.36 9.08-3.47 0-8.7-1.1-10.04-3.96-1.35-2.87-1.34-6.4-2.2-6.4-.86 0-4.53-.2-5-.2-1.14.4.7 2.43-2.1 4.93-2.8 2.5-5.35 3.7-7.86 3.97 2.7-3.82 1.63-7.27 2.28-9.53.65-2.28 2.64-6.14 7.68-4.73.4.25 4.62 0 5.4 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E564AD",
      "d": "M131.05 141.54c1.9-2.67 7.17 0 6.48 4.18-1.78-2.16-4.54-3.8-6.48-3.42-.55 0-3.67.28-3.97.28-.73 2.15-3.26 1.23-5.17 4.8-.04-3.32 1.96-6.74 5.18-5.84.25.16 3.48 0 3.97 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FA92CC",
      "d": "M132.74 138.94c-.8-.82-4.04-1.32-5.03-.35-.97.96-1.06 4.88-.27 5.9.8 1 4.63.8 5.06 0-1.38-.85-1.66-4.56.24-5.56z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E564AD",
      "d": "M82.24 202.1c8.7-11.2 43.37-.82 51.54 28.88 6.2 0 27.44-23.8 41.28-26.8-.4-1.14-.88-2.82-1.88-4.18-31.7 5.42-53.5 0-84.28-12.54-2.78 1.84-6.6 9.85-6.66 14.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E3D0B0",
      "d": "M128.55 188.18c.94.25 1.52-.94 1.88-2.3.3-1.14 2.23-10.2 2.42-13.18.2-2.96-1.34-16.8-2.17-16.67-.83.14 1.24 10.5.44 17.15-.65 5.4-2.8 11.78-2.96 12.52-.4 1.67-.54 2.23.4 2.48z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#C5AC82",
      "d": "M129.02 187c.36.1.57-.33.63-.78.06-.45.7-2.5.36-2.58-.35-.1-1.2 1.63-1.4 2.34-.18.7.07.92.42 1.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M49.75 231.02h-.06l-1.5 7.7h3.05l-1.5-7.7zm-1.28-6.13H51l4.76 21.28H52.7l-.9-4.58h-4.14l-.9 4.58H43.7l4.77-21.3zm11.84 9.5h1.74c.54 0 .97-.08 1.3-.23.3-.15.55-.36.72-.64.17-.28.28-.62.34-1.03.06-.4.1-.88.1-1.42 0-.54-.04-1-.1-1.42-.06-.4-.18-.76-.37-1.05-.2-.28-.46-.5-.8-.63-.33-.14-.78-.2-1.34-.2h-1.6v6.63zm-3.04-9.5h4.9c3.6 0 5.38 2.07 5.38 6.24 0 1.24-.2 2.3-.58 3.18-.4.9-1.07 1.6-2.05 2.14l3.3 9.72h-3.23l-2.84-9.1H60.3v9.1h-3.04v-21.3zm12.73 0h9.08v2.86h-6.04V234h5.27v2.88h-5.26v6.25h6.04v3.05h-9.1v-21.3zm19.46 12.28l-4.2-12.3h3.24l2.45 8.47H91l2.47-8.46h3.22l-4.2 12.28v9h-3.04v-9zm8.58-7.27c0-.84.15-1.6.45-2.26.3-.66.68-1.2 1.17-1.63.5-.42 1.04-.74 1.64-.96.62-.22 1.23-.33 1.85-.33.62 0 1.23.12 1.84.34.6.22 1.15.54 1.64.97.48.44.88.98 1.18 1.64.3.66.45 1.42.45 2.27v11.26c0 .87-.15 1.64-.45 2.28-.3.65-.7 1.2-1.18 1.62-.5.43-1.04.75-1.65.97-.62.22-1.23.33-1.85.33-.62 0-1.23-.1-1.84-.33-.6-.22-1.14-.54-1.63-.97-.5-.43-.88-.97-1.18-1.62-.3-.64-.46-1.4-.46-2.28V229.9zm3.05 11.26c0 .73.2 1.28.6 1.63.4.33.9.5 1.45.5.56 0 1.04-.17 1.45-.5.4-.36.62-.9.62-1.64V229.9c0-.72-.2-1.27-.62-1.62-.4-.34-.9-.52-1.45-.52-.56 0-1.04.18-1.45.52-.4.35-.6.9-.6 1.63v11.26zm19.72.24c0 .7-.13 1.34-.38 1.94-.26.6-.62 1.12-1.07 1.57-.44.46-.97.8-1.57 1.07-.6.26-1.23.4-1.9.4-.7 0-1.33-.14-1.92-.4-.6-.26-1.12-.6-1.57-1.06-.44-.44-.8-.96-1.05-1.56-.26-.6-.4-1.25-.4-1.94v-16.5h3.06v16.2c0 .75.2 1.3.54 1.67.36.36.8.54 1.35.54.53 0 .98-.17 1.34-.53.35-.36.53-.92.53-1.67v-16.2h3.05v16.5zm-75.73 7.4h4.44c.98 0 1.8.16 2.5.46.7.3 1.25.7 1.7 1.2.43.5.74 1.07.93 1.7.2.66.28 1.34.28 2.03v.77c0 .58-.04 1.07-.13 1.47-.1.4-.23.74-.4 1.04-.18.3-.4.56-.66.8-.26.22-.56.44-.9.64.72.34 1.25.84 1.6 1.5.32.67.5 1.57.5 2.68v1.2c0 1.87-.46 3.3-1.37 4.3-.9 1-2.36 1.5-4.36 1.5H45.1v-21.3zm3.04 18.25h1.3c.63 0 1.1-.1 1.46-.27.35-.18.6-.43.8-.75.17-.32.28-.7.32-1.13.04-.44.06-.92.06-1.44 0-.54-.03-1-.1-1.4-.05-.4-.17-.74-.36-1-.2-.27-.45-.48-.8-.62-.33-.14-.78-.2-1.34-.2h-1.34v6.8zm0-9.5h1.37c1.03 0 1.7-.26 2.06-.77.35-.5.52-1.25.52-2.23 0-.96-.2-1.67-.58-2.15-.4-.48-1.1-.72-2.1-.72h-1.26v5.86zm9.68-8.74h9.1v2.88h-6.05v6.25h5.27v2.87h-5.27v6.25h6.04v3.05h-9.08v-21.3zm15.73 6.14h-.06l-1.5 7.7h3.05l-1.5-7.7zm-1.28-6.13h2.54l4.76 21.3H76.5l-.9-4.58h-4.14l-.9 4.58H67.5l4.77-21.3zm18.47 16.55c0 .65-.12 1.28-.37 1.88-.25.6-.6 1.12-1.03 1.57-.44.45-.95.8-1.54 1.08-.6.26-1.22.4-1.9.4-.58 0-1.17-.08-1.76-.24-.6-.16-1.14-.43-1.62-.82-.48-.4-.87-.9-1.18-1.54-.3-.64-.46-1.45-.46-2.42v-11.73c0-.7.12-1.34.36-1.94.24-.6.57-1.12 1-1.56.45-.44.97-.8 1.58-1.04.6-.24 1.28-.37 2.02-.37.7 0 1.35.13 1.94.37.6.25 1.12.6 1.56 1.05.44.45.78 1 1.03 1.62.25.62.37 1.3.37 2.04v1.2H87.7v-1c0-.6-.18-1.12-.5-1.56-.35-.44-.8-.66-1.4-.66-.75 0-1.25.24-1.5.7-.25.47-.37 1.07-.37 1.78v10.9c0 .6.13 1.12.4 1.54.27.42.75.63 1.45.63.2 0 .4-.04.64-.1.23-.08.44-.2.63-.35.2-.16.35-.38.46-.66.13-.28.2-.62.2-1.04v-1.05h3.04v1.32zm2.5-16.54h3.04v9.13h3.76v-9.12h3.05v21.3h-3.06v-9.48h-3.76v9.48h-3.05v-21.3zm18.28 0h4.46c.98 0 1.8.16 2.5.46.68.3 1.25.7 1.7 1.2.42.5.74 1.07.93 1.7.2.66.3 1.34.3 2.03v.77c0 .58-.05 1.07-.14 1.47-.1.4-.23.74-.4 1.04-.2.3-.4.56-.66.8-.26.22-.56.44-.9.64.72.34 1.24.84 1.58 1.5.34.67.5 1.57.5 2.68v1.2c0 1.87-.44 3.3-1.35 4.3-.9 1-2.36 1.5-4.35 1.5h-4.16v-21.3zm3.05 18.25h1.32c.6 0 1.1-.1 1.44-.27.35-.18.6-.43.8-.75.17-.32.28-.7.32-1.13.04-.44.06-.92.06-1.44 0-.54-.03-1-.1-1.4-.05-.4-.17-.74-.36-1-.2-.27-.46-.48-.8-.62-.33-.14-.78-.2-1.34-.2h-1.35v6.8zm0-9.5h1.38c1.02 0 1.7-.26 2.05-.77.35-.5.52-1.25.52-2.23 0-.96-.2-1.67-.58-2.15-.4-.48-1.1-.72-2.1-.72h-1.27v5.86zm9.5-3.72c0-.85.16-1.6.46-2.27.3-.66.7-1.2 1.18-1.63.5-.43 1.05-.75 1.66-.97.6-.22 1.22-.33 1.84-.33.6 0 1.23.1 1.83.33.6.22 1.16.54 1.65.97.5.43.88.97 1.18 1.63.3.66.45 1.42.45 2.27v11.25c0 .87-.14 1.64-.44 2.28-.3.65-.7 1.2-1.18 1.62-.5.43-1.04.75-1.65.97-.6.22-1.22.33-1.83.33-.62 0-1.23-.1-1.84-.33-.6-.22-1.16-.54-1.65-.97-.48-.43-.87-.97-1.17-1.62-.3-.64-.45-1.4-.45-2.28v-11.25zm3.06 11.25c0 .73.2 1.28.62 1.63.4.35.9.53 1.45.53.55 0 1.04-.18 1.45-.52.4-.34.6-.9.6-1.62v-11.25c0-.73-.2-1.28-.6-1.63-.4-.34-.9-.52-1.45-.52-.56 0-1.05.18-1.45.52-.4.35-.62.9-.62 1.63v11.25zM137 248.8h4.5c1.75 0 3.07.5 4 1.46.9.97 1.37 2.32 1.37 4.05v9.97c0 2-.5 3.46-1.45 4.4-.97.96-2.36 1.43-4.17 1.43H137v-21.3zm3.05 18.43h1.4c.86 0 1.47-.22 1.83-.64.36-.44.54-1.1.54-2.03V254.3c0-.82-.17-1.47-.5-1.93-.35-.46-.97-.7-1.86-.7h-1.4v15.56zm12-6.13l-4.2-12.3h3.23l2.45 8.47h.06l2.45-8.46h3.23l-4.2 12.3v9h-3.04v-9zm-103.9 21.14h1.72c.54 0 .97-.08 1.3-.23.3-.13.55-.35.72-.63.16-.28.27-.62.33-1.03.06-.4.1-.88.1-1.42 0-.54-.04-1-.1-1.42-.06-.4-.18-.76-.37-1.05-.2-.3-.45-.5-.8-.64-.33-.13-.78-.2-1.34-.2h-1.58v6.64zm-3.06-9.5H50c3.58 0 5.37 2.07 5.37 6.24 0 1.24-.2 2.3-.58 3.18-.4.9-1.08 1.6-2.06 2.14l3.3 9.72H52.8l-2.84-9.1h-1.82v9.1H45.1v-21.3zm12.72 0h9.1v2.86h-6.05v6.25h5.27v2.87h-5.27v6.25h6.04v3.05h-9.08v-21.3zm15.73 6.12h-.06l-1.5 7.7h3.05l-1.5-7.7zm-1.28-6.13h2.54l4.76 21.3H76.5l-.9-4.58h-4.14l-.9 4.57H67.5l4.77-21.3zm8.8 0h4.5c1.74 0 3.06.48 3.98 1.45.92.97 1.37 2.32 1.37 4.05v9.96c0 1.98-.48 3.45-1.45 4.4-.96.95-2.35 1.42-4.17 1.42h-4.24v-21.3zm3.04 18.42h1.4c.87 0 1.48-.2 1.84-.64.35-.42.53-1.1.53-2v-10.27c0-.83-.17-1.48-.5-1.94-.34-.47-.96-.7-1.86-.7h-1.4v15.55zm12-6.13l-4.2-12.3h3.24l2.45 8.47h.05l2.45-8.47h3.23l-4.18 12.3v9H96.1v-9zm8.28-7.92c0-.62.12-1.2.36-1.77.24-.56.57-1.04.98-1.45.42-.4.9-.73 1.47-.97.55-.23 1.15-.35 1.78-.35.74 0 1.4.15 2.02.45.6.3 1.1.72 1.5 1.26.2.27.38.53.5.77.13.24.24.5.32.77.08.26.13.57.16.9.03.35.05.75.05 1.2 0 .52 0 .96-.02 1.3 0 .35-.02.66-.06.92-.04.26-.1.48-.15.67-.07.18-.15.35-.25.5l-2.06 3.54c-.15.24-.27.48-.37.73-.1.25-.15.52-.15.8v2.4h-3.05v-2.8c0-.43.07-.85.2-1.25.15-.4.33-.8.55-1.17l1.9-3.1c.17-.26.27-.54.32-.84.05-.3.08-.6.08-.9v-1.57c0-.42-.15-.78-.44-1.08-.28-.3-.64-.45-1.06-.45-.36 0-.7.13-1.04.4-.34.25-.5.63-.5 1.13v1.73h-3.06v-1.76zm3.05 13.87h3.05v3.05h-3.05v-3.05z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "span_6_xs right_panel"
  }, [_c('div', {
    staticClass: "right_panel_content"
  }, [_c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Please see your teacher. She/he will lead a discussion that will analyze messages you receive about men, women,\n                self, culture and relationships through media/marketing.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.modal_close
    }
  }, [_vm._v("proceed")])])])]) : (_vm.selected_pin == 'texter') ? _c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "span_6_xs left_panel"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "400",
      "height": "400",
      "viewBox": "0 0 400 400"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(167 97)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#DBBFAF",
      "d": "M7.7 105.8c-.3 1.34-1.33 1.9-2.52 3.3-1.38 1.62-1.95 4.95-3.64 7.5.18.72 2.34-.08 2.96-1.12.63-1.04 1.1-1.9 1.3-2.15.2-.25.53-.16.57.13.05.3-1.73 10.1-1.62 10.63.1.5 1.27.78 1.58.33.3-.46 1.9-8.18 2.03-8.36.14-.2.38-.04.46.1.1.13-1.82 8.33-1.7 8.67.1.35 1.3.55 1.5.33.18-.23 1.94-8.44 2.1-8.6.18-.15.44-.07.5.12.1.17-1.86 8.02-1.75 8.4.12.4 1.28.64 1.46.32.18-.32 2.1-8.23 2.22-8.32.14-.1.3-.05.38.08.08.13-1.05 6.1-.93 6.46.12.36.98.63 1.2.26.2-.37 2.62-15 2.8-15.8.63-2.67-.3-5.8-3.37-6.45-3.07-.67-4.9 1.27-5.53 4.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#68047D",
      "d": "M17.96 78.68c2.5.54 4.08 3.05 3.55 5.6l-4.85 23.2-9.03-1.95 4.85-23.2c.54-2.55 3-4.2 5.5-3.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#83069D",
      "d": "M8.26 98.25L20 100.78l-2.36 6.77-9.93-2.15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#68047D",
      "d": "M17.2 48.22c2.56 0 4.63 2.13 4.64 4.75l.1 29.85c0 2.6-2.06 4.73-4.6 4.72-2.56 0-4.64-2.13-4.65-4.75l-.1-29.86c0-2.62 2.05-4.73 4.6-4.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#363636",
      "d": "M22.68 182.1c-.46-.78-3.92 2.2-4.18 2.86-.25.68.1 6.08-3.03 9.14-3.13 3.05-6.14 3.56-7.4 4.04.32 1 3.14 1.46 4.97 1.9 10.42-3.4 10.1-17.16 9.64-17.94z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A4A4A",
      "d": "M22.15 182.08c1.03-1.74 3.68-.4 5.14.65-.22 2 .3 19.34 0 22.57H3.86c-.18-1.45-1.13-6.2 4.88-7.97.62.5 1.3 1.02 3.46 1.78 9.6-3.53 8.92-15.27 9.95-17.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M11.45 203.76h16.7v2.06H3.1c-.14-1.18-.7-5.2 4-7.08 1.28-.4 4.2 2.1 4.37 5.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M16.57 197.83c-.4-.7-3.1-1.9-4.08-2.03-.42-.06-.84.3-.78.72 1.23.24 3.58 1.43 4 1.9.4.47 1.27.12.85-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19.48 194.92c-.4-.7-3.1-1.9-4.08-2.03-.4-.07-.83.28-.77.7 1.23.25 3.58 1.44 4 1.9.4.48 1.27.13.85-.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M21.4 192.74c-.43-.7-3.1-1.9-4.1-2.04-.4-.06-.54.42-.48.85 1.23.24 3.3 1.3 3.7 1.78.4.47 1.3.12.87-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A4A4A",
      "d": "M21.55 139.04c3.83 0 6.93 3.1 6.93 6.93v42.36H14.62v-42.36c0-3.82 3.1-6.93 6.93-6.93z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "13.86",
      "height": "62.09",
      "x": "14.62",
      "y": "91.03",
      "fill": "#4A4A4A",
      "rx": "6.93"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#363636",
      "d": "M42.3 182.1c-.46-.78-3.92 2.2-4.17 2.86-.26.68.08 6.08-3.04 9.14-3.13 3.05-6.13 3.55-7.38 4.03.3 1 3.1 1.47 4.94 1.9 10.43-3.4 10.1-17.15 9.65-17.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A4A4A",
      "d": "M41.8 182.08c1.02-1.74 3.67-.4 5.13.65-.2 2 .3 19.34 0 22.57H23.5c-.16-1.45-1.1-6.2 4.9-7.97.6.5 1.28 1.02 3.45 1.78 9.6-3.53 8.92-15.27 9.95-17.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M30.37 203.76h16.7v2.06H22c-.15-1.18-.7-5.2 4-7.08 1.28-.4 4.2 2.1 4.37 5.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M35.5 197.83c-.43-.7-3.1-1.9-4.1-2.03-.4-.06-.83.3-.77.72 1.24.24 3.6 1.43 4 1.9.4.47 1.28.12.86-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M39.13 194.92c-.42-.7-3.1-1.9-4.1-2.03-.4-.07-.82.28-.76.7 1.23.25 3.6 1.44 4 1.9.4.48 1.27.13.86-.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M40.3 192.74c.42.7-.45 1.06-.86.6-.4-.5-2.47-1.55-3.7-1.8-.07-.42.07-.9.48-.84.98.15 3.67 1.34 4.08 2.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A4A4A",
      "d": "M43.38 139.04c3.82 0 6.92 3.1 6.92 6.93v42.36H36.45v-42.36c0-3.82 3.1-6.93 6.93-6.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A4A4A",
      "d": "M43.38 91.03c3.82 0 6.92 3.1 6.92 6.92v48.23c0 3.83-3.1 6.93-6.92 6.93-3.83 0-6.93-3.1-6.93-6.92V97.95c0-3.82 3.1-6.92 6.93-6.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4A4A4A",
      "d": "M14.62 85.93H50.2v8.3c0 9.8-7.97 17.77-17.8 17.77-9.82 0-17.78-7.96-17.78-17.78v-8.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#595959",
      "d": "M28.44 85.93h4.62v18.96c-4.33-4.1-4.62-8.4-4.62-18.97z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F9F8F2",
      "d": "M31.96 45.2c2.95 0 11.7.55 14.13 1.33V87.4c-4.07 1.26-26.08.74-30.75 0 .53-3.9 1.78-28.55 2.9-40.18 3.2-1.82 10.76-2.03 13.7-2.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4C025C",
      "d": "M31.9 45.2c2.94 0 13.37.64 14.87 1.65 1 .67 1.73 17.08 2.2 49.22H36.13V46.85c-5.75-.22-8.67-.33-8.76-.32-.08 0-.08 16.53 0 49.54H13.9c.93-31.1 2.36-47.4 4.3-48.85 2.88-2.2 10.74-2.03 13.7-2.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#68047D",
      "d": "M30.72 43.74c8.96.12 9.9 2.33 9.9 5.28-.02 2.95-.04 5.77-.94 5.82-.9.05-1.78-2.42-4.05-1.08.13-.9.13-3.2 0-6.87H26.7v6.86c-2.07-1.66-4.8 1.17-4.8 1.08v-5.82c0-2.26-.14-5.4 8.82-5.28z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "16.63",
      "height": "10.9",
      "x": "17.37",
      "y": "57.35",
      "fill": "#000",
      "transform": "rotate(103 25.687 62.8)",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DBBFAF",
      "d": "M36.55 67.48c-1.2-.65-1.46-1.8-2.48-3.34-.6-.92-1.7-1.76-2.9-2.67l-1.2 2.25c.2.26-.13.38-.42.35-.3-.04-9.64-4.7-10.17-4.74-.53-.04-1.1 1-.76 1.42.35.42 7.75 4.32 7.9 4.5.13.2-.08.38-.23.42-.16.05-7.93-4.3-8.3-4.3-.35.02-.88 1.13-.7 1.37.15.24 7.97 4.45 8.07 4.65.1.2-.04.43-.24.45-.2.02-7.62-4.27-8.02-4.26-.38 0-.95 1.04-.7 1.3.27.27 7.76 4.52 7.8 4.68.06.16-.02.3-.17.34-.15.04-5.57-2.7-5.95-2.7-.38.02-.87.78-.57 1.1.3.3 13.68 6.7 14.4 7.1 2.4 1.33 5.65 1.3 7.12-1.47 1.47-2.76.12-5.07-2.47-6.47z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#68047D",
      "d": "M58.84 84.7c-1.2 2.26-4 3.12-6.25 1.92L31.55 75.44l4.34-8.16 21.03 11.18c2.25 1.2 3.1 4 1.9 6.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#83069D",
      "d": "M41.78 68.76l-5.64 10.6-5.85-4.15 4.76-8.96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "9.24",
      "height": "39.34",
      "x": "46.34",
      "y": "46.65",
      "fill": "#68047D",
      "transform": "rotate(-14 50.964 66.316)",
      "rx": "4.62"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D4B5A7",
      "d": "M27.85 40.85c.38 2.5.47 4.47-.13 5.6 0 .92-.14 3.7 2.8 3.67 2.9-.02 4.56-2.2 5.04-3.66-.75-1.5-.66-2.9-.25-5.6-.7-2.02-6.44-1.95-7.45 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#DBBFAF",
      "fill-rule": "nonzero",
      "d": "M48.38 23.76c1-.6 2.4-1.34 4 0 1.36 1.15.33 5.66-1.5 8.16-1.84 2.48-4.8 3-5.98 2.04-2.46 5.7-8.73 8.7-12.92 8.67-11.22-.1-15.9-11.74-15.9-21.42C16.08 5.96 22.02.8 31.98.8c8.94-.04 18.86 4.8 16.4 22.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D4B5A7",
      "d": "M47.63 28c.9-1.9 2.28-3.68 3.97-3.05 1.7.63-.47 7.66-4.97 7.65.52-.33 1.94-1.86 2-3.06.04-1.2-.34-1.8-1-1.53z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "39.43",
      "cy": "32.25",
      "fill": "#DBB7A6",
      "rx": "2.98",
      "ry": "3.06"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "22.7",
      "cy": "32.25",
      "fill": "#DBB7A6",
      "rx": "2.98",
      "ry": "3.06"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#C9A89D",
      "fill-rule": "nonzero",
      "d": "M27 36.52c.77.2 5.14.25 6.6-.05.78-.15-.97 1.35-3.9 1.35-2.9 0-2.7-1.3-2.7-1.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#BD9B90",
      "fill-rule": "nonzero",
      "d": "M26.26 36.93c0-.65.5-1.2 3-1.2 1.76 0 4.58.9 6 .5.28-.1.28.15-.1.3-1.8.65-3.55.65-6.23.65-1.75-.05-2.67-.25-2.67-.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#C9A89D",
      "d": "M28.2 24.14c0-1 2.48-1.07 2.48 0s.8 6.66 0 7.65c-.8.98-3.12.65-3.48 0-.36-.67-.3-1.75.5-2.05.77-.3.5-4.63.5-5.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M34.26 25.78c1.3-3.68 7.1-4.25 7.96-1.06 0 4.3-7 4.7-7.96 1.06z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "38.33",
      "cy": "26.97",
      "fill": "#322316",
      "rx": "1.99",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D4B5A7",
      "d": "M34.26 25.78c1.3-3.68 7.1-4.25 7.96-1.06 0 4.3-7 4.7-7.96 1.06z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M26.94 25.78c-1.3-3.68-7.08-4.25-7.95-1.06-.02 4.3 7 4.7 7.94 1.06z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "23.05",
      "cy": "26.97",
      "fill": "#322316",
      "rx": "1.99",
      "ry": "2.04"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#D4B5A7",
      "d": "M26.94 25.78c-1.3-3.68-7.08-4.25-7.95-1.06-.02 4.3 7 4.7 7.94 1.06z",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#322316",
      "d": "M34.77 20.9c1-.55 6.23-.64 7.38 0 1.15.65.3 1.3-.5 1.04-.8-.25-5.54-.3-6.4 0-.84.3-1.47-.48-.48-1.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#322316",
      "d": "M26.2 20.9c-1-.55-6.23-.64-7.38 0-1.15.65-.3 1.3.5 1.04.8-.25 5.54-.3 6.4 0 .84.3 1.48-.48.48-1.03z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#322316",
      "d": "M16.04 11.42c-2.56 4.82-3.22 16-2.72 20.53.5 4.52 6.14 10.77 10.8 10.77-.43-4.08-4.82-39.35 14.6-33.1 10.55 3.4 8.88 14.78 9.12 14.86.82-1.74 2.72-1.84 3.45-1.74.06-9.5 0-22.68-17.3-22.65C22.14.1 18.6 6.6 16.03 11.4z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "span_6_xs right_panel"
  }, [_c('div', {
    staticClass: "right_panel_content"
  }, [_c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Please see your teacher. She/he will lead a discussion that will analyze messages you receive about men, women,\n                self, culture and relationships through social media/the internet.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.modal_close
    }
  }, [_vm._v("proceed")])])])]) : _c('div', {
    staticClass: "row flush final_modal align_center"
  }, [_c('div', {
    staticClass: "span_8_xs offset_2_xs"
  }, [_c('p', {
    staticClass: "modal_text"
  }, [_vm._v("We all get overwhelmed from time to time. Your teacher has a mindfulness activity for you to practice as a class.\n              Next time you begin to shut down or feel overwhelmed, take 5 minutes and try this activity on your own!")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.modal_close
    }
  }, [_vm._v("proceed")])])])])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "active": _vm.modalActive,
      "text": _vm.modalText,
      "ind": _vm.modalInd,
      "modalStyle": _vm.modalStyle
    },
    on: {
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fa958c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/module_2/module_2.html
// module id = 679
// module chunks = 1